import { jsx as p, Fragment as Qe, jsxs as V } from "react/jsx-runtime";
import * as c from "react";
import N, { createContext as Pn, useContext as An, useState as Ee, useCallback as Vt, useMemo as Ut, useLayoutEffect as ki, useEffect as be, useRef as Bt, forwardRef as re, useReducer as Li } from "react";
import * as Et from "react-dom";
import zr, { createPortal as Hr } from "react-dom";
const Fi = Pn(null), Wi = () => {
  const e = An(Fi);
  if (!e)
    throw new Error("ActionSheet 컴포넌트는 ActionSheet Provider 내부에서 사용되어야 합니다.");
  return e;
};
function Bi(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (n = Bi(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Vi() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
    (e = arguments[n]) && (t = Bi(e)) && (r && (r += " "), r += t);
  return r;
}
const jr = "-", Dl = (e) => {
  const t = Ml(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const a = s.split(jr);
      return a[0] === "" && a.length !== 1 && a.shift(), Ui(a, t) || Ol(s);
    },
    getConflictingClassGroupIds: (s, a) => {
      const u = n[s] || [];
      return a && r[s] ? [...u, ...r[s]] : u;
    }
  };
}, Ui = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? Ui(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(jr);
  return (s = t.validators.find(({
    validator: a
  }) => a(i))) == null ? void 0 : s.classGroupId;
}, Fo = /^\[(.+)\]$/, Ol = (e) => {
  if (Fo.test(e)) {
    const t = Fo.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Ml = (e) => {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return _l(Object.entries(e.classGroups), n).forEach(([i, s]) => {
    hr(s, r, i, t);
  }), r;
}, hr = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : Wo(t, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (Il(o)) {
        hr(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([i, s]) => {
      hr(s, Wo(t, i), n, r);
    });
  });
}, Wo = (e, t) => {
  let n = e;
  return t.split(jr).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, Il = (e) => e.isThemeGetter, _l = (e, t) => t ? e.map(([n, r]) => {
  const o = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([s, a]) => [t + s, a])) : i);
  return [n, o];
}) : e, $l = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (i, s) => {
    n.set(i, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let s = n.get(i);
      if (s !== void 0)
        return s;
      if ((s = r.get(i)) !== void 0)
        return o(i, s), s;
    },
    set(i, s) {
      n.has(i) ? n.set(i, s) : o(i, s);
    }
  };
}, zi = "!", kl = (e) => {
  const {
    separator: t,
    experimentalParseClassName: n
  } = e, r = t.length === 1, o = t[0], i = t.length, s = (a) => {
    const u = [];
    let l = 0, d = 0, f;
    for (let h = 0; h < a.length; h++) {
      let y = a[h];
      if (l === 0) {
        if (y === o && (r || a.slice(h, h + i) === t)) {
          u.push(a.slice(d, h)), d = h + i;
          continue;
        }
        if (y === "/") {
          f = h;
          continue;
        }
      }
      y === "[" ? l++ : y === "]" && l--;
    }
    const m = u.length === 0 ? a : a.substring(d), v = m.startsWith(zi), w = v ? m.substring(1) : m, g = f && f > d ? f - d : void 0;
    return {
      modifiers: u,
      hasImportantModifier: v,
      baseClassName: w,
      maybePostfixModifierPosition: g
    };
  };
  return n ? (a) => n({
    className: a,
    parseClassName: s
  }) : s;
}, Ll = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}, Fl = (e) => ({
  cache: $l(e.cacheSize),
  parseClassName: kl(e),
  ...Dl(e)
}), Wl = /\s+/, Bl = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o
  } = t, i = [], s = e.trim().split(Wl);
  let a = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const l = s[u], {
      modifiers: d,
      hasImportantModifier: f,
      baseClassName: m,
      maybePostfixModifierPosition: v
    } = n(l);
    let w = !!v, g = r(w ? m.substring(0, v) : m);
    if (!g) {
      if (!w) {
        a = l + (a.length > 0 ? " " + a : a);
        continue;
      }
      if (g = r(m), !g) {
        a = l + (a.length > 0 ? " " + a : a);
        continue;
      }
      w = !1;
    }
    const h = Ll(d).join(":"), y = f ? h + zi : h, E = y + g;
    if (i.includes(E))
      continue;
    i.push(E);
    const x = o(g, w);
    for (let b = 0; b < x.length; ++b) {
      const S = x[b];
      i.push(y + S);
    }
    a = l + (a.length > 0 ? " " + a : a);
  }
  return a;
};
function Vl() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Hi(t)) && (r && (r += " "), r += n);
  return r;
}
const Hi = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Hi(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Ul(e, ...t) {
  let n, r, o, i = s;
  function s(u) {
    const l = t.reduce((d, f) => f(d), e());
    return n = Fl(l), r = n.cache.get, o = n.cache.set, i = a, a(u);
  }
  function a(u) {
    const l = r(u);
    if (l)
      return l;
    const d = Bl(u, n);
    return o(u, d), d;
  }
  return function() {
    return i(Vl.apply(null, arguments));
  };
}
const Z = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, ji = /^\[(?:([a-z-]+):)?(.+)\]$/i, zl = /^\d+\/\d+$/, Hl = /* @__PURE__ */ new Set(["px", "full", "screen"]), jl = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Kl = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Gl = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Yl = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Xl = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ke = (e) => vt(e) || Hl.has(e) || zl.test(e), He = (e) => Ct(e, "length", ru), vt = (e) => !!e && !Number.isNaN(Number(e)), Un = (e) => Ct(e, "number", vt), _t = (e) => !!e && Number.isInteger(Number(e)), ql = (e) => e.endsWith("%") && vt(e.slice(0, -1)), H = (e) => ji.test(e), je = (e) => jl.test(e), Zl = /* @__PURE__ */ new Set(["length", "size", "percentage"]), Ql = (e) => Ct(e, Zl, Ki), Jl = (e) => Ct(e, "position", Ki), eu = /* @__PURE__ */ new Set(["image", "url"]), tu = (e) => Ct(e, eu, iu), nu = (e) => Ct(e, "", ou), $t = () => !0, Ct = (e, t, n) => {
  const r = ji.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}, ru = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Kl.test(e) && !Gl.test(e)
), Ki = () => !1, ou = (e) => Yl.test(e), iu = (e) => Xl.test(e), au = () => {
  const e = Z("colors"), t = Z("spacing"), n = Z("blur"), r = Z("brightness"), o = Z("borderColor"), i = Z("borderRadius"), s = Z("borderSpacing"), a = Z("borderWidth"), u = Z("contrast"), l = Z("grayscale"), d = Z("hueRotate"), f = Z("invert"), m = Z("gap"), v = Z("gradientColorStops"), w = Z("gradientColorStopPositions"), g = Z("inset"), h = Z("margin"), y = Z("opacity"), E = Z("padding"), x = Z("saturate"), b = Z("scale"), S = Z("sepia"), T = Z("skew"), C = Z("space"), R = Z("translate"), D = () => ["auto", "contain", "none"], I = () => ["auto", "hidden", "clip", "visible", "scroll"], L = () => ["auto", H, t], O = () => [H, t], P = () => ["", ke, He], A = () => ["auto", vt, H], W = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], $ = () => ["solid", "dashed", "dotted", "double", "none"], U = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], _ = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", H], j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [vt, H];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [$t],
      spacing: [ke, He],
      blur: ["none", "", je, H],
      brightness: G(),
      borderColor: [e],
      borderRadius: ["none", "", "full", je, H],
      borderSpacing: O(),
      borderWidth: P(),
      contrast: G(),
      grayscale: M(),
      hueRotate: G(),
      invert: M(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [ql, He],
      inset: L(),
      margin: L(),
      opacity: G(),
      padding: O(),
      saturate: G(),
      scale: G(),
      sepia: M(),
      skew: G(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", H]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [je]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...W(), H]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: I()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": I()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": I()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: D()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": D()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": D()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", _t, H]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: L()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", H]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", _t, H]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [$t]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", _t, H]
        }, H]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": A()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": A()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [$t]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [_t, H]
        }, H]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": A()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": A()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", H]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [m]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [m]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [m]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ..._()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ..._(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [..._(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [E]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [E]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [E]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [E]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [E]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [E]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [E]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [E]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [E]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [C]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [C]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", H, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [H, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [H, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [je]
        }, je]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [H, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [H, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [H, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", je, He]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Un]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [$t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", H]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", vt, Un]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", ke, H]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", H]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", H]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [y]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [y]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...$(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", ke, He]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", ke, H]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", H]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", H]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [y]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...W(), Jl]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Ql]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, tu]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [w]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [w]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [w]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [y]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...$(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [y]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: $()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...$()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ke, H]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [ke, He]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: P()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [y]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [ke, He]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", je, nu]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [$t]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [y]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...U(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": U()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", je, H]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [y]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", H]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: G()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", H]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: G()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", H]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [b]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [b]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [b]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [_t, H]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [T]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [T]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", H]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", H]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", H]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ke, He, Un]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, su = /* @__PURE__ */ Ul(au);
function F(...e) {
  return su(Vi(e));
}
const Gi = N.forwardRef(
  ({ children: e, className: t, disabled: n, onClick: r, ...o }, i) => {
    const { open: s, onOpenChange: a, contentId: u, triggerId: l } = Wi(), d = (f) => {
      n || a(!s), r == null || r(f);
    };
    return /* @__PURE__ */ p(
      "button",
      {
        ref: i,
        id: l,
        type: "button",
        disabled: n,
        "aria-expanded": s,
        "aria-controls": u,
        "aria-haspopup": "dialog",
        className: F(
          // 기본 버튼 스타일
          "inline-flex items-center justify-center rounded-lg px-4 py-2",
          "typography-ui-16m text-gray-900",
          "border border-gray-200 bg-white",
          "transition-colors duration-200",
          // 호버/포커스 상태
          "hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          // 비활성화 상태
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-white",
          t
        ),
        onClick: d,
        ...o,
        children: e
      }
    );
  }
);
Gi.displayName = "ActionSheetTrigger";
const cu = (e = {}) => {
  const { open: t, onOpenChange: n, defaultOpen: r = !1 } = e, o = t !== void 0, [i, s] = Ee(r), a = o ? t : i, u = Vt(
    (l) => {
      o || s(l), n == null || n(l);
    },
    [o, n]
  );
  return {
    open: a,
    onOpenChange: u,
    isControlled: o
  };
}, lu = ({ children: e, ...t }) => {
  const { open: n, onOpenChange: r } = cu(t), o = Ut(() => {
    const a = Math.random().toString(36).substr(2, 9);
    return {
      contentId: `actionsheet-content-${a}`,
      triggerId: `actionsheet-trigger-${a}`
    };
  }, []), i = N.Children.toArray(e).some(
    (a) => N.isValidElement(a) && a.type === Gi
  ), s = Ut(
    () => ({
      open: n,
      onOpenChange: r,
      contentId: o.contentId,
      triggerId: i ? o.triggerId : void 0
    }),
    [n, r, o.contentId, o.triggerId, i]
  );
  return /* @__PURE__ */ p(Fi.Provider, { value: s, children: e });
};
lu.displayName = "ActionSheet";
function Bo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function uu(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Bo(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Bo(e[o], null);
        }
      };
  };
}
var Kr = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), i = o.find(fu);
  if (i) {
    const s = i.props.children, a = o.map((u) => u === i ? c.Children.count(s) > 1 ? c.Children.only(null) : c.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ p(vr, { ...r, ref: t, children: c.isValidElement(s) ? c.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ p(vr, { ...r, ref: t, children: n });
});
Kr.displayName = "Slot";
var vr = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = mu(n);
    return c.cloneElement(n, {
      ...pu(r, n.props),
      // @ts-ignore
      ref: t ? uu(t, o) : o
    });
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
vr.displayName = "SlotClone";
var du = ({ children: e }) => /* @__PURE__ */ p(Qe, { children: e });
function fu(e) {
  return c.isValidElement(e) && e.type === du;
}
function pu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function mu(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Vo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ce(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = Vo(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : Vo(e[o], null);
        }
      };
  };
}
function q(...e) {
  return c.useCallback(Ce(...e), e);
}
function gu(e, t) {
  const n = c.createContext(t), r = (i) => {
    const { children: s, ...a } = i, u = c.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ p(n.Provider, { value: u, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = c.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function We(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = c.createContext(s), u = n.length;
    n = [...n, s];
    const l = (f) => {
      var y;
      const { scope: m, children: v, ...w } = f, g = ((y = m == null ? void 0 : m[e]) == null ? void 0 : y[u]) || a, h = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ p(g.Provider, { value: h, children: v });
    };
    l.displayName = i + "Provider";
    function d(f, m) {
      var g;
      const v = ((g = m == null ? void 0 : m[e]) == null ? void 0 : g[u]) || a, w = c.useContext(v);
      if (w)
        return w;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [l, d];
  }
  const o = () => {
    const i = n.map((s) => c.createContext(s));
    return function(a) {
      const u = (a == null ? void 0 : a[e]) || i;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    };
  };
  return o.scopeName = e, [r, hu(o, ...t)];
}
function hu(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: u, scopeName: l }) => {
        const f = u(i)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function k(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
var De = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, vu = c[" useInsertionEffect ".trim().toString()] || De;
function St({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, s] = yu({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, u = a ? e : o;
  {
    const d = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = d.current;
      f !== a && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = a;
    }, [a, r]);
  }
  const l = c.useCallback(
    (d) => {
      var f;
      if (a) {
        const m = bu(d) ? d(e) : d;
        m !== e && ((f = s.current) == null || f.call(s, m));
      } else
        i(d);
    },
    [a, e, i, s]
  );
  return [u, l];
}
function yu({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = c.useState(e), o = c.useRef(n), i = c.useRef(t);
  return vu(() => {
    i.current = t;
  }, [t]), c.useEffect(() => {
    var s;
    o.current !== n && ((s = i.current) == null || s.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function bu(e) {
  return typeof e == "function";
}
function wu(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Yi(e) {
  const [t, n] = c.useState(void 0);
  return De(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const u = i.borderBoxSize, l = Array.isArray(u) ? u[0] : u;
          s = l.inlineSize, a = l.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({ width: s, height: a });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
function xu(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var Me = (e) => {
  const { present: t, children: n } = e, r = Eu(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), i = q(r.ref, Cu(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: i }) : null;
};
Me.displayName = "Presence";
function Eu(e) {
  const [t, n] = c.useState(), r = c.useRef(null), o = c.useRef(e), i = c.useRef("none"), s = e ? "mounted" : "unmounted", [a, u] = xu(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = an(r.current);
    i.current = a === "mounted" ? l : "none";
  }, [a]), De(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, v = an(l);
      e ? u("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(d && m !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), De(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const g = an(r.current).includes(v.animationName);
        if (v.target === t && g && (u("ANIMATION_END"), !o.current)) {
          const h = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = h);
          });
        }
      }, m = (v) => {
        v.target === t && (i.current = an(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: c.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function an(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Cu(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function Su(e) {
  const t = /* @__PURE__ */ Ru(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Nu);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Ru(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Au(o), a = Pu(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Tu = Symbol("radix.slottable");
function Nu(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Tu;
}
function Pu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Au(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Du = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], oe = Du.reduce((e, t) => {
  const n = /* @__PURE__ */ Su(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Xi(e, t) {
  e && Et.flushSync(() => e.dispatchEvent(t));
}
var Dn = "Checkbox", [Ou, Uy] = We(Dn), [Mu, Iu] = Ou(Dn), qi = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: r,
      checked: o,
      defaultChecked: i,
      required: s,
      disabled: a,
      value: u = "on",
      onCheckedChange: l,
      form: d,
      ...f
    } = e, [m, v] = c.useState(null), w = q(t, (b) => v(b)), g = c.useRef(!1), h = m ? d || !!m.closest("form") : !0, [y, E] = St({
      prop: o,
      defaultProp: i ?? !1,
      onChange: l,
      caller: Dn
    }), x = c.useRef(y);
    return c.useEffect(() => {
      const b = m == null ? void 0 : m.form;
      if (b) {
        const S = () => E(x.current);
        return b.addEventListener("reset", S), () => b.removeEventListener("reset", S);
      }
    }, [m, E]), /* @__PURE__ */ V(Mu, { scope: n, state: y, disabled: a, children: [
      /* @__PURE__ */ p(
        oe.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Xe(y) ? "mixed" : y,
          "aria-required": s,
          "data-state": ea(y),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: u,
          ...f,
          ref: w,
          onKeyDown: k(e.onKeyDown, (b) => {
            b.key === "Enter" && b.preventDefault();
          }),
          onClick: k(e.onClick, (b) => {
            E((S) => Xe(S) ? !0 : !S), h && (g.current = b.isPropagationStopped(), g.current || b.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ p(
        Ji,
        {
          control: m,
          bubbles: !g.current,
          name: r,
          value: u,
          checked: y,
          required: s,
          disabled: a,
          form: d,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Xe(i) ? !1 : i
        }
      )
    ] });
  }
);
qi.displayName = Dn;
var Zi = "CheckboxIndicator", Qi = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: r, ...o } = e, i = Iu(Zi, n);
    return /* @__PURE__ */ p(Me, { present: r || Xe(i.state) || i.state === !0, children: /* @__PURE__ */ p(
      oe.span,
      {
        "data-state": ea(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...o,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
Qi.displayName = Zi;
var _u = "CheckboxBubbleInput", Ji = c.forwardRef(
  ({
    __scopeCheckbox: e,
    control: t,
    checked: n,
    bubbles: r = !0,
    defaultChecked: o,
    ...i
  }, s) => {
    const a = c.useRef(null), u = q(a, s), l = wu(n), d = Yi(t);
    c.useEffect(() => {
      const m = a.current;
      if (!m)
        return;
      const v = window.HTMLInputElement.prototype, g = Object.getOwnPropertyDescriptor(
        v,
        "checked"
      ).set;
      if (l !== n && g) {
        const h = new Event("click", { bubbles: r });
        m.indeterminate = Xe(n), g.call(m, Xe(n) ? !1 : n), m.dispatchEvent(h);
      }
    }, [l, n, r]);
    const f = c.useRef(Xe(n) ? !1 : n);
    return /* @__PURE__ */ p(
      oe.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? f.current,
        ...i,
        tabIndex: -1,
        ref: u,
        style: {
          ...i.style,
          ...d,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Ji.displayName = _u;
function Xe(e) {
  return e === "indeterminate";
}
function ea(e) {
  return Xe(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var $u = qi, ku = Qi;
// @__NO_SIDE_EFFECTS__
function Uo(e) {
  const t = /* @__PURE__ */ Lu(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Wu);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Lu(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Vu(o), a = Bu(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Fu = Symbol("radix.slottable");
function Wu(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Fu;
}
function Bu(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Vu(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ta(e) {
  const t = e + "CollectionProvider", [n, r] = We(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: h, children: y } = g, E = N.useRef(null), x = N.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(o, { scope: h, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", u = /* @__PURE__ */ Uo(a), l = N.forwardRef(
    (g, h) => {
      const { scope: y, children: E } = g, x = i(a, y), b = q(h, x.collectionRef);
      return /* @__PURE__ */ p(u, { ref: b, children: E });
    }
  );
  l.displayName = a;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ Uo(d), v = N.forwardRef(
    (g, h) => {
      const { scope: y, children: E, ...x } = g, b = N.useRef(null), S = q(h, b), T = i(d, y);
      return N.useEffect(() => (T.itemMap.set(b, { ref: b, ...x }), () => void T.itemMap.delete(b))), /* @__PURE__ */ p(m, { [f]: "", ref: S, children: E });
    }
  );
  v.displayName = d;
  function w(g) {
    const h = i(e + "CollectionConsumer", g);
    return N.useCallback(() => {
      const E = h.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${f}]`));
      return Array.from(h.itemMap.values()).sort(
        (T, C) => x.indexOf(T.ref.current) - x.indexOf(C.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    w,
    r
  ];
}
var Uu = c.createContext(void 0);
function na(e) {
  const t = c.useContext(Uu);
  return e || t || "ltr";
}
function ne(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function ra(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var zu = "DismissableLayer", yr = "dismissableLayer.update", Hu = "dismissableLayer.pointerDownOutside", ju = "dismissableLayer.focusOutside", zo, oa = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ia = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(oa), [d, f] = c.useState(null), m = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = q(t, (C) => f(C)), g = Array.from(l.layers), [h] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(h), E = d ? g.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = Yu((C) => {
      const R = C.target, D = [...l.branches].some((I) => I.contains(R));
      !b || D || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m), T = Xu((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m);
    return ra((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, m), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (zo = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), Ho(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = zo);
        };
    }, [d, m, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), Ho());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(yr, C), () => document.removeEventListener(yr, C);
    }, []), /* @__PURE__ */ p(
      oe.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: k(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: k(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: k(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
ia.displayName = zu;
var Ku = "DismissableLayerBranch", Gu = c.forwardRef((e, t) => {
  const n = c.useContext(oa), r = c.useRef(null), o = q(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ p(oe.div, { ...e, ref: o });
});
Gu.displayName = Ku;
function Yu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          aa(
            Hu,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Xu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && aa(ju, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ho() {
  const e = new CustomEvent(yr);
  document.dispatchEvent(e);
}
function aa(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Xi(o, i) : o.dispatchEvent(i);
}
var zn = 0;
function sa() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? jo()), document.body.insertAdjacentElement("beforeend", e[1] ?? jo()), zn++, () => {
      zn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), zn--;
    };
  }, []);
}
function jo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Hn = "focusScope.autoFocusOnMount", jn = "focusScope.autoFocusOnUnmount", Ko = { bubbles: !1, cancelable: !0 }, qu = "FocusScope", ca = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, u] = c.useState(null), l = ne(o), d = ne(i), f = c.useRef(null), m = q(t, (g) => u(g)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (v.paused || !a)
          return;
        const b = x.target;
        a.contains(b) ? f.current = b : Ke(f.current, { select: !0 });
      }, h = function(x) {
        if (v.paused || !a)
          return;
        const b = x.relatedTarget;
        b !== null && (a.contains(b) || Ke(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Ke(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", h);
      const E = new MutationObserver(y);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", h), E.disconnect();
      };
    }
  }, [r, a, v.paused]), c.useEffect(() => {
    if (a) {
      Yo.add(v);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(Hn, Ko);
        a.addEventListener(Hn, l), a.dispatchEvent(y), y.defaultPrevented || (Zu(nd(la(a)), { select: !0 }), document.activeElement === g && Ke(a));
      }
      return () => {
        a.removeEventListener(Hn, l), setTimeout(() => {
          const y = new CustomEvent(jn, Ko);
          a.addEventListener(jn, d), a.dispatchEvent(y), y.defaultPrevented || Ke(g ?? document.body, { select: !0 }), a.removeEventListener(jn, d), Yo.remove(v);
        }, 0);
      };
    }
  }, [a, l, d, v]);
  const w = c.useCallback(
    (g) => {
      if (!n && !r || v.paused)
        return;
      const h = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (h && y) {
        const E = g.currentTarget, [x, b] = Qu(E);
        x && b ? !g.shiftKey && y === b ? (g.preventDefault(), n && Ke(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && Ke(b, { select: !0 })) : y === E && g.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ p(oe.div, { tabIndex: -1, ...s, ref: m, onKeyDown: w });
});
ca.displayName = qu;
function Zu(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ke(r, { select: t }), document.activeElement !== n)
      return;
}
function Qu(e) {
  const t = la(e), n = Go(t, e), r = Go(t.reverse(), e);
  return [n, r];
}
function la(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Go(e, t) {
  for (const n of e)
    if (!Ju(n, { upTo: t }))
      return n;
}
function Ju(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ed(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ke(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ed(e) && t && e.select();
  }
}
var Yo = td();
function td() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Xo(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Xo(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Xo(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function nd(e) {
  return e.filter((t) => t.tagName !== "A");
}
var rd = c[" useId ".trim().toString()] || (() => {
}), od = 0;
function qe(e) {
  const [t, n] = c.useState(rd());
  return De(() => {
    e || n((r) => r ?? String(od++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const id = ["top", "right", "bottom", "left"], Je = Math.min, pe = Math.max, bn = Math.round, sn = Math.floor, Ae = (e) => ({
  x: e,
  y: e
}), ad = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, sd = {
  start: "end",
  end: "start"
};
function br(e, t, n) {
  return pe(e, Je(t, n));
}
function Le(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Fe(e) {
  return e.split("-")[0];
}
function Rt(e) {
  return e.split("-")[1];
}
function Gr(e) {
  return e === "x" ? "y" : "x";
}
function Yr(e) {
  return e === "y" ? "height" : "width";
}
function et(e) {
  return ["top", "bottom"].includes(Fe(e)) ? "y" : "x";
}
function Xr(e) {
  return Gr(et(e));
}
function cd(e, t, n) {
  n === void 0 && (n = !1);
  const r = Rt(e), o = Xr(e), i = Yr(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (s = wn(s)), [s, wn(s)];
}
function ld(e) {
  const t = wn(e);
  return [wr(e), t, wr(t)];
}
function wr(e) {
  return e.replace(/start|end/g, (t) => sd[t]);
}
function ud(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : s;
    default:
      return [];
  }
}
function dd(e, t, n, r) {
  const o = Rt(e);
  let i = ud(Fe(e), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), t && (i = i.concat(i.map(wr)))), i;
}
function wn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => ad[t]);
}
function fd(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ua(e) {
  return typeof e != "number" ? fd(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function xn(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function qo(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = et(t), s = Xr(t), a = Yr(s), u = Fe(t), l = i === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, m = r[a] / 2 - o[a] / 2;
  let v;
  switch (u) {
    case "top":
      v = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (Rt(t)) {
    case "start":
      v[s] -= m * (n && l ? -1 : 1);
      break;
    case "end":
      v[s] += m * (n && l ? -1 : 1);
      break;
  }
  return v;
}
const pd = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), u = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = qo(l, r, u), m = r, v = {}, w = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: h,
      fn: y
    } = a[g], {
      x: E,
      y: x,
      data: b,
      reset: S
    } = await y({
      x: d,
      y: f,
      initialPlacement: r,
      placement: m,
      strategy: o,
      middlewareData: v,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = E ?? d, f = x ?? f, v = {
      ...v,
      [h]: {
        ...v[h],
        ...b
      }
    }, S && w <= 50 && (w++, typeof S == "object" && (S.placement && (m = S.placement), S.rects && (l = S.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : S.rects), {
      x: d,
      y: f
    } = qo(l, m, u)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: m,
    strategy: o,
    middlewareData: v
  };
};
async function zt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: u
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: v = 0
  } = Le(t, e), w = ua(v), h = a[m ? f === "floating" ? "reference" : "floating" : f], y = xn(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(h))) == null || n ? h : h.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: u
  })), E = f === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, x = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), b = await (i.isElement == null ? void 0 : i.isElement(x)) ? await (i.getScale == null ? void 0 : i.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = xn(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: E,
    offsetParent: x,
    strategy: u
  }) : E);
  return {
    top: (y.top - S.top + w.top) / b.y,
    bottom: (S.bottom - y.bottom + w.bottom) / b.y,
    left: (y.left - S.left + w.left) / b.x,
    right: (S.right - y.right + w.right) / b.x
  };
}
const md = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a,
      middlewareData: u
    } = t, {
      element: l,
      padding: d = 0
    } = Le(e, t) || {};
    if (l == null)
      return {};
    const f = ua(d), m = {
      x: n,
      y: r
    }, v = Xr(o), w = Yr(v), g = await s.getDimensions(l), h = v === "y", y = h ? "top" : "left", E = h ? "bottom" : "right", x = h ? "clientHeight" : "clientWidth", b = i.reference[w] + i.reference[v] - m[v] - i.floating[w], S = m[v] - i.reference[v], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let C = T ? T[x] : 0;
    (!C || !await (s.isElement == null ? void 0 : s.isElement(T))) && (C = a.floating[x] || i.floating[w]);
    const R = b / 2 - S / 2, D = C / 2 - g[w] / 2 - 1, I = Je(f[y], D), L = Je(f[E], D), O = I, P = C - g[w] - L, A = C / 2 - g[w] / 2 + R, W = br(O, A, P), $ = !u.arrow && Rt(o) != null && A !== W && i.reference[w] / 2 - (A < O ? I : L) - g[w] / 2 < 0, U = $ ? A < O ? A - O : A - P : 0;
    return {
      [v]: m[v] + U,
      data: {
        [v]: W,
        centerOffset: A - W - U,
        ...$ && {
          alignmentOffset: U
        }
      },
      reset: $
    };
  }
}), gd = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: s,
        initialPlacement: a,
        platform: u,
        elements: l
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: g = !0,
        ...h
      } = Le(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const y = Fe(o), E = et(a), x = Fe(a) === a, b = await (u.isRTL == null ? void 0 : u.isRTL(l.floating)), S = m || (x || !g ? [wn(a)] : ld(a)), T = w !== "none";
      !m && T && S.push(...dd(a, g, w, b));
      const C = [a, ...S], R = await zt(t, h), D = [];
      let I = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && D.push(R[y]), f) {
        const A = cd(o, s, b);
        D.push(R[A[0]], R[A[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: D
      }], !D.every((A) => A <= 0)) {
        var L, O;
        const A = (((L = i.flip) == null ? void 0 : L.index) || 0) + 1, W = C[A];
        if (W)
          return {
            data: {
              index: A,
              overflows: I
            },
            reset: {
              placement: W
            }
          };
        let $ = (O = I.filter((U) => U.overflows[0] <= 0).sort((U, _) => U.overflows[1] - _.overflows[1])[0]) == null ? void 0 : O.placement;
        if (!$)
          switch (v) {
            case "bestFit": {
              var P;
              const U = (P = I.filter((_) => {
                if (T) {
                  const M = et(_.placement);
                  return M === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((M) => M > 0).reduce((M, j) => M + j, 0)]).sort((_, M) => _[1] - M[1])[0]) == null ? void 0 : P[0];
              U && ($ = U);
              break;
            }
            case "initialPlacement":
              $ = a;
              break;
          }
        if (o !== $)
          return {
            reset: {
              placement: $
            }
          };
      }
      return {};
    }
  };
};
function Zo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Qo(e) {
  return id.some((t) => e[t] >= 0);
}
const hd = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Le(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await zt(t, {
            ...o,
            elementContext: "reference"
          }), s = Zo(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Qo(s)
            }
          };
        }
        case "escaped": {
          const i = await zt(t, {
            ...o,
            altBoundary: !0
          }), s = Zo(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Qo(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function vd(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = Fe(n), a = Rt(n), u = et(n) === "y", l = ["left", "top"].includes(s) ? -1 : 1, d = i && u ? -1 : 1, f = Le(t, e);
  let {
    mainAxis: m,
    crossAxis: v,
    alignmentAxis: w
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return a && typeof w == "number" && (v = a === "end" ? w * -1 : w), u ? {
    x: v * d,
    y: m * l
  } : {
    x: m * l,
    y: v * d
  };
}
const yd = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: s,
        middlewareData: a
      } = t, u = await vd(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: o + u.x,
        y: i + u.y,
        data: {
          ...u,
          placement: s
        }
      };
    }
  };
}, bd = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (h) => {
            let {
              x: y,
              y: E
            } = h;
            return {
              x: y,
              y: E
            };
          }
        },
        ...u
      } = Le(e, t), l = {
        x: n,
        y: r
      }, d = await zt(t, u), f = et(Fe(o)), m = Gr(f);
      let v = l[m], w = l[f];
      if (i) {
        const h = m === "y" ? "top" : "left", y = m === "y" ? "bottom" : "right", E = v + d[h], x = v - d[y];
        v = br(E, v, x);
      }
      if (s) {
        const h = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", E = w + d[h], x = w - d[y];
        w = br(E, w, x);
      }
      const g = a.fn({
        ...t,
        [m]: v,
        [f]: w
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r,
          enabled: {
            [m]: i,
            [f]: s
          }
        }
      };
    }
  };
}, wd = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: u = !0,
        crossAxis: l = !0
      } = Le(e, t), d = {
        x: n,
        y: r
      }, f = et(o), m = Gr(f);
      let v = d[m], w = d[f];
      const g = Le(a, t), h = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (u) {
        const x = m === "y" ? "height" : "width", b = i.reference[m] - i.floating[x] + h.mainAxis, S = i.reference[m] + i.reference[x] - h.mainAxis;
        v < b ? v = b : v > S && (v = S);
      }
      if (l) {
        var y, E;
        const x = m === "y" ? "width" : "height", b = ["top", "left"].includes(Fe(o)), S = i.reference[f] - i.floating[x] + (b && ((y = s.offset) == null ? void 0 : y[f]) || 0) + (b ? 0 : h.crossAxis), T = i.reference[f] + i.reference[x] + (b ? 0 : ((E = s.offset) == null ? void 0 : E[f]) || 0) - (b ? h.crossAxis : 0);
        w < S ? w = S : w > T && (w = T);
      }
      return {
        [m]: v,
        [f]: w
      };
    }
  };
}, xd = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: i,
        platform: s,
        elements: a
      } = t, {
        apply: u = () => {
        },
        ...l
      } = Le(e, t), d = await zt(t, l), f = Fe(o), m = Rt(o), v = et(o) === "y", {
        width: w,
        height: g
      } = i.floating;
      let h, y;
      f === "top" || f === "bottom" ? (h = f, y = m === (await (s.isRTL == null ? void 0 : s.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = f, h = m === "end" ? "top" : "bottom");
      const E = g - d.top - d.bottom, x = w - d.left - d.right, b = Je(g - d[h], E), S = Je(w - d[y], x), T = !t.middlewareData.shift;
      let C = b, R = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (R = x), (r = t.middlewareData.shift) != null && r.enabled.y && (C = E), T && !m) {
        const I = pe(d.left, 0), L = pe(d.right, 0), O = pe(d.top, 0), P = pe(d.bottom, 0);
        v ? R = w - 2 * (I !== 0 || L !== 0 ? I + L : pe(d.left, d.right)) : C = g - 2 * (O !== 0 || P !== 0 ? O + P : pe(d.top, d.bottom));
      }
      await u({
        ...t,
        availableWidth: R,
        availableHeight: C
      });
      const D = await s.getDimensions(a.floating);
      return w !== D.width || g !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function On() {
  return typeof window < "u";
}
function Tt(e) {
  return da(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function me(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ie(e) {
  var t;
  return (t = (da(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function da(e) {
  return On() ? e instanceof Node || e instanceof me(e).Node : !1;
}
function we(e) {
  return On() ? e instanceof Element || e instanceof me(e).Element : !1;
}
function Oe(e) {
  return On() ? e instanceof HTMLElement || e instanceof me(e).HTMLElement : !1;
}
function Jo(e) {
  return !On() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof me(e).ShadowRoot;
}
function Gt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Ed(e) {
  return ["table", "td", "th"].includes(Tt(e));
}
function Mn(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function qr(e) {
  const t = Zr(), n = we(e) ? xe(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Cd(e) {
  let t = tt(e);
  for (; Oe(t) && !xt(t); ) {
    if (qr(t))
      return t;
    if (Mn(t))
      return null;
    t = tt(t);
  }
  return null;
}
function Zr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function xt(e) {
  return ["html", "body", "#document"].includes(Tt(e));
}
function xe(e) {
  return me(e).getComputedStyle(e);
}
function In(e) {
  return we(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function tt(e) {
  if (Tt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Jo(e) && e.host || // Fallback.
    Ie(e)
  );
  return Jo(t) ? t.host : t;
}
function fa(e) {
  const t = tt(e);
  return xt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Oe(t) && Gt(t) ? t : fa(t);
}
function Ht(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = fa(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = me(o);
  if (i) {
    const a = xr(s);
    return t.concat(s, s.visualViewport || [], Gt(o) ? o : [], a && n ? Ht(a) : []);
  }
  return t.concat(o, Ht(o, [], n));
}
function xr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function pa(e) {
  const t = xe(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Oe(e), i = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, a = bn(n) !== i || bn(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function Qr(e) {
  return we(e) ? e : e.contextElement;
}
function yt(e) {
  const t = Qr(e);
  if (!Oe(t))
    return Ae(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = pa(t);
  let s = (i ? bn(n.width) : n.width) / r, a = (i ? bn(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const Sd = /* @__PURE__ */ Ae(0);
function ma(e) {
  const t = me(e);
  return !Zr() || !t.visualViewport ? Sd : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Rd(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== me(e) ? !1 : t;
}
function st(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = Qr(e);
  let s = Ae(1);
  t && (r ? we(r) && (s = yt(r)) : s = yt(e));
  const a = Rd(i, n, r) ? ma(i) : Ae(0);
  let u = (o.left + a.x) / s.x, l = (o.top + a.y) / s.y, d = o.width / s.x, f = o.height / s.y;
  if (i) {
    const m = me(i), v = r && we(r) ? me(r) : r;
    let w = m, g = xr(w);
    for (; g && r && v !== w; ) {
      const h = yt(g), y = g.getBoundingClientRect(), E = xe(g), x = y.left + (g.clientLeft + parseFloat(E.paddingLeft)) * h.x, b = y.top + (g.clientTop + parseFloat(E.paddingTop)) * h.y;
      u *= h.x, l *= h.y, d *= h.x, f *= h.y, u += x, l += b, w = me(g), g = xr(w);
    }
  }
  return xn({
    width: d,
    height: f,
    x: u,
    y: l
  });
}
function Jr(e, t) {
  const n = In(e).scrollLeft;
  return t ? t.left + n : st(Ie(e)).left + n;
}
function ga(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Jr(e, r)
  )), i = r.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Td(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", s = Ie(r), a = t ? Mn(t.floating) : !1;
  if (r === s || a && i)
    return n;
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ae(1);
  const d = Ae(0), f = Oe(r);
  if ((f || !f && !i) && ((Tt(r) !== "body" || Gt(s)) && (u = In(r)), Oe(r))) {
    const v = st(r);
    l = yt(r), d.x = v.x + r.clientLeft, d.y = v.y + r.clientTop;
  }
  const m = s && !f && !i ? ga(s, u, !0) : Ae(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - u.scrollLeft * l.x + d.x + m.x,
    y: n.y * l.y - u.scrollTop * l.y + d.y + m.y
  };
}
function Nd(e) {
  return Array.from(e.getClientRects());
}
function Pd(e) {
  const t = Ie(e), n = In(e), r = e.ownerDocument.body, o = pe(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = pe(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Jr(e);
  const a = -n.scrollTop;
  return xe(r).direction === "rtl" && (s += pe(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function Ad(e, t) {
  const n = me(e), r = Ie(e), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, u = 0;
  if (o) {
    i = o.width, s = o.height;
    const l = Zr();
    (!l || l && t === "fixed") && (a = o.offsetLeft, u = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: u
  };
}
function Dd(e, t) {
  const n = st(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = Oe(e) ? yt(e) : Ae(1), s = e.clientWidth * i.x, a = e.clientHeight * i.y, u = o * i.x, l = r * i.y;
  return {
    width: s,
    height: a,
    x: u,
    y: l
  };
}
function ei(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ad(e, n);
  else if (t === "document")
    r = Pd(Ie(e));
  else if (we(t))
    r = Dd(t, n);
  else {
    const o = ma(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return xn(r);
}
function ha(e, t) {
  const n = tt(e);
  return n === t || !we(n) || xt(n) ? !1 : xe(n).position === "fixed" || ha(n, t);
}
function Od(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ht(e, [], !1).filter((a) => we(a) && Tt(a) !== "body"), o = null;
  const i = xe(e).position === "fixed";
  let s = i ? tt(e) : e;
  for (; we(s) && !xt(s); ) {
    const a = xe(s), u = qr(s);
    !u && a.position === "fixed" && (o = null), (i ? !u && !o : !u && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Gt(s) && !u && ha(e, s)) ? r = r.filter((d) => d !== s) : o = a, s = tt(s);
  }
  return t.set(e, r), r;
}
function Md(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Mn(t) ? [] : Od(t, this._c) : [].concat(n), r], a = s[0], u = s.reduce((l, d) => {
    const f = ei(t, d, o);
    return l.top = pe(f.top, l.top), l.right = Je(f.right, l.right), l.bottom = Je(f.bottom, l.bottom), l.left = pe(f.left, l.left), l;
  }, ei(t, a, o));
  return {
    width: u.right - u.left,
    height: u.bottom - u.top,
    x: u.left,
    y: u.top
  };
}
function Id(e) {
  const {
    width: t,
    height: n
  } = pa(e);
  return {
    width: t,
    height: n
  };
}
function _d(e, t, n) {
  const r = Oe(t), o = Ie(t), i = n === "fixed", s = st(e, !0, i, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const u = Ae(0);
  if (r || !r && !i)
    if ((Tt(t) !== "body" || Gt(o)) && (a = In(t)), r) {
      const m = st(t, !0, i, t);
      u.x = m.x + t.clientLeft, u.y = m.y + t.clientTop;
    } else
      o && (u.x = Jr(o));
  const l = o && !r && !i ? ga(o, a) : Ae(0), d = s.left + a.scrollLeft - u.x - l.x, f = s.top + a.scrollTop - u.y - l.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Kn(e) {
  return xe(e).position === "static";
}
function ti(e, t) {
  if (!Oe(e) || xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ie(e) === n && (n = n.ownerDocument.body), n;
}
function va(e, t) {
  const n = me(e);
  if (Mn(e))
    return n;
  if (!Oe(e)) {
    let o = tt(e);
    for (; o && !xt(o); ) {
      if (we(o) && !Kn(o))
        return o;
      o = tt(o);
    }
    return n;
  }
  let r = ti(e, t);
  for (; r && Ed(r) && Kn(r); )
    r = ti(r, t);
  return r && xt(r) && Kn(r) && !qr(r) ? n : r || Cd(e) || n;
}
const $d = async function(e) {
  const t = this.getOffsetParent || va, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: _d(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function kd(e) {
  return xe(e).direction === "rtl";
}
const Ld = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Td,
  getDocumentElement: Ie,
  getClippingRect: Md,
  getOffsetParent: va,
  getElementRects: $d,
  getClientRects: Nd,
  getDimensions: Id,
  getScale: yt,
  isElement: we,
  isRTL: kd
};
function ya(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Fd(e, t) {
  let n = null, r;
  const o = Ie(e);
  function i() {
    var a;
    clearTimeout(r), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, u) {
    a === void 0 && (a = !1), u === void 0 && (u = 1), i();
    const l = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: m,
      height: v
    } = l;
    if (a || t(), !m || !v)
      return;
    const w = sn(f), g = sn(o.clientWidth - (d + m)), h = sn(o.clientHeight - (f + v)), y = sn(d), x = {
      rootMargin: -w + "px " + -g + "px " + -h + "px " + -y + "px",
      threshold: pe(0, Je(1, u)) || 1
    };
    let b = !0;
    function S(T) {
      const C = T[0].intersectionRatio;
      if (C !== u) {
        if (!b)
          return s();
        C ? s(!1, C) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      C === 1 && !ya(l, e.getBoundingClientRect()) && s(), b = !1;
    }
    try {
      n = new IntersectionObserver(S, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(S, x);
    }
    n.observe(e);
  }
  return s(!0), i;
}
function Wd(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: u = !1
  } = r, l = Qr(e), d = o || i ? [...l ? Ht(l) : [], ...Ht(t)] : [];
  d.forEach((y) => {
    o && y.addEventListener("scroll", n, {
      passive: !0
    }), i && y.addEventListener("resize", n);
  });
  const f = l && a ? Fd(l, n) : null;
  let m = -1, v = null;
  s && (v = new ResizeObserver((y) => {
    let [E] = y;
    E && E.target === l && v && (v.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var x;
      (x = v) == null || x.observe(t);
    })), n();
  }), l && !u && v.observe(l), v.observe(t));
  let w, g = u ? st(e) : null;
  u && h();
  function h() {
    const y = st(e);
    g && !ya(g, y) && n(), g = y, w = requestAnimationFrame(h);
  }
  return n(), () => {
    var y;
    d.forEach((E) => {
      o && E.removeEventListener("scroll", n), i && E.removeEventListener("resize", n);
    }), f == null || f(), (y = v) == null || y.disconnect(), v = null, u && cancelAnimationFrame(w);
  };
}
const Bd = yd, Vd = bd, Ud = gd, zd = xd, Hd = hd, ni = md, jd = wd, Kd = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Ld,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return pd(e, t, {
    ...o,
    platform: i
  });
};
var hn = typeof document < "u" ? ki : be;
function En(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!En(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !En(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function ba(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ri(e, t) {
  const n = ba(e);
  return Math.round(t * n) / n;
}
function Gn(e) {
  const t = c.useRef(e);
  return hn(() => {
    t.current = e;
  }), t;
}
function Gd(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: u,
    open: l
  } = e, [d, f] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, v] = c.useState(r);
  En(m, r) || v(r);
  const [w, g] = c.useState(null), [h, y] = c.useState(null), E = c.useCallback((_) => {
    _ !== T.current && (T.current = _, g(_));
  }, []), x = c.useCallback((_) => {
    _ !== C.current && (C.current = _, y(_));
  }, []), b = i || w, S = s || h, T = c.useRef(null), C = c.useRef(null), R = c.useRef(d), D = u != null, I = Gn(u), L = Gn(o), O = Gn(l), P = c.useCallback(() => {
    if (!T.current || !C.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: m
    };
    L.current && (_.platform = L.current), Kd(T.current, C.current, _).then((M) => {
      const j = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: O.current !== !1
      };
      A.current && !En(R.current, j) && (R.current = j, Et.flushSync(() => {
        f(j);
      }));
    });
  }, [m, t, n, L, O]);
  hn(() => {
    l === !1 && R.current.isPositioned && (R.current.isPositioned = !1, f((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [l]);
  const A = c.useRef(!1);
  hn(() => (A.current = !0, () => {
    A.current = !1;
  }), []), hn(() => {
    if (b && (T.current = b), S && (C.current = S), b && S) {
      if (I.current)
        return I.current(b, S, P);
      P();
    }
  }, [b, S, P, I, D]);
  const W = c.useMemo(() => ({
    reference: T,
    floating: C,
    setReference: E,
    setFloating: x
  }), [E, x]), $ = c.useMemo(() => ({
    reference: b,
    floating: S
  }), [b, S]), U = c.useMemo(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!$.floating)
      return _;
    const M = ri($.floating, d.x), j = ri($.floating, d.y);
    return a ? {
      ..._,
      transform: "translate(" + M + "px, " + j + "px)",
      ...ba($.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: j
    };
  }, [n, a, $.floating, d.x, d.y]);
  return c.useMemo(() => ({
    ...d,
    update: P,
    refs: W,
    elements: $,
    floatingStyles: U
  }), [d, P, W, $, U]);
}
const Yd = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? ni({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? ni({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Xd = (e, t) => ({
  ...Bd(e),
  options: [e, t]
}), qd = (e, t) => ({
  ...Vd(e),
  options: [e, t]
}), Zd = (e, t) => ({
  ...jd(e),
  options: [e, t]
}), Qd = (e, t) => ({
  ...Ud(e),
  options: [e, t]
}), Jd = (e, t) => ({
  ...zd(e),
  options: [e, t]
}), ef = (e, t) => ({
  ...Hd(e),
  options: [e, t]
}), tf = (e, t) => ({
  ...Yd(e),
  options: [e, t]
});
var nf = "Arrow", wa = c.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ p(
    oe.svg,
    {
      ...i,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ p("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
wa.displayName = nf;
var rf = wa, eo = "Popper", [xa, Ea] = We(eo), [of, Ca] = xa(eo), Sa = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = c.useState(null);
  return /* @__PURE__ */ p(of, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
Sa.displayName = eo;
var Ra = "PopperAnchor", Ta = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, i = Ca(Ra, n), s = c.useRef(null), a = q(t, s);
    return c.useEffect(() => {
      i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ p(oe.div, { ...o, ref: a });
  }
);
Ta.displayName = Ra;
var to = "PopperContent", [af, sf] = xa(to), Na = c.forwardRef(
  (e, t) => {
    var le, ve, se, _e, $e, Dt;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: a = 0,
      avoidCollisions: u = !0,
      collisionBoundary: l = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: w,
      ...g
    } = e, h = Ca(to, n), [y, E] = c.useState(null), x = q(t, (Ve) => E(Ve)), [b, S] = c.useState(null), T = Yi(b), C = (T == null ? void 0 : T.width) ?? 0, R = (T == null ? void 0 : T.height) ?? 0, D = r + (i !== "center" ? "-" + i : ""), I = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, L = Array.isArray(l) ? l : [l], O = L.length > 0, P = {
      padding: I,
      boundary: L.filter(lf),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: O
    }, { refs: A, floatingStyles: W, placement: $, isPositioned: U, middlewareData: _ } = Gd({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (...Ve) => Wd(...Ve, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: h.anchor
      },
      middleware: [
        Xd({ mainAxis: o + R, alignmentAxis: s }),
        u && qd({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Zd() : void 0,
          ...P
        }),
        u && Qd({ ...P }),
        Jd({
          ...P,
          apply: ({ elements: Ve, rects: z, availableWidth: tn, availableHeight: nn }) => {
            const { width: Ot, height: Vn } = z.reference, ft = Ve.floating.style;
            ft.setProperty("--radix-popper-available-width", `${tn}px`), ft.setProperty("--radix-popper-available-height", `${nn}px`), ft.setProperty("--radix-popper-anchor-width", `${Ot}px`), ft.setProperty("--radix-popper-anchor-height", `${Vn}px`);
          }
        }),
        b && tf({ element: b, padding: a }),
        uf({ arrowWidth: C, arrowHeight: R }),
        m && ef({ strategy: "referenceHidden", ...P })
      ]
    }), [M, j] = Da($), G = ne(w);
    De(() => {
      U && (G == null || G());
    }, [U, G]);
    const ie = (le = _.arrow) == null ? void 0 : le.x, ae = (ve = _.arrow) == null ? void 0 : ve.y, fe = ((se = _.arrow) == null ? void 0 : se.centerOffset) !== 0, [Be, he] = c.useState();
    return De(() => {
      y && he(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ p(
      "div",
      {
        ref: A.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...W,
          transform: U ? W.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Be,
          "--radix-popper-transform-origin": [
            (_e = _.transformOrigin) == null ? void 0 : _e.x,
            ($e = _.transformOrigin) == null ? void 0 : $e.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Dt = _.hide) == null ? void 0 : Dt.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ p(
          af,
          {
            scope: n,
            placedSide: M,
            onArrowChange: S,
            arrowX: ie,
            arrowY: ae,
            shouldHideArrow: fe,
            children: /* @__PURE__ */ p(
              oe.div,
              {
                "data-side": M,
                "data-align": j,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: U ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Na.displayName = to;
var Pa = "PopperArrow", cf = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Aa = c.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, i = sf(Pa, r), s = cf[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ p(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ p(
          rf,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Aa.displayName = Pa;
function lf(e) {
  return e !== null;
}
var uf = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var h, y, E;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((h = o.arrow) == null ? void 0 : h.centerOffset) !== 0, a = s ? 0 : e.arrowWidth, u = s ? 0 : e.arrowHeight, [l, d] = Da(n), f = { start: "0%", center: "50%", end: "100%" }[d], m = (((y = o.arrow) == null ? void 0 : y.x) ?? 0) + a / 2, v = (((E = o.arrow) == null ? void 0 : E.y) ?? 0) + u / 2;
    let w = "", g = "";
    return l === "bottom" ? (w = s ? f : `${m}px`, g = `${-u}px`) : l === "top" ? (w = s ? f : `${m}px`, g = `${r.floating.height + u}px`) : l === "right" ? (w = `${-u}px`, g = s ? f : `${v}px`) : l === "left" && (w = `${r.floating.width + u}px`, g = s ? f : `${v}px`), { data: { x: w, y: g } };
  }
});
function Da(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Oa = Sa, df = Ta, ff = Na, pf = Aa, mf = "Portal", Ma = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  De(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? zr.createPortal(/* @__PURE__ */ p(oe.div, { ...r, ref: t }), s) : null;
});
Ma.displayName = mf;
var Yn = "rovingFocusGroup.onEntryFocus", gf = { bubbles: !1, cancelable: !0 }, Yt = "RovingFocusGroup", [Er, Ia, hf] = ta(Yt), [vf, _a] = We(
  Yt,
  [hf]
), [yf, bf] = vf(Yt), $a = c.forwardRef(
  (e, t) => /* @__PURE__ */ p(Er.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(Er.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ p(wf, { ...e, ref: t }) }) })
);
$a.displayName = Yt;
var wf = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: i,
    currentTabStopId: s,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: u,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, m = c.useRef(null), v = q(t, m), w = na(i), [g, h] = St({
    prop: s,
    defaultProp: a ?? null,
    onChange: u,
    caller: Yt
  }), [y, E] = c.useState(!1), x = ne(l), b = Ia(n), S = c.useRef(!1), [T, C] = c.useState(0);
  return c.useEffect(() => {
    const R = m.current;
    if (R)
      return R.addEventListener(Yn, x), () => R.removeEventListener(Yn, x);
  }, [x]), /* @__PURE__ */ p(
    yf,
    {
      scope: n,
      orientation: r,
      dir: w,
      loop: o,
      currentTabStopId: g,
      onItemFocus: c.useCallback(
        (R) => h(R),
        [h]
      ),
      onItemShiftTab: c.useCallback(() => E(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => C((R) => R + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => C((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ p(
        oe.div,
        {
          tabIndex: y || T === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: k(e.onMouseDown, () => {
            S.current = !0;
          }),
          onFocus: k(e.onFocus, (R) => {
            const D = !S.current;
            if (R.target === R.currentTarget && D && !y) {
              const I = new CustomEvent(Yn, gf);
              if (R.currentTarget.dispatchEvent(I), !I.defaultPrevented) {
                const L = b().filter(($) => $.focusable), O = L.find(($) => $.active), P = L.find(($) => $.id === g), W = [O, P, ...L].filter(
                  Boolean
                ).map(($) => $.ref.current);
                Fa(W, d);
              }
            }
            S.current = !1;
          }),
          onBlur: k(e.onBlur, () => E(!1))
        }
      )
    }
  );
}), ka = "RovingFocusGroupItem", La = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: i,
      children: s,
      ...a
    } = e, u = qe(), l = i || u, d = bf(ka, n), f = d.currentTabStopId === l, m = Ia(n), { onFocusableItemAdd: v, onFocusableItemRemove: w, currentTabStopId: g } = d;
    return c.useEffect(() => {
      if (r)
        return v(), () => w();
    }, [r, v, w]), /* @__PURE__ */ p(
      Er.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ p(
          oe.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": d.orientation,
            ...a,
            ref: t,
            onMouseDown: k(e.onMouseDown, (h) => {
              r ? d.onItemFocus(l) : h.preventDefault();
            }),
            onFocus: k(e.onFocus, () => d.onItemFocus(l)),
            onKeyDown: k(e.onKeyDown, (h) => {
              if (h.key === "Tab" && h.shiftKey) {
                d.onItemShiftTab();
                return;
              }
              if (h.target !== h.currentTarget)
                return;
              const y = Cf(h, d.orientation, d.dir);
              if (y !== void 0) {
                if (h.metaKey || h.ctrlKey || h.altKey || h.shiftKey)
                  return;
                h.preventDefault();
                let x = m().filter((b) => b.focusable).map((b) => b.ref.current);
                if (y === "last")
                  x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const b = x.indexOf(h.currentTarget);
                  x = d.loop ? Sf(x, b + 1) : x.slice(b + 1);
                }
                setTimeout(() => Fa(x));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: f, hasTabStop: g != null }) : s
          }
        )
      }
    );
  }
);
La.displayName = ka;
var xf = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ef(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Cf(e, t, n) {
  const r = Ef(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return xf[r];
}
function Fa(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n))
      return;
}
function Sf(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var Rf = $a, Tf = La;
// @__NO_SIDE_EFFECTS__
function Nf(e) {
  const t = /* @__PURE__ */ Pf(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Df);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function Pf(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Mf(o), a = Of(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Af = Symbol("radix.slottable");
function Df(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Af;
}
function Of(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Mf(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var If = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, mt = /* @__PURE__ */ new WeakMap(), cn = /* @__PURE__ */ new WeakMap(), ln = {}, Xn = 0, Wa = function(e) {
  return e && (e.host || Wa(e.parentNode));
}, _f = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Wa(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, $f = function(e, t, n, r) {
  var o = _f(t, Array.isArray(e) ? e : [e]);
  ln[n] || (ln[n] = /* @__PURE__ */ new WeakMap());
  var i = ln[n], s = [], a = /* @__PURE__ */ new Set(), u = new Set(o), l = function(f) {
    !f || a.has(f) || (a.add(f), l(f.parentNode));
  };
  o.forEach(l);
  var d = function(f) {
    !f || u.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (a.has(m))
        d(m);
      else
        try {
          var v = m.getAttribute(r), w = v !== null && v !== "false", g = (mt.get(m) || 0) + 1, h = (i.get(m) || 0) + 1;
          mt.set(m, g), i.set(m, h), s.push(m), g === 1 && w && cn.set(m, !0), h === 1 && m.setAttribute(n, "true"), w || m.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", m, y);
        }
    });
  };
  return d(t), a.clear(), Xn++, function() {
    s.forEach(function(f) {
      var m = mt.get(f) - 1, v = i.get(f) - 1;
      mt.set(f, m), i.set(f, v), m || (cn.has(f) || f.removeAttribute(r), cn.delete(f)), v || f.removeAttribute(n);
    }), Xn--, Xn || (mt = /* @__PURE__ */ new WeakMap(), mt = /* @__PURE__ */ new WeakMap(), cn = /* @__PURE__ */ new WeakMap(), ln = {});
  };
}, no = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || If(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), $f(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Ne = function() {
  return Ne = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ne.apply(this, arguments);
};
function Ba(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function kf(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, i; r < o; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var vn = "right-scroll-bar-position", yn = "width-before-scroll-bar", Lf = "with-scroll-bars-hidden", Ff = "--removed-body-scroll-bar-size";
function qn(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Wf(e, t) {
  var n = Ee(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Bf = typeof window < "u" ? c.useLayoutEffect : c.useEffect, oi = /* @__PURE__ */ new WeakMap();
function Vf(e, t) {
  var n = Wf(t || null, function(r) {
    return e.forEach(function(o) {
      return qn(o, r);
    });
  });
  return Bf(function() {
    var r = oi.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), s = n.current;
      o.forEach(function(a) {
        i.has(a) || qn(a, null);
      }), i.forEach(function(a) {
        o.has(a) || qn(a, s);
      });
    }
    oi.set(n, e);
  }, [e]), n;
}
function Uf(e) {
  return e;
}
function zf(e, t) {
  t === void 0 && (t = Uf);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var s = t(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var u = function() {
        var d = s;
        s = [], d.forEach(i);
      }, l = function() {
        return Promise.resolve().then(u);
      };
      l(), n = {
        push: function(d) {
          s.push(d), l();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return o;
}
function Hf(e) {
  e === void 0 && (e = {});
  var t = zf(null);
  return t.options = Ne({ async: !0, ssr: !1 }, e), t;
}
var Va = function(e) {
  var t = e.sideCar, n = Ba(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return c.createElement(r, Ne({}, n));
};
Va.isSideCarExport = !0;
function jf(e, t) {
  return e.useMedium(t), Va;
}
var Ua = Hf(), Zn = function() {
}, _n = c.forwardRef(function(e, t) {
  var n = c.useRef(null), r = c.useState({
    onScrollCapture: Zn,
    onWheelCapture: Zn,
    onTouchMoveCapture: Zn
  }), o = r[0], i = r[1], s = e.forwardProps, a = e.children, u = e.className, l = e.removeScrollBar, d = e.enabled, f = e.shards, m = e.sideCar, v = e.noIsolation, w = e.inert, g = e.allowPinchZoom, h = e.as, y = h === void 0 ? "div" : h, E = e.gapMode, x = Ba(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), b = m, S = Vf([n, t]), T = Ne(Ne({}, x), o);
  return c.createElement(
    c.Fragment,
    null,
    d && c.createElement(b, { sideCar: Ua, removeScrollBar: l, shards: f, noIsolation: v, inert: w, setCallbacks: i, allowPinchZoom: !!g, lockRef: n, gapMode: E }),
    s ? c.cloneElement(c.Children.only(a), Ne(Ne({}, T), { ref: S })) : c.createElement(y, Ne({}, T, { className: u, ref: S }), a)
  );
});
_n.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_n.classNames = {
  fullWidth: yn,
  zeroRight: vn
};
var ii, Kf = function() {
  if (ii)
    return ii;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Gf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Kf();
  return t && e.setAttribute("nonce", t), e;
}
function Yf(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Xf(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var qf = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Gf()) && (Yf(t, n), Xf(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Zf = function() {
  var e = qf();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, za = function() {
  var e = Zf(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Qf = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Qn = function(e) {
  return parseInt(e || "", 10) || 0;
}, Jf = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Qn(n), Qn(r), Qn(o)];
}, ep = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Qf;
  var t = Jf(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, tp = za(), bt = "data-scroll-locked", np = function(e, t, n, r) {
  var o = e.left, i = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Lf, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(bt, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(vn, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(yn, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(vn, " .").concat(vn, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(yn, " .").concat(yn, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(bt, `] {
    `).concat(Ff, ": ").concat(a, `px;
  }
`);
}, ai = function() {
  var e = parseInt(document.body.getAttribute(bt) || "0", 10);
  return isFinite(e) ? e : 0;
}, rp = function() {
  c.useEffect(function() {
    return document.body.setAttribute(bt, (ai() + 1).toString()), function() {
      var e = ai() - 1;
      e <= 0 ? document.body.removeAttribute(bt) : document.body.setAttribute(bt, e.toString());
    };
  }, []);
}, op = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  rp();
  var i = c.useMemo(function() {
    return ep(o);
  }, [o]);
  return c.createElement(tp, { styles: np(i, !t, o, n ? "" : "!important") });
}, Cr = !1;
if (typeof window < "u")
  try {
    var un = Object.defineProperty({}, "passive", {
      get: function() {
        return Cr = !0, !0;
      }
    });
    window.addEventListener("test", un, un), window.removeEventListener("test", un, un);
  } catch {
    Cr = !1;
  }
var gt = Cr ? { passive: !1 } : !1, ip = function(e) {
  return e.tagName === "TEXTAREA";
}, Ha = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !ip(e) && n[t] === "visible")
  );
}, ap = function(e) {
  return Ha(e, "overflowY");
}, sp = function(e) {
  return Ha(e, "overflowX");
}, si = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = ja(e, r);
    if (o) {
      var i = Ka(e, r), s = i[1], a = i[2];
      if (s > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, cp = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, lp = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ja = function(e, t) {
  return e === "v" ? ap(t) : sp(t);
}, Ka = function(e, t) {
  return e === "v" ? cp(t) : lp(t);
}, up = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, dp = function(e, t, n, r, o) {
  var i = up(e, window.getComputedStyle(t).direction), s = i * r, a = n.target, u = t.contains(a), l = !1, d = s > 0, f = 0, m = 0;
  do {
    var v = Ka(e, a), w = v[0], g = v[1], h = v[2], y = g - h - i * w;
    (w || y) && ja(e, a) && (f += y, m += w), a instanceof ShadowRoot ? a = a.host : a = a.parentNode;
  } while (
    // portaled content
    !u && a !== document.body || // self content
    u && (t.contains(a) || t === a)
  );
  return (d && (o && Math.abs(f) < 1 || !o && s > f) || !d && (o && Math.abs(m) < 1 || !o && -s > m)) && (l = !0), l;
}, dn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ci = function(e) {
  return [e.deltaX, e.deltaY];
}, li = function(e) {
  return e && "current" in e ? e.current : e;
}, fp = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, pp = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, mp = 0, ht = [];
function gp(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), r = c.useRef(), o = c.useState(mp++)[0], i = c.useState(za)[0], s = c.useRef(e);
  c.useEffect(function() {
    s.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = kf([e.lockRef.current], (e.shards || []).map(li), !0).filter(Boolean);
      return g.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = c.useCallback(function(g, h) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !s.current.allowPinchZoom;
    var y = dn(g), E = n.current, x = "deltaX" in g ? g.deltaX : E[0] - y[0], b = "deltaY" in g ? g.deltaY : E[1] - y[1], S, T = g.target, C = Math.abs(x) > Math.abs(b) ? "h" : "v";
    if ("touches" in g && C === "h" && T.type === "range")
      return !1;
    var R = si(C, T);
    if (!R)
      return !0;
    if (R ? S = C : (S = C === "v" ? "h" : "v", R = si(C, T)), !R)
      return !1;
    if (!r.current && "changedTouches" in g && (x || b) && (r.current = S), !S)
      return !0;
    var D = r.current || S;
    return dp(D, h, g, D === "h" ? x : b, !0);
  }, []), u = c.useCallback(function(g) {
    var h = g;
    if (!(!ht.length || ht[ht.length - 1] !== i)) {
      var y = "deltaY" in h ? ci(h) : dn(h), E = t.current.filter(function(S) {
        return S.name === h.type && (S.target === h.target || h.target === S.shadowParent) && fp(S.delta, y);
      })[0];
      if (E && E.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!E) {
        var x = (s.current.shards || []).map(li).filter(Boolean).filter(function(S) {
          return S.contains(h.target);
        }), b = x.length > 0 ? a(h, x[0]) : !s.current.noIsolation;
        b && h.cancelable && h.preventDefault();
      }
    }
  }, []), l = c.useCallback(function(g, h, y, E) {
    var x = { name: g, delta: h, target: y, should: E, shadowParent: hp(y) };
    t.current.push(x), setTimeout(function() {
      t.current = t.current.filter(function(b) {
        return b !== x;
      });
    }, 1);
  }, []), d = c.useCallback(function(g) {
    n.current = dn(g), r.current = void 0;
  }, []), f = c.useCallback(function(g) {
    l(g.type, ci(g), g.target, a(g, e.lockRef.current));
  }, []), m = c.useCallback(function(g) {
    l(g.type, dn(g), g.target, a(g, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return ht.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", u, gt), document.addEventListener("touchmove", u, gt), document.addEventListener("touchstart", d, gt), function() {
      ht = ht.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", u, gt), document.removeEventListener("touchmove", u, gt), document.removeEventListener("touchstart", d, gt);
    };
  }, []);
  var v = e.removeScrollBar, w = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    w ? c.createElement(i, { styles: pp(o) }) : null,
    v ? c.createElement(op, { gapMode: e.gapMode }) : null
  );
}
function hp(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const vp = jf(Ua, gp);
var Ga = c.forwardRef(function(e, t) {
  return c.createElement(_n, Ne({}, e, { ref: t, sideCar: vp }));
});
Ga.classNames = _n.classNames;
const ro = Ga;
var Sr = ["Enter", " "], yp = ["ArrowDown", "PageUp", "Home"], Ya = ["ArrowUp", "PageDown", "End"], bp = [...yp, ...Ya], wp = {
  ltr: [...Sr, "ArrowRight"],
  rtl: [...Sr, "ArrowLeft"]
}, xp = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Xt = "Menu", [jt, Ep, Cp] = ta(Xt), [ut, Xa] = We(Xt, [
  Cp,
  Ea,
  _a
]), qt = Ea(), qa = _a(), [Za, nt] = ut(Xt), [Sp, Zt] = ut(Xt), Qa = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = e, a = qt(t), [u, l] = c.useState(null), d = c.useRef(!1), f = ne(i), m = na(o);
  return c.useEffect(() => {
    const v = () => {
      d.current = !0, document.addEventListener("pointerdown", w, { capture: !0, once: !0 }), document.addEventListener("pointermove", w, { capture: !0, once: !0 });
    }, w = () => d.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", w, { capture: !0 }), document.removeEventListener("pointermove", w, { capture: !0 });
    };
  }, []), /* @__PURE__ */ p(Oa, { ...a, children: /* @__PURE__ */ p(
    Za,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: u,
      onContentChange: l,
      children: /* @__PURE__ */ p(
        Sp,
        {
          scope: t,
          onClose: c.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: m,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
Qa.displayName = Xt;
var Rp = "MenuAnchor", oo = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = qt(n);
    return /* @__PURE__ */ p(df, { ...o, ...r, ref: t });
  }
);
oo.displayName = Rp;
var io = "MenuPortal", [Tp, Ja] = ut(io, {
  forceMount: void 0
}), es = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, i = nt(io, t);
  return /* @__PURE__ */ p(Tp, { scope: t, forceMount: n, children: /* @__PURE__ */ p(Me, { present: n || i.open, children: /* @__PURE__ */ p(Ma, { asChild: !0, container: o, children: r }) }) });
};
es.displayName = io;
var ge = "MenuContent", [Np, ao] = ut(ge), ts = c.forwardRef(
  (e, t) => {
    const n = Ja(ge, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = nt(ge, e.__scopeMenu), s = Zt(ge, e.__scopeMenu);
    return /* @__PURE__ */ p(jt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(Me, { present: r || i.open, children: /* @__PURE__ */ p(jt.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ p(Pp, { ...o, ref: t }) : /* @__PURE__ */ p(Ap, { ...o, ref: t }) }) }) });
  }
), Pp = c.forwardRef(
  (e, t) => {
    const n = nt(ge, e.__scopeMenu), r = c.useRef(null), o = q(t, r);
    return c.useEffect(() => {
      const i = r.current;
      if (i)
        return no(i);
    }, []), /* @__PURE__ */ p(
      so,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: k(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), Ap = c.forwardRef((e, t) => {
  const n = nt(ge, e.__scopeMenu);
  return /* @__PURE__ */ p(
    so,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Dp = /* @__PURE__ */ Nf("MenuContent.ScrollLock"), so = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: a,
      onEntryFocus: u,
      onEscapeKeyDown: l,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: m,
      onDismiss: v,
      disableOutsideScroll: w,
      ...g
    } = e, h = nt(ge, n), y = Zt(ge, n), E = qt(n), x = qa(n), b = Ep(n), [S, T] = c.useState(null), C = c.useRef(null), R = q(t, C, h.onContentChange), D = c.useRef(0), I = c.useRef(""), L = c.useRef(0), O = c.useRef(null), P = c.useRef("right"), A = c.useRef(0), W = w ? ro : c.Fragment, $ = w ? { as: Dp, allowPinchZoom: !0 } : void 0, U = (M) => {
      var le, ve;
      const j = I.current + M, G = b().filter((se) => !se.disabled), ie = document.activeElement, ae = (le = G.find((se) => se.ref.current === ie)) == null ? void 0 : le.textValue, fe = G.map((se) => se.textValue), Be = Up(fe, j, ae), he = (ve = G.find((se) => se.textValue === Be)) == null ? void 0 : ve.ref.current;
      (function se(_e) {
        I.current = _e, window.clearTimeout(D.current), _e !== "" && (D.current = window.setTimeout(() => se(""), 1e3));
      })(j), he && setTimeout(() => he.focus());
    };
    c.useEffect(() => () => window.clearTimeout(D.current), []), sa();
    const _ = c.useCallback((M) => {
      var G, ie;
      return P.current === ((G = O.current) == null ? void 0 : G.side) && Hp(M, (ie = O.current) == null ? void 0 : ie.area);
    }, []);
    return /* @__PURE__ */ p(
      Np,
      {
        scope: n,
        searchRef: I,
        onItemEnter: c.useCallback(
          (M) => {
            _(M) && M.preventDefault();
          },
          [_]
        ),
        onItemLeave: c.useCallback(
          (M) => {
            var j;
            _(M) || ((j = C.current) == null || j.focus(), T(null));
          },
          [_]
        ),
        onTriggerLeave: c.useCallback(
          (M) => {
            _(M) && M.preventDefault();
          },
          [_]
        ),
        pointerGraceTimerRef: L,
        onPointerGraceIntentChange: c.useCallback((M) => {
          O.current = M;
        }, []),
        children: /* @__PURE__ */ p(W, { ...$, children: /* @__PURE__ */ p(
          ca,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: k(i, (M) => {
              var j;
              M.preventDefault(), (j = C.current) == null || j.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ p(
              ia,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: l,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: m,
                onDismiss: v,
                children: /* @__PURE__ */ p(
                  Rf,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: S,
                    onCurrentTabStopIdChange: T,
                    onEntryFocus: k(u, (M) => {
                      y.isUsingKeyboardRef.current || M.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ p(
                      ff,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": ys(h.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...E,
                        ...g,
                        ref: R,
                        style: { outline: "none", ...g.style },
                        onKeyDown: k(g.onKeyDown, (M) => {
                          const G = M.target.closest("[data-radix-menu-content]") === M.currentTarget, ie = M.ctrlKey || M.altKey || M.metaKey, ae = M.key.length === 1;
                          G && (M.key === "Tab" && M.preventDefault(), !ie && ae && U(M.key));
                          const fe = C.current;
                          if (M.target !== fe || !bp.includes(M.key))
                            return;
                          M.preventDefault();
                          const he = b().filter((le) => !le.disabled).map((le) => le.ref.current);
                          Ya.includes(M.key) && he.reverse(), Bp(he);
                        }),
                        onBlur: k(e.onBlur, (M) => {
                          M.currentTarget.contains(M.target) || (window.clearTimeout(D.current), I.current = "");
                        }),
                        onPointerMove: k(
                          e.onPointerMove,
                          Kt((M) => {
                            const j = M.target, G = A.current !== M.clientX;
                            if (M.currentTarget.contains(j) && G) {
                              const ie = M.clientX > A.current ? "right" : "left";
                              P.current = ie, A.current = M.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
ts.displayName = ge;
var Op = "MenuGroup", co = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(oe.div, { role: "group", ...r, ref: t });
  }
);
co.displayName = Op;
var Mp = "MenuLabel", ns = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(oe.div, { ...r, ref: t });
  }
);
ns.displayName = Mp;
var Cn = "MenuItem", ui = "menu.itemSelect", $n = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, i = c.useRef(null), s = Zt(Cn, e.__scopeMenu), a = ao(Cn, e.__scopeMenu), u = q(t, i), l = c.useRef(!1), d = () => {
      const f = i.current;
      if (!n && f) {
        const m = new CustomEvent(ui, { bubbles: !0, cancelable: !0 });
        f.addEventListener(ui, (v) => r == null ? void 0 : r(v), { once: !0 }), Xi(f, m), m.defaultPrevented ? l.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ p(
      rs,
      {
        ...o,
        ref: u,
        disabled: n,
        onClick: k(e.onClick, d),
        onPointerDown: (f) => {
          var m;
          (m = e.onPointerDown) == null || m.call(e, f), l.current = !0;
        },
        onPointerUp: k(e.onPointerUp, (f) => {
          var m;
          l.current || (m = f.currentTarget) == null || m.click();
        }),
        onKeyDown: k(e.onKeyDown, (f) => {
          const m = a.searchRef.current !== "";
          n || m && f.key === " " || Sr.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
$n.displayName = Cn;
var rs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = e, s = ao(Cn, n), a = qa(n), u = c.useRef(null), l = q(t, u), [d, f] = c.useState(!1), [m, v] = c.useState("");
    return c.useEffect(() => {
      const w = u.current;
      w && v((w.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ p(
      jt.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? m,
        children: /* @__PURE__ */ p(Tf, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ p(
          oe.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...i,
            ref: l,
            onPointerMove: k(
              e.onPointerMove,
              Kt((w) => {
                r ? s.onItemLeave(w) : (s.onItemEnter(w), w.defaultPrevented || w.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: k(
              e.onPointerLeave,
              Kt((w) => s.onItemLeave(w))
            ),
            onFocus: k(e.onFocus, () => f(!0)),
            onBlur: k(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), Ip = "MenuCheckboxItem", os = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ p(ls, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ p(
      $n,
      {
        role: "menuitemcheckbox",
        "aria-checked": Sn(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": fo(n),
        onSelect: k(
          o.onSelect,
          () => r == null ? void 0 : r(Sn(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
os.displayName = Ip;
var is = "MenuRadioGroup", [_p, $p] = ut(
  is,
  { value: void 0, onValueChange: () => {
  } }
), as = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, i = ne(r);
    return /* @__PURE__ */ p(_p, { scope: e.__scopeMenu, value: n, onValueChange: i, children: /* @__PURE__ */ p(co, { ...o, ref: t }) });
  }
);
as.displayName = is;
var ss = "MenuRadioItem", cs = c.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = $p(ss, e.__scopeMenu), i = n === o.value;
    return /* @__PURE__ */ p(ls, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ p(
      $n,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...r,
        ref: t,
        "data-state": fo(i),
        onSelect: k(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
cs.displayName = ss;
var lo = "MenuItemIndicator", [ls, kp] = ut(
  lo,
  { checked: !1 }
), us = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, i = kp(lo, n);
    return /* @__PURE__ */ p(
      Me,
      {
        present: r || Sn(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ p(
          oe.span,
          {
            ...o,
            ref: t,
            "data-state": fo(i.checked)
          }
        )
      }
    );
  }
);
us.displayName = lo;
var Lp = "MenuSeparator", ds = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ p(
      oe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
ds.displayName = Lp;
var Fp = "MenuArrow", fs = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = qt(n);
    return /* @__PURE__ */ p(pf, { ...o, ...r, ref: t });
  }
);
fs.displayName = Fp;
var uo = "MenuSub", [Wp, ps] = ut(uo), ms = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, i = nt(uo, t), s = qt(t), [a, u] = c.useState(null), [l, d] = c.useState(null), f = ne(o);
  return c.useEffect(() => (i.open === !1 && f(!1), () => f(!1)), [i.open, f]), /* @__PURE__ */ p(Oa, { ...s, children: /* @__PURE__ */ p(
    Za,
    {
      scope: t,
      open: r,
      onOpenChange: f,
      content: l,
      onContentChange: d,
      children: /* @__PURE__ */ p(
        Wp,
        {
          scope: t,
          contentId: qe(),
          triggerId: qe(),
          trigger: a,
          onTriggerChange: u,
          children: n
        }
      )
    }
  ) });
};
ms.displayName = uo;
var Wt = "MenuSubTrigger", gs = c.forwardRef(
  (e, t) => {
    const n = nt(Wt, e.__scopeMenu), r = Zt(Wt, e.__scopeMenu), o = ps(Wt, e.__scopeMenu), i = ao(Wt, e.__scopeMenu), s = c.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: u } = i, l = { __scopeMenu: e.__scopeMenu }, d = c.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return c.useEffect(() => d, [d]), c.useEffect(() => {
      const f = a.current;
      return () => {
        window.clearTimeout(f), u(null);
      };
    }, [a, u]), /* @__PURE__ */ p(oo, { asChild: !0, ...l, children: /* @__PURE__ */ p(
      rs,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": ys(n.open),
        ...e,
        ref: Ce(t, o.onTriggerChange),
        onClick: (f) => {
          var m;
          (m = e.onClick) == null || m.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: k(
          e.onPointerMove,
          Kt((f) => {
            i.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !s.current && (i.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: k(
          e.onPointerLeave,
          Kt((f) => {
            var v, w;
            d();
            const m = (v = n.content) == null ? void 0 : v.getBoundingClientRect();
            if (m) {
              const g = (w = n.content) == null ? void 0 : w.dataset.side, h = g === "right", y = h ? -5 : 5, E = m[h ? "left" : "right"], x = m[h ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + y, y: f.clientY },
                  { x: E, y: m.top },
                  { x, y: m.top },
                  { x, y: m.bottom },
                  { x: E, y: m.bottom }
                ],
                side: g
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(f), f.defaultPrevented)
                return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: k(e.onKeyDown, (f) => {
          var v;
          const m = i.searchRef.current !== "";
          e.disabled || m && f.key === " " || wp[r.dir].includes(f.key) && (n.onOpenChange(!0), (v = n.content) == null || v.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
gs.displayName = Wt;
var hs = "MenuSubContent", vs = c.forwardRef(
  (e, t) => {
    const n = Ja(ge, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, i = nt(ge, e.__scopeMenu), s = Zt(ge, e.__scopeMenu), a = ps(hs, e.__scopeMenu), u = c.useRef(null), l = q(t, u);
    return /* @__PURE__ */ p(jt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(Me, { present: r || i.open, children: /* @__PURE__ */ p(jt.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ p(
      so,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          s.isUsingKeyboardRef.current && ((f = u.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: k(e.onFocusOutside, (d) => {
          d.target !== a.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: k(e.onEscapeKeyDown, (d) => {
          s.onClose(), d.preventDefault();
        }),
        onKeyDown: k(e.onKeyDown, (d) => {
          var v;
          const f = d.currentTarget.contains(d.target), m = xp[s.dir].includes(d.key);
          f && m && (i.onOpenChange(!1), (v = a.trigger) == null || v.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
vs.displayName = hs;
function ys(e) {
  return e ? "open" : "closed";
}
function Sn(e) {
  return e === "indeterminate";
}
function fo(e) {
  return Sn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Bp(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Vp(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function Up(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let s = Vp(e, Math.max(i, 0));
  o.length === 1 && (s = s.filter((l) => l !== n));
  const u = s.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return u !== n ? u : void 0;
}
function zp(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let i = 0, s = t.length - 1; i < t.length; s = i++) {
    const a = t[i], u = t[s], l = a.x, d = a.y, f = u.x, m = u.y;
    d > r != m > r && n < (f - l) * (r - d) / (m - d) + l && (o = !o);
  }
  return o;
}
function Hp(e, t) {
  if (!t)
    return !1;
  const n = { x: e.clientX, y: e.clientY };
  return zp(n, t);
}
function Kt(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var jp = Qa, Kp = oo, Gp = es, Yp = ts, Xp = co, qp = ns, Zp = $n, Qp = os, Jp = as, em = cs, tm = us, nm = ds, rm = fs, om = ms, im = gs, am = vs, kn = "DropdownMenu", [sm, zy] = We(
  kn,
  [Xa]
), ce = Xa(), [cm, bs] = sm(kn), ws = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: i,
    onOpenChange: s,
    modal: a = !0
  } = e, u = ce(t), l = c.useRef(null), [d, f] = St({
    prop: o,
    defaultProp: i ?? !1,
    onChange: s,
    caller: kn
  });
  return /* @__PURE__ */ p(
    cm,
    {
      scope: t,
      triggerId: qe(),
      triggerRef: l,
      contentId: qe(),
      open: d,
      onOpenChange: f,
      onOpenToggle: c.useCallback(() => f((m) => !m), [f]),
      modal: a,
      children: /* @__PURE__ */ p(jp, { ...u, open: d, onOpenChange: f, dir: r, modal: a, children: n })
    }
  );
};
ws.displayName = kn;
var xs = "DropdownMenuTrigger", Es = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, i = bs(xs, n), s = ce(n);
    return /* @__PURE__ */ p(Kp, { asChild: !0, ...s, children: /* @__PURE__ */ p(
      oe.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Ce(t, i.triggerRef),
        onPointerDown: k(e.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
        }),
        onKeyDown: k(e.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
Es.displayName = xs;
var lm = "DropdownMenuPortal", Cs = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = ce(t);
  return /* @__PURE__ */ p(Gp, { ...r, ...n });
};
Cs.displayName = lm;
var Ss = "DropdownMenuContent", Rs = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = bs(Ss, n), i = ce(n), s = c.useRef(!1);
    return /* @__PURE__ */ p(
      Yp,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...r,
        ref: t,
        onCloseAutoFocus: k(e.onCloseAutoFocus, (a) => {
          var u;
          s.current || (u = o.triggerRef.current) == null || u.focus(), s.current = !1, a.preventDefault();
        }),
        onInteractOutside: k(e.onInteractOutside, (a) => {
          const u = a.detail.originalEvent, l = u.button === 0 && u.ctrlKey === !0, d = u.button === 2 || l;
          (!o.modal || d) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Rs.displayName = Ss;
var um = "DropdownMenuGroup", Ts = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ p(Xp, { ...o, ...r, ref: t });
  }
);
Ts.displayName = um;
var dm = "DropdownMenuLabel", Ns = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ p(qp, { ...o, ...r, ref: t });
  }
);
Ns.displayName = dm;
var fm = "DropdownMenuItem", Ps = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ p(Zp, { ...o, ...r, ref: t });
  }
);
Ps.displayName = fm;
var pm = "DropdownMenuCheckboxItem", As = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(Qp, { ...o, ...r, ref: t });
});
As.displayName = pm;
var mm = "DropdownMenuRadioGroup", Ds = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(Jp, { ...o, ...r, ref: t });
});
Ds.displayName = mm;
var gm = "DropdownMenuRadioItem", Os = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(em, { ...o, ...r, ref: t });
});
Os.displayName = gm;
var hm = "DropdownMenuItemIndicator", Ms = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(tm, { ...o, ...r, ref: t });
});
Ms.displayName = hm;
var vm = "DropdownMenuSeparator", Is = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(nm, { ...o, ...r, ref: t });
});
Is.displayName = vm;
var ym = "DropdownMenuArrow", bm = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
    return /* @__PURE__ */ p(rm, { ...o, ...r, ref: t });
  }
);
bm.displayName = ym;
var wm = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: i } = e, s = ce(t), [a, u] = St({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ p(om, { ...s, open: a, onOpenChange: u, children: n });
}, xm = "DropdownMenuSubTrigger", _s = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(im, { ...o, ...r, ref: t });
});
_s.displayName = xm;
var Em = "DropdownMenuSubContent", $s = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = ce(n);
  return /* @__PURE__ */ p(
    am,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
$s.displayName = Em;
var Cm = ws, ks = Es, Ls = Cs, Fs = Rs, Sm = Ts, Ws = Ns, Bs = Ps, Vs = As, Rm = Ds, Us = Os, zs = Ms, Hs = Is, Tm = wm, js = _s, Ks = $s;
const Pe = ({ name: e, size: t, color: n, filled: r, onClick: o, rotate: i = 0, className: s }) => /* @__PURE__ */ p(
  "div",
  {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: t ? `${t}px` : void 0,
      transform: i ? `rotate(${i}deg)` : void 0
    },
    onClick: o,
    children: /* @__PURE__ */ p(
      "span",
      {
        translate: "no",
        className: F("material-symbols-rounded", s),
        style: {
          fontSize: t ? `${t}px` : void 0,
          color: n,
          overflow: "hidden",
          fontVariationSettings: r ? "'FILL' 1" : "'FILL' 0"
        },
        children: e
      }
    )
  }
), Nm = (e) => /* @__PURE__ */ c.createElement("svg", { width: 22, height: 22, viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ c.createElement("g", { id: "CheckItem" }, /* @__PURE__ */ c.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M18.2961 4.5363C18.8284 4.97598 18.9034 5.76387 18.4637 6.29611L8.96375 17.7961C8.7241 18.0862 8.36651 18.2529 7.99023 18.25C7.61395 18.247 7.25903 18.0747 7.02396 17.7809L3.02396 12.7809C2.5927 12.2418 2.6801 11.4552 3.21918 11.0239C3.75825 10.5927 4.54487 10.6801 4.97613 11.2191L8.01561 15.0185L16.5363 4.7039C16.976 4.17166 17.7639 4.09663 18.2961 4.5363Z", fill: "#FD7E14" }))), Pm = ({ size: e = 22, className: t, ...n }) => /* @__PURE__ */ p(Nm, { width: e, height: e, className: t, ...n });
function Ze(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function di(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Am(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = di(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : di(e[o], null);
        }
      };
  };
}
function Nt(...e) {
  return c.useCallback(Am(...e), e);
}
function Dm(e, t) {
  const n = c.createContext(t), r = (i) => {
    const { children: s, ...a } = i, u = c.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ p(n.Provider, { value: u, children: s });
  };
  r.displayName = e + "Provider";
  function o(i) {
    const s = c.useContext(n);
    if (s)
      return s;
    if (t !== void 0)
      return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Om(e, t = []) {
  let n = [];
  function r(i, s) {
    const a = c.createContext(s), u = n.length;
    n = [...n, s];
    const l = (f) => {
      var y;
      const { scope: m, children: v, ...w } = f, g = ((y = m == null ? void 0 : m[e]) == null ? void 0 : y[u]) || a, h = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ p(g.Provider, { value: h, children: v });
    };
    l.displayName = i + "Provider";
    function d(f, m) {
      var g;
      const v = ((g = m == null ? void 0 : m[e]) == null ? void 0 : g[u]) || a, w = c.useContext(v);
      if (w)
        return w;
      if (s !== void 0)
        return s;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [l, d];
  }
  const o = () => {
    const i = n.map((s) => c.createContext(s));
    return function(a) {
      const u = (a == null ? void 0 : a[e]) || i;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...a, [e]: u } }),
        [a, u]
      );
    };
  };
  return o.scopeName = e, [r, Mm(o, ...t)];
}
function Mm(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: u, scopeName: l }) => {
        const f = u(i)[`__scope${l}`];
        return { ...a, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Rn = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, Im = c["useId".toString()] || (() => {
}), _m = 0;
function Jn(e) {
  const [t, n] = c.useState(Im());
  return Rn(() => {
    e || n((r) => r ?? String(_m++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function Qt(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function $m({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, o] = km({ defaultProp: t, onChange: n }), i = e !== void 0, s = i ? e : r, a = Qt(n), u = c.useCallback(
    (l) => {
      if (i) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && a(f);
      } else
        o(l);
    },
    [i, e, o, a]
  );
  return [s, u];
}
function km({
  defaultProp: e,
  onChange: t
}) {
  const n = c.useState(e), [r] = n, o = c.useRef(r), i = Qt(t);
  return c.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
function fi(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Lm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = fi(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : fi(e[o], null);
        }
      };
  };
}
var Ln = c.forwardRef((e, t) => {
  const { children: n, ...r } = e, o = c.Children.toArray(n), i = o.find(Wm);
  if (i) {
    const s = i.props.children, a = o.map((u) => u === i ? c.Children.count(s) > 1 ? c.Children.only(null) : c.isValidElement(s) ? s.props.children : null : u);
    return /* @__PURE__ */ p(Rr, { ...r, ref: t, children: c.isValidElement(s) ? c.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ p(Rr, { ...r, ref: t, children: n });
});
Ln.displayName = "Slot";
var Rr = c.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (c.isValidElement(n)) {
    const o = Vm(n), i = Bm(r, n.props);
    return n.type !== c.Fragment && (i.ref = t ? Lm(t, o) : o), c.cloneElement(n, i);
  }
  return c.Children.count(n) > 1 ? c.Children.only(null) : null;
});
Rr.displayName = "SlotClone";
var Fm = ({ children: e }) => /* @__PURE__ */ p(Qe, { children: e });
function Wm(e) {
  return c.isValidElement(e) && e.type === Fm;
}
function Bm(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Vm(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Um = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], rt = Um.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Ln : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function zm(e, t) {
  e && Et.flushSync(() => e.dispatchEvent(t));
}
function Hm(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qt(e);
  c.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var jm = "DismissableLayer", Tr = "dismissableLayer.update", Km = "dismissableLayer.pointerDownOutside", Gm = "dismissableLayer.focusOutside", pi, Gs = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ys = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(Gs), [d, f] = c.useState(null), m = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = Nt(t, (C) => f(C)), g = Array.from(l.layers), [h] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(h), E = d ? g.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = qm((C) => {
      const R = C.target, D = [...l.branches].some((I) => I.contains(R));
      !b || D || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m), T = Zm((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m);
    return Hm((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, m), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (pi = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), mi(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = pi);
        };
    }, [d, m, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), mi());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(Tr, C), () => document.removeEventListener(Tr, C);
    }, []), /* @__PURE__ */ p(
      rt.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ze(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: Ze(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: Ze(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
Ys.displayName = jm;
var Ym = "DismissableLayerBranch", Xm = c.forwardRef((e, t) => {
  const n = c.useContext(Gs), r = c.useRef(null), o = Nt(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ p(rt.div, { ...e, ref: o });
});
Xm.displayName = Ym;
function qm(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qt(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          Xs(
            Km,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Zm(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Qt(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Xs(Gm, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function mi() {
  const e = new CustomEvent(Tr);
  document.dispatchEvent(e);
}
function Xs(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? zm(o, i) : o.dispatchEvent(i);
}
function gi(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Qm(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = gi(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : gi(e[o], null);
        }
      };
  };
}
function Jm(...e) {
  return c.useCallback(Qm(...e), e);
}
var eg = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], tg = eg.reduce((e, t) => {
  const n = c.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Ln : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function hi(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var er = "focusScope.autoFocusOnMount", tr = "focusScope.autoFocusOnUnmount", vi = { bubbles: !1, cancelable: !0 }, ng = "FocusScope", qs = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, u] = c.useState(null), l = hi(o), d = hi(i), f = c.useRef(null), m = Jm(t, (g) => u(g)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (v.paused || !a)
          return;
        const b = x.target;
        a.contains(b) ? f.current = b : Ge(f.current, { select: !0 });
      }, h = function(x) {
        if (v.paused || !a)
          return;
        const b = x.relatedTarget;
        b !== null && (a.contains(b) || Ge(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Ge(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", h);
      const E = new MutationObserver(y);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", h), E.disconnect();
      };
    }
  }, [r, a, v.paused]), c.useEffect(() => {
    if (a) {
      bi.add(v);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(er, vi);
        a.addEventListener(er, l), a.dispatchEvent(y), y.defaultPrevented || (rg(cg(Zs(a)), { select: !0 }), document.activeElement === g && Ge(a));
      }
      return () => {
        a.removeEventListener(er, l), setTimeout(() => {
          const y = new CustomEvent(tr, vi);
          a.addEventListener(tr, d), a.dispatchEvent(y), y.defaultPrevented || Ge(g ?? document.body, { select: !0 }), a.removeEventListener(tr, d), bi.remove(v);
        }, 0);
      };
    }
  }, [a, l, d, v]);
  const w = c.useCallback(
    (g) => {
      if (!n && !r || v.paused)
        return;
      const h = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (h && y) {
        const E = g.currentTarget, [x, b] = og(E);
        x && b ? !g.shiftKey && y === b ? (g.preventDefault(), n && Ge(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && Ge(b, { select: !0 })) : y === E && g.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ p(tg.div, { tabIndex: -1, ...s, ref: m, onKeyDown: w });
});
qs.displayName = ng;
function rg(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ge(r, { select: t }), document.activeElement !== n)
      return;
}
function og(e) {
  const t = Zs(e), n = yi(t, e), r = yi(t.reverse(), e);
  return [n, r];
}
function Zs(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function yi(e, t) {
  for (const n of e)
    if (!ig(n, { upTo: t }))
      return n;
}
function ig(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ag(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ge(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && ag(e) && t && e.select();
  }
}
var bi = sg();
function sg() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = wi(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = wi(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function wi(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function cg(e) {
  return e.filter((t) => t.tagName !== "A");
}
var lg = "Portal", Qs = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  Rn(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? zr.createPortal(/* @__PURE__ */ p(rt.div, { ...r, ref: t }), s) : null;
});
Qs.displayName = lg;
function ug(e, t) {
  return c.useReducer((n, r) => t[n][r] ?? n, e);
}
var Fn = (e) => {
  const { present: t, children: n } = e, r = dg(t), o = typeof n == "function" ? n({ present: r.isPresent }) : c.Children.only(n), i = Nt(r.ref, fg(o));
  return typeof n == "function" || r.isPresent ? c.cloneElement(o, { ref: i }) : null;
};
Fn.displayName = "Presence";
function dg(e) {
  const [t, n] = c.useState(), r = c.useRef({}), o = c.useRef(e), i = c.useRef("none"), s = e ? "mounted" : "unmounted", [a, u] = ug(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const l = fn(r.current);
    i.current = a === "mounted" ? l : "none";
  }, [a]), Rn(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const m = i.current, v = fn(l);
      e ? u("MOUNT") : v === "none" || (l == null ? void 0 : l.display) === "none" ? u("UNMOUNT") : u(d && m !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, u]), Rn(() => {
    if (t) {
      let l;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const g = fn(r.current).includes(v.animationName);
        if (v.target === t && g && (u("ANIMATION_END"), !o.current)) {
          const h = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = h);
          });
        }
      }, m = (v) => {
        v.target === t && (i.current = fn(r.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(l), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      u("ANIMATION_END");
  }, [t, u]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: c.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function fn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function fg(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var nr = 0;
function pg() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xi()), document.body.insertAdjacentElement("beforeend", e[1] ?? xi()), nr++, () => {
      nr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), nr--;
    };
  }, []);
}
function xi() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var po = "Dialog", [Js, Hy] = Om(po), [mg, Se] = Js(po), ec = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = c.useRef(null), u = c.useRef(null), [l = !1, d] = $m({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ p(
    mg,
    {
      scope: t,
      triggerRef: a,
      contentRef: u,
      contentId: Jn(),
      titleId: Jn(),
      descriptionId: Jn(),
      open: l,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: n
    }
  );
};
ec.displayName = po;
var tc = "DialogTrigger", nc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Se(tc, n), i = Nt(t, o.triggerRef);
    return /* @__PURE__ */ p(
      rt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": ho(o.open),
        ...r,
        ref: i,
        onClick: Ze(e.onClick, o.onOpenToggle)
      }
    );
  }
);
nc.displayName = tc;
var mo = "DialogPortal", [gg, rc] = Js(mo, {
  forceMount: void 0
}), oc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Se(mo, t);
  return /* @__PURE__ */ p(gg, { scope: t, forceMount: n, children: c.Children.map(r, (s) => /* @__PURE__ */ p(Fn, { present: n || i.open, children: /* @__PURE__ */ p(Qs, { asChild: !0, container: o, children: s }) })) });
};
oc.displayName = mo;
var Tn = "DialogOverlay", ic = c.forwardRef(
  (e, t) => {
    const n = rc(Tn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Se(Tn, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ p(Fn, { present: r || i.open, children: /* @__PURE__ */ p(hg, { ...o, ref: t }) }) : null;
  }
);
ic.displayName = Tn;
var hg = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Se(Tn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(ro, { as: Ln, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p(
        rt.div,
        {
          "data-state": ho(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), ct = "DialogContent", ac = c.forwardRef(
  (e, t) => {
    const n = rc(ct, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Se(ct, e.__scopeDialog);
    return /* @__PURE__ */ p(Fn, { present: r || i.open, children: i.modal ? /* @__PURE__ */ p(vg, { ...o, ref: t }) : /* @__PURE__ */ p(yg, { ...o, ref: t }) });
  }
);
ac.displayName = ct;
var vg = c.forwardRef(
  (e, t) => {
    const n = Se(ct, e.__scopeDialog), r = c.useRef(null), o = Nt(t, n.contentRef, r);
    return c.useEffect(() => {
      const i = r.current;
      if (i)
        return no(i);
    }, []), /* @__PURE__ */ p(
      sc,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ze(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: Ze(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: Ze(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), yg = c.forwardRef(
  (e, t) => {
    const n = Se(ct, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ p(
      sc,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var u, l;
          (u = e.onInteractOutside) == null || u.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), sc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = Se(ct, n), u = c.useRef(null), l = Nt(t, u);
    return pg(), /* @__PURE__ */ V(Qe, { children: [
      /* @__PURE__ */ p(
        qs,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ p(
            Ys,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": ho(a.open),
              ...s,
              ref: l,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(Qe, { children: [
        /* @__PURE__ */ p(bg, { titleId: a.titleId }),
        /* @__PURE__ */ p(xg, { contentRef: u, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), go = "DialogTitle", cc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Se(go, n);
    return /* @__PURE__ */ p(rt.h2, { id: o.titleId, ...r, ref: t });
  }
);
cc.displayName = go;
var lc = "DialogDescription", uc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Se(lc, n);
    return /* @__PURE__ */ p(rt.p, { id: o.descriptionId, ...r, ref: t });
  }
);
uc.displayName = lc;
var dc = "DialogClose", fc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Se(dc, n);
    return /* @__PURE__ */ p(
      rt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Ze(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
fc.displayName = dc;
function ho(e) {
  return e ? "open" : "closed";
}
var pc = "DialogTitleWarning", [jy, mc] = Dm(pc, {
  contentName: ct,
  titleName: go,
  docsSlug: "dialog"
}), bg = ({ titleId: e }) => {
  const t = mc(pc), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, wg = "DialogDescriptionWarning", xg = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${mc(wg).contentName}}.`;
  return c.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, Eg = ec, Cg = nc, Sg = oc, Rg = ic, Tg = ac, Ng = cc, Pg = uc, Ag = fc;
function Dg(e) {
  if (!e || typeof document > "u")
    return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const gc = N.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), Pt = () => {
  const e = N.useContext(gc);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
Dg(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Og() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function Mg() {
  return vo(/^Mac/);
}
function Ig() {
  return vo(/^iPhone/);
}
function Ei() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function _g() {
  return vo(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Mg() && navigator.maxTouchPoints > 1;
}
function hc() {
  return Ig() || _g();
}
function vo(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const $g = 24, kg = typeof window < "u" ? ki : be;
function Ci(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const rr = typeof document < "u" && window.visualViewport;
function Si(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function vc(e) {
  for (Si(e) && (e = e.parentElement); e && !Si(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const Lg = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let pn = 0, or;
function Fg(e = {}) {
  let { isDisabled: t } = e;
  kg(() => {
    if (!t)
      return pn++, pn === 1 && hc() && (or = Wg()), () => {
        pn--, pn === 0 && (or == null || or());
      };
  }, [
    t
  ]);
}
function Wg() {
  let e, t = 0, n = (f) => {
    e = vc(f.target), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    let m = f.changedTouches[0].pageY, v = e.scrollTop, w = e.scrollHeight - e.clientHeight;
    w !== 0 && ((v <= 0 && m > t || v >= w && m < t) && f.preventDefault(), t = m);
  }, o = (f) => {
    let m = f.target;
    Nr(m) && m !== document.activeElement && (f.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, i = (f) => {
    let m = f.target;
    Nr(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", rr && (rr.height < window.innerHeight ? requestAnimationFrame(() => {
        Ri(m);
      }) : rr.addEventListener("resize", () => Ri(m), {
        once: !0
      }));
    }));
  }, s = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, u = window.pageYOffset, l = Ci(Bg(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let d = Ci(kt(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), kt(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), kt(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), kt(document, "focus", i, !0), kt(window, "scroll", s));
  return () => {
    l(), d(), window.scrollTo(a, u);
  };
}
function Bg(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function kt(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Ri(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = vc(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const s = n.getBoundingClientRect().bottom + $g;
      i > s && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function Nr(e) {
  return e instanceof HTMLInputElement && !Lg.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function Vg(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Ug(...e) {
  return (t) => e.forEach((n) => Vg(n, t));
}
function yc(...e) {
  return c.useCallback(Ug(...e), e);
}
const bc = /* @__PURE__ */ new WeakMap();
function te(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && bc.set(e, r);
}
function zg(e, t) {
  if (!e || !(e instanceof HTMLElement))
    return;
  let n = bc.get(e);
  n && (e.style[t] = n[t]);
}
const ee = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function mn(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[ee(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[ee(t) ? 5 : 4]) : null);
}
function Hg(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function ir(e, t) {
  if (!e)
    return () => {
    };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function jg(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Q = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, wc = 0.4, Kg = 0.25, Gg = 100, xc = 8, it = 16, Pr = 26, ar = "vaul-dragging";
function Ec(e) {
  const t = N.useRef(e);
  return N.useEffect(() => {
    t.current = e;
  }), N.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function Yg({ defaultProp: e, onChange: t }) {
  const n = N.useState(e), [r] = n, o = N.useRef(r), i = Ec(t);
  return N.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function Cc({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = Yg({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, s = i ? e : r, a = Ec(n), u = N.useCallback((l) => {
    if (i) {
      const f = typeof l == "function" ? l(e) : l;
      f !== e && a(f);
    } else
      o(l);
  }, [
    i,
    e,
    o,
    a
  ]);
  return [
    s,
    u
  ];
}
function Xg({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: s, direction: a = "bottom", container: u, snapToSequentialPoint: l }) {
  const [d, f] = Cc({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [m, v] = N.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  N.useEffect(() => {
    function C() {
      v({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", C), () => window.removeEventListener("resize", C);
  }, []);
  const w = N.useMemo(() => d === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    d
  ]), g = N.useMemo(() => {
    var C;
    return (C = n == null ? void 0 : n.findIndex((R) => R === d)) != null ? C : null;
  }, [
    n,
    d
  ]), h = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === d || !n, y = N.useMemo(() => {
    const C = u ? {
      width: u.getBoundingClientRect().width,
      height: u.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var R;
    return (R = n == null ? void 0 : n.map((D) => {
      const I = typeof D == "string";
      let L = 0;
      if (I && (L = parseInt(D, 10)), ee(a)) {
        const P = I ? L : m ? D * C.height : 0;
        return m ? a === "bottom" ? C.height - P : -C.height + P : P;
      }
      const O = I ? L : m ? D * C.width : 0;
      return m ? a === "right" ? C.width - O : -C.width + O : O;
    })) != null ? R : [];
  }, [
    n,
    m,
    u
  ]), E = N.useMemo(() => g !== null ? y == null ? void 0 : y[g] : null, [
    y,
    g
  ]), x = N.useCallback((C) => {
    var R;
    const D = (R = y == null ? void 0 : y.findIndex((I) => I === C)) != null ? R : null;
    s(D), te(r.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(a) ? `translate3d(0, ${C}px, 0)` : `translate3d(${C}px, 0, 0)`
    }), y && D !== y.length - 1 && i !== void 0 && D !== i && D < i ? te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "0"
    }) : te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(D, 0)]);
  }, [
    r.current,
    n,
    y,
    i,
    o,
    f
  ]);
  N.useEffect(() => {
    if (d || e) {
      var C;
      const R = (C = n == null ? void 0 : n.findIndex((D) => D === e || D === d)) != null ? C : -1;
      y && R !== -1 && typeof y[R] == "number" && x(y[R]);
    }
  }, [
    d,
    e,
    n,
    y,
    x
  ]);
  function b({ draggedDistance: C, closeDrawer: R, velocity: D, dismissible: I }) {
    if (i === void 0)
      return;
    const L = a === "bottom" || a === "right" ? (E ?? 0) - C : (E ?? 0) + C, O = g === i - 1, P = g === 0, A = C > 0;
    if (O && te(o.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`
    }), !l && D > 2 && !A) {
      I ? R() : x(y[0]);
      return;
    }
    if (!l && D > 2 && A && y && n) {
      x(y[n.length - 1]);
      return;
    }
    const W = y == null ? void 0 : y.reduce((U, _) => typeof U != "number" || typeof _ != "number" ? U : Math.abs(_ - L) < Math.abs(U - L) ? _ : U), $ = ee(a) ? window.innerHeight : window.innerWidth;
    if (D > wc && Math.abs(C) < $ * 0.4) {
      const U = A ? 1 : -1;
      if (U > 0 && w && n) {
        x(y[n.length - 1]);
        return;
      }
      if (P && U < 0 && I && R(), g === null)
        return;
      x(y[g + U]);
      return;
    }
    x(W);
  }
  function S({ draggedDistance: C }) {
    if (E === null)
      return;
    const R = a === "bottom" || a === "right" ? E - C : E + C;
    (a === "bottom" || a === "right") && R < y[y.length - 1] || (a === "top" || a === "left") && R > y[y.length - 1] || te(r.current, {
      transform: ee(a) ? `translate3d(0, ${R}px, 0)` : `translate3d(${R}px, 0, 0)`
    });
  }
  function T(C, R) {
    if (!n || typeof g != "number" || !y || i === void 0)
      return null;
    const D = g === i - 1;
    if (g >= i && R)
      return 0;
    if (D && !R)
      return 1;
    if (!h && !D)
      return null;
    const L = D ? g + 1 : g - 1, O = D ? y[L] - y[L - 1] : y[L + 1] - y[L], P = C / Math.abs(O);
    return D ? 1 - P : P;
  }
  return {
    isLastSnapPoint: w,
    activeSnapPoint: d,
    shouldFade: h,
    getPercentageDragged: T,
    setActiveSnapPoint: f,
    activeSnapPointIndex: g,
    onRelease: b,
    onDrag: S,
    snapPointsOffset: y
  };
}
const qg = () => () => {
};
function Zg() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = Pt(), i = N.useRef(null), s = Ut(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - Pr) / window.innerWidth;
  }
  N.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const u = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!u)
        return;
      jg(r && !o ? ir(document.body, {
        background: "black"
      }) : qg, ir(u, {
        transformOrigin: ee(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Q.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Q.EASE.join(",")})`
      }));
      const l = ir(u, {
        borderRadius: `${xc}px`,
        overflow: "hidden",
        ...ee(e) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        l(), i.current = window.setTimeout(() => {
          s ? document.body.style.background = s : document.body.style.removeProperty("background");
        }, Q.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    s
  ]);
}
let Lt = null;
function Qg({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [s, a] = N.useState(() => typeof window < "u" ? window.location.href : ""), u = N.useRef(0), l = N.useCallback(() => {
    if (Ei() && Lt === null && e && !i) {
      Lt = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-u.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const v = m - window.innerHeight;
        v && u.current >= m && (document.body.style.top = `${-(u.current + v)}px`);
      }), 300);
    }
  }, [
    e
  ]), d = N.useCallback(() => {
    if (Ei() && Lt !== null && !i) {
      const f = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Lt), window.requestAnimationFrame(() => {
        if (o && s !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(m, f);
      }), Lt = null;
    }
  }, [
    s
  ]);
  return N.useEffect(() => {
    function f() {
      u.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), N.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || d();
      };
  }, [
    t,
    d
  ]), N.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && l(), t || window.setTimeout(() => {
      d();
    }, 500)) : d());
  }, [
    e,
    r,
    s,
    t,
    n,
    l,
    d
  ]), {
    restorePositionSetting: d
  };
}
function Sc({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: s = !1, setBackgroundColorOnScale: a = !0, closeThreshold: u = Kg, scrollLockTimeout: l = Gg, dismissible: d = !0, handleOnly: f = !1, fadeFromIndex: m = i && i.length - 1, activeSnapPoint: v, setActiveSnapPoint: w, fixed: g, modal: h = !0, onClose: y, nested: E, noBodyStyles: x = !1, direction: b = "bottom", defaultOpen: S = !1, disablePreventScroll: T = !0, snapToSequentialPoint: C = !1, preventScrollRestoration: R = !1, repositionInputs: D = !0, onAnimationEnd: I, container: L, autoFocus: O = !1 }) {
  var P, A;
  const [W = !1, $] = Cc({
    defaultProp: S,
    prop: e,
    onChange: (B) => {
      t == null || t(B), !B && !E && El(), setTimeout(() => {
        I == null || I(B);
      }, Q.DURATION * 1e3), B && !h && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), B || (document.body.style.pointerEvents = "auto");
    }
  }), [U, _] = N.useState(!1), [M, j] = N.useState(!1), [G, ie] = N.useState(!1), ae = N.useRef(null), fe = N.useRef(null), Be = N.useRef(null), he = N.useRef(null), le = N.useRef(null), ve = N.useRef(!1), se = N.useRef(null), _e = N.useRef(0), $e = N.useRef(!1), Dt = N.useRef(!S), Ve = N.useRef(0), z = N.useRef(null), tn = N.useRef(((P = z.current) == null ? void 0 : P.getBoundingClientRect().height) || 0), nn = N.useRef(((A = z.current) == null ? void 0 : A.getBoundingClientRect().width) || 0), Ot = N.useRef(0), Vn = N.useCallback((B) => {
    i && B === Mt.length - 1 && (fe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: ft, activeSnapPointIndex: pt, setActiveSnapPoint: Io, onRelease: bl, snapPointsOffset: Mt, onDrag: wl, shouldFade: _o, getPercentageDragged: xl } = Xg({
    snapPoints: i,
    activeSnapPointProp: v,
    setActiveSnapPointProp: w,
    drawerRef: z,
    fadeFromIndex: m,
    overlayRef: ae,
    onSnapPointChange: Vn,
    direction: b,
    container: L,
    snapToSequentialPoint: C
  });
  Fg({
    isDisabled: !W || M || !h || G || !U || !D || !T
  });
  const { restorePositionSetting: El } = Qg({
    isOpen: W,
    modal: h,
    nested: E ?? !1,
    hasBeenOpened: U,
    preventScrollRestoration: R,
    noBodyStyles: x
  });
  function rn() {
    return (window.innerWidth - Pr) / window.innerWidth;
  }
  function Cl(B) {
    var Y, X;
    !d && !i || z.current && !z.current.contains(B.target) || (tn.current = ((Y = z.current) == null ? void 0 : Y.getBoundingClientRect().height) || 0, nn.current = ((X = z.current) == null ? void 0 : X.getBoundingClientRect().width) || 0, j(!0), Be.current = /* @__PURE__ */ new Date(), hc() && window.addEventListener("touchend", () => ve.current = !1, {
      once: !0
    }), B.target.setPointerCapture(B.pointerId), _e.current = ee(b) ? B.pageY : B.pageX);
  }
  function $o(B, Y) {
    var X;
    let K = B;
    const J = (X = window.getSelection()) == null ? void 0 : X.toString(), de = z.current ? mn(z.current, b) : null, ue = /* @__PURE__ */ new Date();
    if (K.tagName === "SELECT" || K.hasAttribute("data-vaul-no-drag") || K.closest("[data-vaul-no-drag]"))
      return !1;
    if (b === "right" || b === "left")
      return !0;
    if (fe.current && ue.getTime() - fe.current.getTime() < 500)
      return !1;
    if (de !== null && (b === "bottom" ? de > 0 : de < 0))
      return !0;
    if (J && J.length > 0)
      return !1;
    if (le.current && ue.getTime() - le.current.getTime() < l && de === 0 || Y)
      return le.current = ue, !1;
    for (; K; ) {
      if (K.scrollHeight > K.clientHeight) {
        if (K.scrollTop !== 0)
          return le.current = /* @__PURE__ */ new Date(), !1;
        if (K.getAttribute("role") === "dialog")
          return !0;
      }
      K = K.parentNode;
    }
    return !0;
  }
  function Sl(B) {
    if (z.current && M) {
      const Y = b === "bottom" || b === "right" ? 1 : -1, X = (_e.current - (ee(b) ? B.pageY : B.pageX)) * Y, K = X > 0, J = i && !d && !K;
      if (J && pt === 0)
        return;
      const de = Math.abs(X), ue = document.querySelector("[data-vaul-drawer-wrapper]"), Ue = b === "bottom" || b === "top" ? tn.current : nn.current;
      let ye = de / Ue;
      const ot = xl(de, K);
      if (ot !== null && (ye = ot), J && ye >= 1 || !ve.current && !$o(B.target, K))
        return;
      if (z.current.classList.add(ar), ve.current = !0, te(z.current, {
        transition: "none"
      }), te(ae.current, {
        transition: "none"
      }), i && wl({
        draggedDistance: X
      }), K && !i) {
        const Te = Hg(X), on = Math.min(Te * -1, 0) * Y;
        te(z.current, {
          transform: ee(b) ? `translate3d(0, ${on}px, 0)` : `translate3d(${on}px, 0, 0)`
        });
        return;
      }
      const ze = 1 - ye;
      if ((_o || m && pt === m - 1) && (r == null || r(B, ye), te(ae.current, {
        opacity: `${ze}`,
        transition: "none"
      }, !0)), ue && ae.current && s) {
        const Te = Math.min(rn() + ye * (1 - rn()), 1), on = 8 - ye * 8, Lo = Math.max(0, 14 - ye * 14);
        te(ue, {
          borderRadius: `${on}px`,
          transform: ee(b) ? `scale(${Te}) translate3d(0, ${Lo}px, 0)` : `scale(${Te}) translate3d(${Lo}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const Te = de * Y;
        te(z.current, {
          transform: ee(b) ? `translate3d(0, ${Te}px, 0)` : `translate3d(${Te}px, 0, 0)`
        });
      }
    }
  }
  N.useEffect(() => {
    window.requestAnimationFrame(() => {
      Dt.current = !0;
    });
  }, []), N.useEffect(() => {
    var B;
    function Y() {
      if (!z.current || !D)
        return;
      const X = document.activeElement;
      if (Nr(X) || $e.current) {
        var K;
        const J = ((K = window.visualViewport) == null ? void 0 : K.height) || 0, de = window.innerHeight;
        let ue = de - J;
        const Ue = z.current.getBoundingClientRect().height || 0, ye = Ue > de * 0.8;
        Ot.current || (Ot.current = Ue);
        const ot = z.current.getBoundingClientRect().top;
        if (Math.abs(Ve.current - ue) > 60 && ($e.current = !$e.current), i && i.length > 0 && Mt && pt) {
          const ze = Mt[pt] || 0;
          ue += ze;
        }
        if (Ve.current = ue, Ue > J || $e.current) {
          const ze = z.current.getBoundingClientRect().height;
          let Te = ze;
          ze > J && (Te = J - (ye ? ot : Pr)), g ? z.current.style.height = `${ze - Math.max(ue, 0)}px` : z.current.style.height = `${Math.max(Te, J - ot)}px`;
        } else
          Og() || (z.current.style.height = `${Ot.current}px`);
        i && i.length > 0 && !$e.current ? z.current.style.bottom = "0px" : z.current.style.bottom = `${Math.max(ue, 0)}px`;
      }
    }
    return (B = window.visualViewport) == null || B.addEventListener("resize", Y), () => {
      var X;
      return (X = window.visualViewport) == null ? void 0 : X.removeEventListener("resize", Y);
    };
  }, [
    pt,
    i,
    Mt
  ]);
  function It(B) {
    Rl(), y == null || y(), B || $(!1), setTimeout(() => {
      i && Io(i[0]);
    }, Q.DURATION * 1e3);
  }
  function ko() {
    if (!z.current)
      return;
    const B = document.querySelector("[data-vaul-drawer-wrapper]"), Y = mn(z.current, b);
    te(z.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`
    }), te(ae.current, {
      transition: `opacity ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      opacity: "1"
    }), s && Y && Y > 0 && W && te(B, {
      borderRadius: `${xc}px`,
      overflow: "hidden",
      ...ee(b) ? {
        transform: `scale(${rn()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${rn()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Q.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Q.EASE.join(",")})`
    }, !0);
  }
  function Rl() {
    !M || !z.current || (z.current.classList.remove(ar), ve.current = !1, j(!1), he.current = /* @__PURE__ */ new Date());
  }
  function Tl(B) {
    if (!M || !z.current)
      return;
    z.current.classList.remove(ar), ve.current = !1, j(!1), he.current = /* @__PURE__ */ new Date();
    const Y = mn(z.current, b);
    if (!B || !$o(B.target, !1) || !Y || Number.isNaN(Y) || Be.current === null)
      return;
    const X = he.current.getTime() - Be.current.getTime(), K = _e.current - (ee(b) ? B.pageY : B.pageX), J = Math.abs(K) / X;
    if (J > 0.05 && (ie(!0), setTimeout(() => {
      ie(!1);
    }, 200)), i) {
      bl({
        draggedDistance: K * (b === "bottom" || b === "right" ? 1 : -1),
        closeDrawer: It,
        velocity: J,
        dismissible: d
      }), o == null || o(B, !0);
      return;
    }
    if (b === "bottom" || b === "right" ? K > 0 : K < 0) {
      ko(), o == null || o(B, !0);
      return;
    }
    if (J > wc) {
      It(), o == null || o(B, !1);
      return;
    }
    var de;
    const ue = Math.min((de = z.current.getBoundingClientRect().height) != null ? de : 0, window.innerHeight);
    var Ue;
    const ye = Math.min((Ue = z.current.getBoundingClientRect().width) != null ? Ue : 0, window.innerWidth), ot = b === "left" || b === "right";
    if (Math.abs(Y) >= (ot ? ye : ue) * u) {
      It(), o == null || o(B, !1);
      return;
    }
    o == null || o(B, !0), ko();
  }
  N.useEffect(() => (W && (te(document.documentElement, {
    scrollBehavior: "auto"
  }), fe.current = /* @__PURE__ */ new Date()), () => {
    zg(document.documentElement, "scrollBehavior");
  }), [
    W
  ]);
  function Nl(B) {
    const Y = B ? (window.innerWidth - it) / window.innerWidth : 1, X = B ? -it : 0;
    se.current && window.clearTimeout(se.current), te(z.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(b) ? `scale(${Y}) translate3d(0, ${X}px, 0)` : `scale(${Y}) translate3d(${X}px, 0, 0)`
    }), !B && z.current && (se.current = setTimeout(() => {
      const K = mn(z.current, b);
      te(z.current, {
        transition: "none",
        transform: ee(b) ? `translate3d(0, ${K}px, 0)` : `translate3d(${K}px, 0, 0)`
      });
    }, 500));
  }
  function Pl(B, Y) {
    if (Y < 0)
      return;
    const X = (window.innerWidth - it) / window.innerWidth, K = X + Y * (1 - X), J = -it + Y * it;
    te(z.current, {
      transform: ee(b) ? `scale(${K}) translate3d(0, ${J}px, 0)` : `scale(${K}) translate3d(${J}px, 0, 0)`,
      transition: "none"
    });
  }
  function Al(B, Y) {
    const X = ee(b) ? window.innerHeight : window.innerWidth, K = Y ? (X - it) / X : 1, J = Y ? -it : 0;
    Y && te(z.current, {
      transition: `transform ${Q.DURATION}s cubic-bezier(${Q.EASE.join(",")})`,
      transform: ee(b) ? `scale(${K}) translate3d(0, ${J}px, 0)` : `scale(${K}) translate3d(${J}px, 0, 0)`
    });
  }
  return N.useEffect(() => {
    h || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    h
  ]), /* @__PURE__ */ N.createElement(Eg, {
    defaultOpen: S,
    onOpenChange: (B) => {
      !d && !B || (B ? _(!0) : It(!0), $(B));
    },
    open: W
  }, /* @__PURE__ */ N.createElement(gc.Provider, {
    value: {
      activeSnapPoint: ft,
      snapPoints: i,
      setActiveSnapPoint: Io,
      drawerRef: z,
      overlayRef: ae,
      onOpenChange: t,
      onPress: Cl,
      onRelease: Tl,
      onDrag: Sl,
      dismissible: d,
      shouldAnimate: Dt,
      handleOnly: f,
      isOpen: W,
      isDragging: M,
      shouldFade: _o,
      closeDrawer: It,
      onNestedDrag: Pl,
      onNestedOpenChange: Nl,
      onNestedRelease: Al,
      keyboardIsOpen: $e,
      modal: h,
      snapPointsOffset: Mt,
      activeSnapPointIndex: pt,
      direction: b,
      shouldScaleBackground: s,
      setBackgroundColorOnScale: a,
      noBodyStyles: x,
      container: L,
      autoFocus: O
    }
  }, n));
}
const Rc = /* @__PURE__ */ N.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: s, modal: a, shouldAnimate: u } = Pt(), l = yc(t, n), d = r && r.length > 0;
  if (!a)
    return null;
  const f = N.useCallback((m) => o(m), [
    o
  ]);
  return /* @__PURE__ */ N.createElement(Rg, {
    onMouseUp: f,
    ref: l,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": s && d ? "true" : "false",
    "data-vaul-snap-points-overlay": s && i ? "true" : "false",
    "data-vaul-animate": u != null && u.current ? "true" : "false",
    ...e
  });
});
Rc.displayName = "Drawer.Overlay";
const Tc = /* @__PURE__ */ N.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: s, onRelease: a, onDrag: u, keyboardIsOpen: l, snapPointsOffset: d, activeSnapPointIndex: f, modal: m, isOpen: v, direction: w, snapPoints: g, container: h, handleOnly: y, shouldAnimate: E, autoFocus: x } = Pt(), [b, S] = N.useState(!1), T = yc(o, i), C = N.useRef(null), R = N.useRef(null), D = N.useRef(!1), I = g && g.length > 0;
  Zg();
  const L = (P, A, W = 0) => {
    if (D.current)
      return !0;
    const $ = Math.abs(P.y), U = Math.abs(P.x), _ = U > $, M = [
      "bottom",
      "right"
    ].includes(A) ? 1 : -1;
    if (A === "left" || A === "right") {
      if (!(P.x * M < 0) && U >= 0 && U <= W)
        return _;
    } else if (!(P.y * M < 0) && $ >= 0 && $ <= W)
      return !_;
    return D.current = !0, !0;
  };
  N.useEffect(() => {
    I && window.requestAnimationFrame(() => {
      S(!0);
    });
  }, []);
  function O(P) {
    C.current = null, D.current = !1, a(P);
  }
  return /* @__PURE__ */ N.createElement(Tg, {
    "data-vaul-drawer-direction": w,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": b ? "true" : "false",
    "data-vaul-snap-points": v && I ? "true" : "false",
    "data-vaul-custom-container": h ? "true" : "false",
    "data-vaul-animate": E != null && E.current ? "true" : "false",
    ...r,
    ref: T,
    style: d && d.length > 0 ? {
      "--snap-point-height": `${d[f ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (P) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, P), C.current = {
        x: P.pageX,
        y: P.pageY
      }, s(P));
    },
    onOpenAutoFocus: (P) => {
      n == null || n(P), x || P.preventDefault();
    },
    onPointerDownOutside: (P) => {
      if (e == null || e(P), !m || P.defaultPrevented) {
        P.preventDefault();
        return;
      }
      l.current && (l.current = !1);
    },
    onFocusOutside: (P) => {
      if (!m) {
        P.preventDefault();
        return;
      }
    },
    onPointerMove: (P) => {
      if (R.current = P, y || (r.onPointerMove == null || r.onPointerMove.call(r, P), !C.current))
        return;
      const A = P.pageY - C.current.y, W = P.pageX - C.current.x, $ = P.pointerType === "touch" ? 10 : 2;
      L({
        x: W,
        y: A
      }, w, $) ? u(P) : (Math.abs(W) > $ || Math.abs(A) > $) && (C.current = null);
    },
    onPointerUp: (P) => {
      r.onPointerUp == null || r.onPointerUp.call(r, P), C.current = null, D.current = !1, a(P);
    },
    onPointerOut: (P) => {
      r.onPointerOut == null || r.onPointerOut.call(r, P), O(R.current);
    },
    onContextMenu: (P) => {
      r.onContextMenu == null || r.onContextMenu.call(r, P), R.current && O(R.current);
    }
  });
});
Tc.displayName = "Drawer.Content";
const Jg = 250, eh = 120, Nc = /* @__PURE__ */ N.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: s, activeSnapPoint: a, setActiveSnapPoint: u, dismissible: l, handleOnly: d, isOpen: f, onPress: m, onDrag: v } = Pt(), w = N.useRef(null), g = N.useRef(!1);
  function h() {
    if (g.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      y();
    }, eh);
  }
  function y() {
    if (i || e || g.current) {
      x();
      return;
    }
    if (x(), !s || s.length === 0) {
      l || o();
      return;
    }
    if (a === s[s.length - 1] && l) {
      o();
      return;
    }
    const S = s.findIndex((C) => C === a);
    if (S === -1)
      return;
    const T = s[S + 1];
    u(T);
  }
  function E() {
    w.current = window.setTimeout(() => {
      g.current = !0;
    }, Jg);
  }
  function x() {
    w.current && window.clearTimeout(w.current), g.current = !1;
  }
  return /* @__PURE__ */ N.createElement("div", {
    onClick: h,
    onPointerCancel: x,
    onPointerDown: (b) => {
      d && m(b), E();
    },
    onPointerMove: (b) => {
      d && v(b);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ N.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
Nc.displayName = "Drawer.Handle";
function th({ onDrag: e, onOpenChange: t, open: n, ...r }) {
  const { onNestedDrag: o, onNestedOpenChange: i, onNestedRelease: s } = Pt();
  if (!o)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ N.createElement(Sc, {
    nested: !0,
    open: n,
    onClose: () => {
      i(!1);
    },
    onDrag: (a, u) => {
      o(a, u), e == null || e(a, u);
    },
    onOpenChange: (a) => {
      a && i(a), t == null || t(a);
    },
    onRelease: s,
    ...r
  });
}
function nh(e) {
  const t = Pt(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ N.createElement(Sg, {
    container: n,
    ...r
  });
}
const Ft = {
  Root: Sc,
  NestedRoot: th,
  Content: Tc,
  Overlay: Rc,
  Trigger: Cg,
  Portal: nh,
  Handle: Nc,
  Close: Ag,
  Title: Ng,
  Description: Pg
};
// @__NO_SIDE_EFFECTS__
function rh(e) {
  const t = /* @__PURE__ */ oh(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(ah);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function oh(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = ch(o), a = sh(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ih = Symbol("radix.slottable");
function ah(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ih;
}
function sh(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function ch(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var lh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Pc = lh.reduce((e, t) => {
  const n = /* @__PURE__ */ rh(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function uh(e, t) {
  e && Et.flushSync(() => e.dispatchEvent(t));
}
var dh = "DismissableLayer", Ar = "dismissableLayer.update", fh = "dismissableLayer.pointerDownOutside", ph = "dismissableLayer.focusOutside", Ti, Ac = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), yo = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: s,
      onDismiss: a,
      ...u
    } = e, l = c.useContext(Ac), [d, f] = c.useState(null), m = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = q(t, (C) => f(C)), g = Array.from(l.layers), [h] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(h), E = d ? g.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, b = E >= y, S = gh((C) => {
      const R = C.target, D = [...l.branches].some((I) => I.contains(R));
      !b || D || (o == null || o(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m), T = hh((C) => {
      const R = C.target;
      [...l.branches].some((I) => I.contains(R)) || (i == null || i(C), s == null || s(C), C.defaultPrevented || a == null || a());
    }, m);
    return ra((C) => {
      E === l.layers.size - 1 && (r == null || r(C), !C.defaultPrevented && a && (C.preventDefault(), a()));
    }, m), c.useEffect(() => {
      if (d)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Ti = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), Ni(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Ti);
        };
    }, [d, m, n, l]), c.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), Ni());
    }, [d, l]), c.useEffect(() => {
      const C = () => v({});
      return document.addEventListener(Ar, C), () => document.removeEventListener(Ar, C);
    }, []), /* @__PURE__ */ p(
      Pc.div,
      {
        ...u,
        ref: w,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: k(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: k(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: k(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
yo.displayName = dh;
var mh = "DismissableLayerBranch", Dc = c.forwardRef((e, t) => {
  const n = c.useContext(Ac), r = c.useRef(null), o = q(t, r);
  return c.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ p(Pc.div, { ...e, ref: o });
});
Dc.displayName = mh;
function gh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = c.useRef(!1), o = c.useRef(() => {
  });
  return c.useEffect(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          Oc(
            fh,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: a };
        a.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, { once: !0 })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function hh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = ne(e), r = c.useRef(!1);
  return c.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && Oc(ph, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ni() {
  const e = new CustomEvent(Ar);
  document.dispatchEvent(e);
}
function Oc(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? uh(o, i) : o.dispatchEvent(i);
}
var vh = yo, yh = Dc;
// @__NO_SIDE_EFFECTS__
function bh(e) {
  const t = /* @__PURE__ */ wh(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(Eh);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function wh(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Sh(o), a = Ch(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var xh = Symbol("radix.slottable");
function Eh(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === xh;
}
function Ch(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Sh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Rh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], At = Rh.reduce((e, t) => {
  const n = /* @__PURE__ */ bh(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), sr = "focusScope.autoFocusOnMount", cr = "focusScope.autoFocusOnUnmount", Pi = { bubbles: !1, cancelable: !0 }, Th = "FocusScope", Mc = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...s
  } = e, [a, u] = c.useState(null), l = ne(o), d = ne(i), f = c.useRef(null), m = q(t, (g) => u(g)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (v.paused || !a)
          return;
        const b = x.target;
        a.contains(b) ? f.current = b : Ye(f.current, { select: !0 });
      }, h = function(x) {
        if (v.paused || !a)
          return;
        const b = x.relatedTarget;
        b !== null && (a.contains(b) || Ye(f.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const S of x)
            S.removedNodes.length > 0 && Ye(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", h);
      const E = new MutationObserver(y);
      return a && E.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", h), E.disconnect();
      };
    }
  }, [r, a, v.paused]), c.useEffect(() => {
    if (a) {
      Di.add(v);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(sr, Pi);
        a.addEventListener(sr, l), a.dispatchEvent(y), y.defaultPrevented || (Nh(Mh(Ic(a)), { select: !0 }), document.activeElement === g && Ye(a));
      }
      return () => {
        a.removeEventListener(sr, l), setTimeout(() => {
          const y = new CustomEvent(cr, Pi);
          a.addEventListener(cr, d), a.dispatchEvent(y), y.defaultPrevented || Ye(g ?? document.body, { select: !0 }), a.removeEventListener(cr, d), Di.remove(v);
        }, 0);
      };
    }
  }, [a, l, d, v]);
  const w = c.useCallback(
    (g) => {
      if (!n && !r || v.paused)
        return;
      const h = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (h && y) {
        const E = g.currentTarget, [x, b] = Ph(E);
        x && b ? !g.shiftKey && y === b ? (g.preventDefault(), n && Ye(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), n && Ye(b, { select: !0 })) : y === E && g.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ p(At.div, { tabIndex: -1, ...s, ref: m, onKeyDown: w });
});
Mc.displayName = Th;
function Nh(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Ye(r, { select: t }), document.activeElement !== n)
      return;
}
function Ph(e) {
  const t = Ic(e), n = Ai(t, e), r = Ai(t.reverse(), e);
  return [n, r];
}
function Ic(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Ai(e, t) {
  for (const n of e)
    if (!Ah(n, { upTo: t }))
      return n;
}
function Ah(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Dh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ye(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Dh(e) && t && e.select();
  }
}
var Di = Oh();
function Oh() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Oi(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Oi(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Oi(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Mh(e) {
  return e.filter((t) => t.tagName !== "A");
}
// @__NO_SIDE_EFFECTS__
function Ih(e) {
  const t = /* @__PURE__ */ _h(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(kh);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function _h(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Fh(o), a = Lh(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var $h = Symbol("radix.slottable");
function kh(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === $h;
}
function Lh(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Fh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Wh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Bh = Wh.reduce((e, t) => {
  const n = /* @__PURE__ */ Ih(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Vh = "Portal", bo = c.forwardRef((e, t) => {
  var a;
  const { container: n, ...r } = e, [o, i] = c.useState(!1);
  De(() => i(!0), []);
  const s = n || o && ((a = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : a.body);
  return s ? zr.createPortal(/* @__PURE__ */ p(Bh.div, { ...r, ref: t }), s) : null;
});
bo.displayName = Vh;
// @__NO_SIDE_EFFECTS__
function Uh(e) {
  const t = /* @__PURE__ */ zh(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(jh);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function zh(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = Gh(o), a = Kh(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Hh = Symbol("radix.slottable");
function jh(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Hh;
}
function Kh(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Gh(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Wn = "Dialog", [_c, Ky] = We(Wn), [Yh, Re] = _c(Wn), $c = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: s = !0
  } = e, a = c.useRef(null), u = c.useRef(null), [l, d] = St({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Wn
  });
  return /* @__PURE__ */ p(
    Yh,
    {
      scope: t,
      triggerRef: a,
      contentRef: u,
      contentId: qe(),
      titleId: qe(),
      descriptionId: qe(),
      open: l,
      onOpenChange: d,
      onOpenToggle: c.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: n
    }
  );
};
$c.displayName = Wn;
var kc = "DialogTrigger", Xh = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Re(kc, n), i = q(t, o.triggerRef);
    return /* @__PURE__ */ p(
      At.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Eo(o.open),
        ...r,
        ref: i,
        onClick: k(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Xh.displayName = kc;
var wo = "DialogPortal", [qh, Lc] = _c(wo, {
  forceMount: void 0
}), Fc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Re(wo, t);
  return /* @__PURE__ */ p(qh, { scope: t, forceMount: n, children: c.Children.map(r, (s) => /* @__PURE__ */ p(Me, { present: n || i.open, children: /* @__PURE__ */ p(bo, { asChild: !0, container: o, children: s }) })) });
};
Fc.displayName = wo;
var Nn = "DialogOverlay", Wc = c.forwardRef(
  (e, t) => {
    const n = Lc(Nn, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Re(Nn, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ p(Me, { present: r || i.open, children: /* @__PURE__ */ p(Qh, { ...o, ref: t }) }) : null;
  }
);
Wc.displayName = Nn;
var Zh = /* @__PURE__ */ Uh("DialogOverlay.RemoveScroll"), Qh = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Re(Nn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ p(ro, { as: Zh, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ p(
        At.div,
        {
          "data-state": Eo(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), lt = "DialogContent", Bc = c.forwardRef(
  (e, t) => {
    const n = Lc(lt, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Re(lt, e.__scopeDialog);
    return /* @__PURE__ */ p(Me, { present: r || i.open, children: i.modal ? /* @__PURE__ */ p(Jh, { ...o, ref: t }) : /* @__PURE__ */ p(ev, { ...o, ref: t }) });
  }
);
Bc.displayName = lt;
var Jh = c.forwardRef(
  (e, t) => {
    const n = Re(lt, e.__scopeDialog), r = c.useRef(null), o = q(t, n.contentRef, r);
    return c.useEffect(() => {
      const i = r.current;
      if (i)
        return no(i);
    }, []), /* @__PURE__ */ p(
      Vc,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: k(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: k(e.onPointerDownOutside, (i) => {
          const s = i.detail.originalEvent, a = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || a) && i.preventDefault();
        }),
        onFocusOutside: k(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), ev = c.forwardRef(
  (e, t) => {
    const n = Re(lt, e.__scopeDialog), r = c.useRef(!1), o = c.useRef(!1);
    return /* @__PURE__ */ p(
      Vc,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var s, a;
          (s = e.onCloseAutoFocus) == null || s.call(e, i), i.defaultPrevented || (r.current || (a = n.triggerRef.current) == null || a.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var u, l;
          (u = e.onInteractOutside) == null || u.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = i.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), Vc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...s } = e, a = Re(lt, n), u = c.useRef(null), l = q(t, u);
    return sa(), /* @__PURE__ */ V(Qe, { children: [
      /* @__PURE__ */ p(
        Mc,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ p(
            yo,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": Eo(a.open),
              ...s,
              ref: l,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ V(Qe, { children: [
        /* @__PURE__ */ p(nv, { titleId: a.titleId }),
        /* @__PURE__ */ p(ov, { contentRef: u, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), xo = "DialogTitle", Uc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Re(xo, n);
    return /* @__PURE__ */ p(At.h2, { id: o.titleId, ...r, ref: t });
  }
);
Uc.displayName = xo;
var zc = "DialogDescription", Hc = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Re(zc, n);
    return /* @__PURE__ */ p(At.p, { id: o.descriptionId, ...r, ref: t });
  }
);
Hc.displayName = zc;
var jc = "DialogClose", tv = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Re(jc, n);
    return /* @__PURE__ */ p(
      At.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: k(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
tv.displayName = jc;
function Eo(e) {
  return e ? "open" : "closed";
}
var Kc = "DialogTitleWarning", [Gy, Gc] = gu(Kc, {
  contentName: lt,
  titleName: xo,
  docsSlug: "dialog"
}), nv = ({ titleId: e }) => {
  const t = Gc(Kc), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, rv = "DialogDescriptionWarning", ov = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Gc(rv).contentName}}.`;
  return c.useEffect(() => {
    var i;
    const o = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, iv = $c, av = Fc, sv = Wc, cv = Bc, lv = Uc, uv = Hc;
// @__NO_SIDE_EFFECTS__
function Dr(e) {
  const t = /* @__PURE__ */ dv(e), n = c.forwardRef((r, o) => {
    const { children: i, ...s } = r, a = c.Children.toArray(i), u = a.find(pv);
    if (u) {
      const l = u.props.children, d = a.map((f) => f === u ? c.Children.count(l) > 1 ? c.Children.only(null) : c.isValidElement(l) ? l.props.children : null : f);
      return /* @__PURE__ */ p(t, { ...s, ref: o, children: c.isValidElement(l) ? c.cloneElement(l, void 0, d) : null });
    }
    return /* @__PURE__ */ p(t, { ...s, ref: o, children: i });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function dv(e) {
  const t = c.forwardRef((n, r) => {
    const { children: o, ...i } = n;
    if (c.isValidElement(o)) {
      const s = gv(o), a = mv(i, o.props);
      return o.type !== c.Fragment && (a.ref = r ? Ce(r, s) : s), c.cloneElement(o, a);
    }
    return c.Children.count(o) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var fv = Symbol("radix.slottable");
function pv(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === fv;
}
function mv(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      const u = i(...a);
      return o(...a), u;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function gv(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function hv(e) {
  const t = e + "CollectionProvider", [n, r] = We(t), [o, i] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (g) => {
    const { scope: h, children: y } = g, E = N.useRef(null), x = N.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ p(o, { scope: h, itemMap: x, collectionRef: E, children: y });
  };
  s.displayName = t;
  const a = e + "CollectionSlot", u = /* @__PURE__ */ Dr(a), l = N.forwardRef(
    (g, h) => {
      const { scope: y, children: E } = g, x = i(a, y), b = q(h, x.collectionRef);
      return /* @__PURE__ */ p(u, { ref: b, children: E });
    }
  );
  l.displayName = a;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ Dr(d), v = N.forwardRef(
    (g, h) => {
      const { scope: y, children: E, ...x } = g, b = N.useRef(null), S = q(h, b), T = i(d, y);
      return N.useEffect(() => (T.itemMap.set(b, { ref: b, ...x }), () => void T.itemMap.delete(b))), /* @__PURE__ */ p(m, { [f]: "", ref: S, children: E });
    }
  );
  v.displayName = d;
  function w(g) {
    const h = i(e + "CollectionConsumer", g);
    return N.useCallback(() => {
      const E = h.collectionRef.current;
      if (!E)
        return [];
      const x = Array.from(E.querySelectorAll(`[${f}]`));
      return Array.from(h.itemMap.values()).sort(
        (T, C) => x.indexOf(T.ref.current) - x.indexOf(C.ref.current)
      );
    }, [h.collectionRef, h.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: v },
    w,
    r
  ];
}
var vv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], dt = vv.reduce((e, t) => {
  const n = /* @__PURE__ */ Dr(`Primitive.${t}`), r = c.forwardRef((o, i) => {
    const { asChild: s, ...a } = o, u = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ p(u, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function yv(e, t) {
  e && Et.flushSync(() => e.dispatchEvent(t));
}
var bv = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), wv = "VisuallyHidden", Co = c.forwardRef(
  (e, t) => /* @__PURE__ */ p(
    dt.span,
    {
      ...e,
      ref: t,
      style: { ...bv, ...e.style }
    }
  )
);
Co.displayName = wv;
var So = "ToastProvider", [Ro, xv, Ev] = hv("Toast"), [Yc, Yy] = We("Toast", [Ev]), [Cv, Bn] = Yc(So), Xc = (e) => {
  const {
    __scopeToast: t,
    label: n = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: i = 50,
    children: s
  } = e, [a, u] = c.useState(null), [l, d] = c.useState(0), f = c.useRef(!1), m = c.useRef(!1);
  return n.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${So}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ p(Ro.Provider, { scope: t, children: /* @__PURE__ */ p(
    Cv,
    {
      scope: t,
      label: n,
      duration: r,
      swipeDirection: o,
      swipeThreshold: i,
      toastCount: l,
      viewport: a,
      onViewportChange: u,
      onToastAdd: c.useCallback(() => d((v) => v + 1), []),
      onToastRemove: c.useCallback(() => d((v) => v - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: m,
      children: s
    }
  ) });
};
Xc.displayName = So;
var qc = "ToastViewport", Sv = ["F8"], Or = "toast.viewportPause", Mr = "toast.viewportResume", Zc = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      hotkey: r = Sv,
      label: o = "Notifications ({hotkey})",
      ...i
    } = e, s = Bn(qc, n), a = xv(n), u = c.useRef(null), l = c.useRef(null), d = c.useRef(null), f = c.useRef(null), m = q(t, f, s.onViewportChange), v = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), w = s.toastCount > 0;
    c.useEffect(() => {
      const h = (y) => {
        var x;
        r.length !== 0 && r.every((b) => y[b] || y.code === b) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", h), () => document.removeEventListener("keydown", h);
    }, [r]), c.useEffect(() => {
      const h = u.current, y = f.current;
      if (w && h && y) {
        const E = () => {
          if (!s.isClosePausedRef.current) {
            const T = new CustomEvent(Or);
            y.dispatchEvent(T), s.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (s.isClosePausedRef.current) {
            const T = new CustomEvent(Mr);
            y.dispatchEvent(T), s.isClosePausedRef.current = !1;
          }
        }, b = (T) => {
          !h.contains(T.relatedTarget) && x();
        }, S = () => {
          h.contains(document.activeElement) || x();
        };
        return h.addEventListener("focusin", E), h.addEventListener("focusout", b), h.addEventListener("pointermove", E), h.addEventListener("pointerleave", S), window.addEventListener("blur", E), window.addEventListener("focus", x), () => {
          h.removeEventListener("focusin", E), h.removeEventListener("focusout", b), h.removeEventListener("pointermove", E), h.removeEventListener("pointerleave", S), window.removeEventListener("blur", E), window.removeEventListener("focus", x);
        };
      }
    }, [w, s.isClosePausedRef]);
    const g = c.useCallback(
      ({ tabbingDirection: h }) => {
        const E = a().map((x) => {
          const b = x.ref.current, S = [b, ...Lv(b)];
          return h === "forwards" ? S : S.reverse();
        });
        return (h === "forwards" ? E.reverse() : E).flat();
      },
      [a]
    );
    return c.useEffect(() => {
      const h = f.current;
      if (h) {
        const y = (E) => {
          var S, T, C;
          const x = E.altKey || E.ctrlKey || E.metaKey;
          if (E.key === "Tab" && !x) {
            const R = document.activeElement, D = E.shiftKey;
            if (E.target === h && D) {
              (S = l.current) == null || S.focus();
              return;
            }
            const O = g({ tabbingDirection: D ? "backwards" : "forwards" }), P = O.findIndex((A) => A === R);
            lr(O.slice(P + 1)) ? E.preventDefault() : D ? (T = l.current) == null || T.focus() : (C = d.current) == null || C.focus();
          }
        };
        return h.addEventListener("keydown", y), () => h.removeEventListener("keydown", y);
      }
    }, [a, g]), /* @__PURE__ */ V(
      yh,
      {
        ref: u,
        role: "region",
        "aria-label": o.replace("{hotkey}", v),
        tabIndex: -1,
        style: { pointerEvents: w ? void 0 : "none" },
        children: [
          w && /* @__PURE__ */ p(
            Ir,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const h = g({
                  tabbingDirection: "forwards"
                });
                lr(h);
              }
            }
          ),
          /* @__PURE__ */ p(Ro.Slot, { scope: n, children: /* @__PURE__ */ p(dt.ol, { tabIndex: -1, ...i, ref: m }) }),
          w && /* @__PURE__ */ p(
            Ir,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const h = g({
                  tabbingDirection: "backwards"
                });
                lr(h);
              }
            }
          )
        ]
      }
    );
  }
);
Zc.displayName = qc;
var Qc = "ToastFocusProxy", Ir = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, onFocusFromOutsideViewport: r, ...o } = e, i = Bn(Qc, n);
    return /* @__PURE__ */ p(
      Co,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: t,
        style: { position: "fixed" },
        onFocus: (s) => {
          var l;
          const a = s.relatedTarget;
          !((l = i.viewport) != null && l.contains(a)) && r();
        }
      }
    );
  }
);
Ir.displayName = Qc;
var Jt = "Toast", Rv = "toast.swipeStart", Tv = "toast.swipeMove", Nv = "toast.swipeCancel", Pv = "toast.swipeEnd", Jc = c.forwardRef(
  (e, t) => {
    const { forceMount: n, open: r, defaultOpen: o, onOpenChange: i, ...s } = e, [a, u] = St({
      prop: r,
      defaultProp: o ?? !0,
      onChange: i,
      caller: Jt
    });
    return /* @__PURE__ */ p(Me, { present: n || a, children: /* @__PURE__ */ p(
      Ov,
      {
        open: a,
        ...s,
        ref: t,
        onClose: () => u(!1),
        onPause: ne(e.onPause),
        onResume: ne(e.onResume),
        onSwipeStart: k(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: k(e.onSwipeMove, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: k(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: k(e.onSwipeEnd, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), u(!1);
        })
      }
    ) });
  }
);
Jc.displayName = Jt;
var [Av, Dv] = Yc(Jt, {
  onClose() {
  }
}), Ov = c.forwardRef(
  (e, t) => {
    const {
      __scopeToast: n,
      type: r = "foreground",
      duration: o,
      open: i,
      onClose: s,
      onEscapeKeyDown: a,
      onPause: u,
      onResume: l,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: m,
      onSwipeEnd: v,
      ...w
    } = e, g = Bn(Jt, n), [h, y] = c.useState(null), E = q(t, (A) => y(A)), x = c.useRef(null), b = c.useRef(null), S = o || g.duration, T = c.useRef(0), C = c.useRef(S), R = c.useRef(0), { onToastAdd: D, onToastRemove: I } = g, L = ne(() => {
      var W;
      (h == null ? void 0 : h.contains(document.activeElement)) && ((W = g.viewport) == null || W.focus()), s();
    }), O = c.useCallback(
      (A) => {
        !A || A === 1 / 0 || (window.clearTimeout(R.current), T.current = (/* @__PURE__ */ new Date()).getTime(), R.current = window.setTimeout(L, A));
      },
      [L]
    );
    c.useEffect(() => {
      const A = g.viewport;
      if (A) {
        const W = () => {
          O(C.current), l == null || l();
        }, $ = () => {
          const U = (/* @__PURE__ */ new Date()).getTime() - T.current;
          C.current = C.current - U, window.clearTimeout(R.current), u == null || u();
        };
        return A.addEventListener(Or, $), A.addEventListener(Mr, W), () => {
          A.removeEventListener(Or, $), A.removeEventListener(Mr, W);
        };
      }
    }, [g.viewport, S, u, l, O]), c.useEffect(() => {
      i && !g.isClosePausedRef.current && O(S);
    }, [i, S, g.isClosePausedRef, O]), c.useEffect(() => (D(), () => I()), [D, I]);
    const P = c.useMemo(() => h ? sl(h) : null, [h]);
    return g.viewport ? /* @__PURE__ */ V(Qe, { children: [
      P && /* @__PURE__ */ p(
        Mv,
        {
          __scopeToast: n,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: P
        }
      ),
      /* @__PURE__ */ p(Av, { scope: n, onClose: L, children: Et.createPortal(
        /* @__PURE__ */ p(Ro.ItemSlot, { scope: n, children: /* @__PURE__ */ p(
          vh,
          {
            asChild: !0,
            onEscapeKeyDown: k(a, () => {
              g.isFocusedToastEscapeKeyDownRef.current || L(), g.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ p(
              dt.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": i ? "open" : "closed",
                "data-swipe-direction": g.swipeDirection,
                ...w,
                ref: E,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: k(e.onKeyDown, (A) => {
                  A.key === "Escape" && (a == null || a(A.nativeEvent), A.nativeEvent.defaultPrevented || (g.isFocusedToastEscapeKeyDownRef.current = !0, L()));
                }),
                onPointerDown: k(e.onPointerDown, (A) => {
                  A.button === 0 && (x.current = { x: A.clientX, y: A.clientY });
                }),
                onPointerMove: k(e.onPointerMove, (A) => {
                  if (!x.current)
                    return;
                  const W = A.clientX - x.current.x, $ = A.clientY - x.current.y, U = !!b.current, _ = ["left", "right"].includes(g.swipeDirection), M = ["left", "up"].includes(g.swipeDirection) ? Math.min : Math.max, j = _ ? M(0, W) : 0, G = _ ? 0 : M(0, $), ie = A.pointerType === "touch" ? 10 : 2, ae = { x: j, y: G }, fe = { originalEvent: A, delta: ae };
                  U ? (b.current = ae, gn(Tv, f, fe, {
                    discrete: !1
                  })) : Mi(ae, g.swipeDirection, ie) ? (b.current = ae, gn(Rv, d, fe, {
                    discrete: !1
                  }), A.target.setPointerCapture(A.pointerId)) : (Math.abs(W) > ie || Math.abs($) > ie) && (x.current = null);
                }),
                onPointerUp: k(e.onPointerUp, (A) => {
                  const W = b.current, $ = A.target;
                  if ($.hasPointerCapture(A.pointerId) && $.releasePointerCapture(A.pointerId), b.current = null, x.current = null, W) {
                    const U = A.currentTarget, _ = { originalEvent: A, delta: W };
                    Mi(W, g.swipeDirection, g.swipeThreshold) ? gn(Pv, v, _, {
                      discrete: !0
                    }) : gn(
                      Nv,
                      m,
                      _,
                      {
                        discrete: !0
                      }
                    ), U.addEventListener("click", (M) => M.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        g.viewport
      ) })
    ] }) : null;
  }
), Mv = (e) => {
  const { __scopeToast: t, children: n, ...r } = e, o = Bn(Jt, t), [i, s] = c.useState(!1), [a, u] = c.useState(!1);
  return $v(() => s(!0)), c.useEffect(() => {
    const l = window.setTimeout(() => u(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), a ? null : /* @__PURE__ */ p(bo, { asChild: !0, children: /* @__PURE__ */ p(Co, { ...r, children: i && /* @__PURE__ */ V(Qe, { children: [
    o.label,
    " ",
    n
  ] }) }) });
}, Iv = "ToastTitle", el = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p(dt.div, { ...r, ref: t });
  }
);
el.displayName = Iv;
var _v = "ToastDescription", tl = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e;
    return /* @__PURE__ */ p(dt.div, { ...r, ref: t });
  }
);
tl.displayName = _v;
var nl = "ToastAction", rl = c.forwardRef(
  (e, t) => {
    const { altText: n, ...r } = e;
    return n.trim() ? /* @__PURE__ */ p(al, { altText: n, asChild: !0, children: /* @__PURE__ */ p(il, { ...r, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${nl}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
rl.displayName = nl;
var ol = "ToastClose", il = c.forwardRef(
  (e, t) => {
    const { __scopeToast: n, ...r } = e, o = Dv(ol, n);
    return /* @__PURE__ */ p(al, { asChild: !0, children: /* @__PURE__ */ p(
      dt.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: k(e.onClick, o.onClose)
      }
    ) });
  }
);
il.displayName = ol;
var al = c.forwardRef((e, t) => {
  const { __scopeToast: n, altText: r, ...o } = e;
  return /* @__PURE__ */ p(
    dt.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: t
    }
  );
});
function sl(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && t.push(r.textContent), kv(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", i = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (i) {
          const s = r.dataset.radixToastAnnounceAlt;
          s && t.push(s);
        } else
          t.push(...sl(r));
    }
  }), t;
}
function gn(e, t, n, { discrete: r }) {
  const o = n.originalEvent.currentTarget, i = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? yv(o, i) : o.dispatchEvent(i);
}
var Mi = (e, t, n = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), i = r > o;
  return t === "left" || t === "right" ? i && r > n : !i && o > n;
};
function $v(e = () => {
}) {
  const t = ne(e);
  De(() => {
    let n = 0, r = 0;
    return n = window.requestAnimationFrame(() => r = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(n), window.cancelAnimationFrame(r);
    };
  }, [t]);
}
function kv(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function Lv(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function lr(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
var Fv = Xc, Wv = Zc, Bv = Jc, Vv = el, Uv = tl, zv = rl;
const cl = Fv, To = c.forwardRef((e, t) => /* @__PURE__ */ p(Bv, { ref: t, ...e }));
To.displayName = "PrimitiveToastRootToastRoot";
const No = c.forwardRef((e, t) => /* @__PURE__ */ p(Wv, { ref: t, ...e }));
No.displayName = "PrimitiveToastViewport";
const ll = c.forwardRef((e, t) => /* @__PURE__ */ p(zv, { ref: t, ...e }));
ll.displayName = "PrimitiveToastAction";
const Po = c.forwardRef((e, t) => /* @__PURE__ */ p(Vv, { ref: t, ...e }));
Po.displayName = "PrimitiveToastTitle";
const Ao = c.forwardRef((e, t) => /* @__PURE__ */ p(Uv, { ref: t, ...e }));
Ao.displayName = "PrimitiveToastDescription";
const ul = ({ children: e, className: t }) => /* @__PURE__ */ V("div", { className: F("flex items-center gap-1", t), children: [
  /* @__PURE__ */ p(Pe, { name: "info", size: 16, color: "#C6CACE", filled: !0 }),
  /* @__PURE__ */ p("span", { className: "typography-ui-13r text-gray-400", children: e })
] }), Hv = N.forwardRef(
  ({
    title: e,
    description: t,
    children: n,
    informationText: r,
    className: o,
    closeOnOverlayClick: i = !0,
    closeOnEscape: s = !0,
    ...a
  }, u) => {
    const { open: l, onOpenChange: d, contentId: f } = Wi(), m = Bt(null), v = Bt(null), [w, g] = Ee(!1), h = Bt(null);
    N.useImperativeHandle(u, () => v.current, []), be(() => (l ? (h.current && (clearTimeout(h.current), h.current = null), g(!0)) : w && (h.current && clearTimeout(h.current), h.current = setTimeout(() => {
      g(!1), h.current = null;
    }, 250)), () => {
      h.current && (clearTimeout(h.current), h.current = null);
    }), [l, w]), be(() => {
      if (!s || !l)
        return;
      const x = (b) => {
        b.key === "Escape" && d(!1);
      };
      return document.addEventListener("keydown", x), () => document.removeEventListener("keydown", x);
    }, [s, l, d]), be(() => {
      var S;
      if (!l)
        return;
      const x = document.activeElement, b = (S = v.current) == null ? void 0 : S.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      return b && b.length > 0 && b[0].focus(), () => {
        x && x.focus();
      };
    }, [l]);
    const y = (x) => {
      i && x.target === m.current && d(!1);
    };
    if (!w)
      return null;
    const E = /* @__PURE__ */ p(
      "div",
      {
        ref: m,
        className: F(
          "fixed inset-0 z-[350] flex items-end justify-center bg-black/50 p-4",
          l ? "animate-fade-in" : "animate-fade-out"
        ),
        onClick: y,
        children: /* @__PURE__ */ V(
          "div",
          {
            ref: v,
            id: f,
            className: F(
              "flex w-full min-w-[360px] max-w-[480px] flex-col gap-4 rounded-2xl bg-white px-3 py-6",
              l ? "animate-slide-up" : "animate-slide-down",
              o
            ),
            ...a,
            children: [
              /* @__PURE__ */ V("div", { className: "flex flex-col gap-2 px-3", children: [
                /* @__PURE__ */ p("h2", { className: "typography-ui-22sb text-gray-900", children: e }),
                t && /* @__PURE__ */ p("p", { className: "typography-ui-15r text-gray-600", children: t })
              ] }),
              /* @__PURE__ */ p("div", { className: "flex flex-col", children: n }),
              r && /* @__PURE__ */ p("div", { className: "px-3", children: /* @__PURE__ */ p(ul, { children: r }) })
            ]
          }
        )
      }
    );
    return Hr(E, document.body);
  }
);
Hv.displayName = "ActionSheetContent";
const dl = c.forwardRef(
  ({ label: e, description: t, showNew: n = !1, className: r, ...o }, i) => /* @__PURE__ */ V("div", { ref: i, className: F("flex flex-col gap-1", r), ...o, children: [
    /* @__PURE__ */ V("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ p("span", { className: "typography-ui-17m text-gray-600", children: e }),
      n && /* @__PURE__ */ p("div", { className: "flex h-[18px] w-[18px] items-center justify-center rounded-full bg-red-600", children: /* @__PURE__ */ p("span", { className: "typography-ui-12sb !text-white", children: "N" }) })
    ] }),
    t && /* @__PURE__ */ p("span", { className: "typography-ui-13r text-start text-gray-400", children: t })
  ] })
);
dl.displayName = "ActionSheetItemLabel";
const jv = c.forwardRef(
  ({ label: e, description: t, showNew: n = !1, selected: r = !1, onPress: o, className: i, onClick: s, ...a }, u) => {
    const l = (d) => {
      o == null || o(), s == null || s(d);
    };
    return /* @__PURE__ */ V(
      "button",
      {
        ref: u,
        className: F(
          // 기본 스타일
          "flex flex-row items-center justify-center gap-2 rounded-lg px-3 py-4",
          "w-full transition-colors duration-200",
          // 호버/액티브 상태
          "hover:bg-gray-30 active:bg-gray-30",
          // 포커스 상태
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500",
          i
        ),
        onClick: l,
        ...a,
        children: [
          /* @__PURE__ */ p("div", { className: "flex-1", children: /* @__PURE__ */ p(
            dl,
            {
              label: e,
              description: t,
              showNew: n,
              className: F(
                // 선택 상태에 따른 텍스트 색상 오버라이드
                r && "[&_span:first-child]:text-gray-900"
              )
            }
          ) }),
          r && /* @__PURE__ */ p(Pm, { className: "flex-shrink-0" })
        ]
      }
    );
  }
);
jv.displayName = "ActionSheetItem";
const Ii = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, _i = Vi, en = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return _i(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = t, s = Object.keys(o).map((l) => {
    const d = n == null ? void 0 : n[l], f = i == null ? void 0 : i[l];
    if (d === null)
      return null;
    const m = Ii(d) || Ii(f);
    return o[l][m];
  }), a = n && Object.entries(n).reduce((l, d) => {
    let [f, m] = d;
    return m === void 0 || (l[f] = m), l;
  }, {}), u = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, d) => {
    let { class: f, className: m, ...v } = d;
    return Object.entries(v).every((w) => {
      let [g, h] = w;
      return Array.isArray(h) ? h.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === h;
    }) ? [
      ...l,
      f,
      m
    ] : l;
  }, []);
  return _i(e, s, u, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Kv = en(
  "inline-flex items-center justify-center whitespace-nowrap font-pretendard transition-colors focus-visible:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      size: {
        s: "typography-ui-13m h-8 gap-1 rounded-[8px] px-2",
        m: "typography-ui-15sb h-10 gap-1 rounded-[8px] px-3",
        l: "typography-ui-17sb h-12 gap-2 rounded-[12px] px-4",
        xl: "typography-ui-17sb h-14 gap-2 rounded-[12px] px-5"
      },
      buttonColor: {
        primary: "",
        red: "",
        gray: "",
        primaryLight: ""
      },
      buttonStyle: {
        contained: "",
        outlined: ""
      }
    },
    defaultVariants: {
      size: "m",
      buttonColor: "primary",
      buttonStyle: "contained"
    },
    compoundVariants: [
      // Primary Contained
      {
        buttonColor: "primary",
        buttonStyle: "contained",
        className: "bg-primary-600 text-white hover:bg-primary-700 active:scale-[0.98] active:bg-primary-800 disabled:bg-gray-100 disabled:text-white"
      },
      // Primary Outlined
      {
        buttonColor: "primary",
        buttonStyle: "outlined",
        className: "border border-primary-500 border-solid bg-white text-primary-700 hover:bg-primary-100 active:scale-[0.98] active:bg-primary-200 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Contained
      {
        buttonColor: "gray",
        buttonStyle: "contained",
        className: "bg-gray-700 text-white hover:bg-gray-800 active:scale-[0.98] active:bg-gray-900 disabled:bg-gray-100 disabled:text-white"
      },
      // Gray Outlined
      {
        buttonColor: "gray",
        buttonStyle: "outlined",
        className: "border border-gray-100 border-solid bg-white text-gray-600 hover:bg-gray-30 active:scale-[0.98] active:bg-gray-50 disabled:border-gray-100 disabled:bg-gray-100 disabled:text-white"
      },
      // Red Contained
      {
        buttonColor: "red",
        buttonStyle: "contained",
        className: "bg-red-600 text-white hover:bg-red-700 active:scale-[0.98] active:bg-red-800 disabled:bg-gray-100 disabled:text-white"
      },
      // PrimaryLight Contained
      {
        buttonColor: "primaryLight",
        buttonStyle: "contained",
        className: "bg-primary-100 text-primary-700 hover:bg-primary-200 active:scale-[0.98] active:bg-primary-300 disabled:bg-gray-100 disabled:text-white"
      }
    ]
  }
), wt = c.forwardRef(
  ({ className: e, size: t, buttonColor: n, buttonStyle: r, asChild: o = !1, ...i }, s) => /* @__PURE__ */ p(o ? Kr : "button", { className: F(Kv({ size: t, buttonColor: n, buttonStyle: r, className: e })), ref: s, ...i })
);
wt.displayName = "Button";
const fl = N.forwardRef(
  ({ state: e = "enabled", autoStateChange: t = !0, containerClassName: n, className: r, disabled: o, onChange: i, value: s, ...a }, u) => {
    const l = () => o ? "disabled" : s && s.toString().trim() !== "" ? "typed" : e, [d, f] = Ee(l()), m = Bt(null), v = u || m;
    be(() => {
      o ? f("disabled") : e !== d && !t && f(e);
    }, [e, o, t, d]), be(() => {
      if (!o && t) {
        const S = s && s.toString().trim() !== "";
        S && (d === "enabled" || d === "focus") ? f("typed") : !S && d === "typed" && f("enabled");
      }
    }, [s, o, t, d]);
    const w = (S) => {
      var T;
      o || (t && f(s ? "typed" : "focus"), (T = a.onFocus) == null || T.call(a, S));
    }, g = (S) => {
      var T;
      o || (t && f(s ? "typed" : "enabled"), (T = a.onBlur) == null || T.call(a, S));
    }, h = (S) => {
      o || (t && f(S.target.value ? "typing" : "focus"), i == null || i(S));
    }, y = o, x = F(
      "relative flex w-full rounded-lg px-[16px] py-[13px] min-h-[120px] max-h-[240px] overflow-y-auto",
      (() => y ? "bg-gray-40" : "bg-gray-10 border border-gray-100 border-solid")(),
      n
    ), b = F(
      "typography-ui-17m placeholder:text-gray-300 w-full p-0 resize-none bg-transparent border-none outline-none caret-primary-700",
      {
        "text-gray-200": d === "disabled",
        "placeholder:text-gray-200": d === "disabled",
        "text-gray-300": d === "enabled" || d === "focus",
        "text-gray-700": d === "typing" || d === "typed"
      },
      {
        "cursor-not-allowed": d === "disabled"
      },
      r
    );
    return /* @__PURE__ */ p("div", { className: x, children: /* @__PURE__ */ p("div", { className: "relative flex w-full gap-0.5", children: /* @__PURE__ */ p(
      "textarea",
      {
        ref: v,
        className: b,
        disabled: o || d === "disabled",
        onChange: h,
        onFocus: w,
        onBlur: g,
        value: s,
        ...a
      }
    ) }) });
  }
);
fl.displayName = "AreaContainer";
function Gv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pl = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var i = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (i = o(i, r(a)));
      }
      return i;
    }
    function r(i) {
      if (typeof i == "string" || typeof i == "number")
        return i;
      if (typeof i != "object")
        return "";
      if (Array.isArray(i))
        return n.apply(null, i);
      if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
        return i.toString();
      var s = "";
      for (var a in i)
        t.call(i, a) && i[a] && (s = o(s, a));
      return s;
    }
    function o(i, s) {
      return s ? i ? i + " " + s : i + s : i;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(pl);
var Yv = pl.exports;
const Xv = /* @__PURE__ */ Gv(Yv), Do = ({
  state: e = "default",
  text: t,
  characterCount: n,
  maxLength: r = 50,
  showCharacterCounter: o = !1,
  className: i
}) => /* @__PURE__ */ V("div", { className: "flex w-full items-center justify-between", children: [
  /* @__PURE__ */ p(
    "div",
    {
      className: Xv(
        "typography-ui-13r w-full rounded-md border-none",
        {
          "text-gray-400": e === "default",
          "text-red-700": e === "error"
        },
        i
      ),
      children: t
    }
  ),
  o && /* @__PURE__ */ p("div", { className: "mt-1 flex justify-end", children: /* @__PURE__ */ V("span", { className: "typography-ui-13r text-gray-500", children: [
    /* @__PURE__ */ p("span", { className: "text-gray-500", children: n }),
    /* @__PURE__ */ V("span", { className: "text-gray-400", children: [
      "/",
      r
    ] })
  ] }) })
] }), qv = re(
  ({
    className: e,
    helpTextArea: t,
    maxLength: n,
    showCharacterCount: r = !1,
    state: o = "enabled",
    autoStateChange: i = !0,
    containerClassName: s,
    disabled: a,
    value: u,
    onChange: l,
    ...d
  }, f) => {
    var y;
    const [m, v] = Ee(((y = d.defaultValue) == null ? void 0 : y.toString().length) || (u == null ? void 0 : u.toString().length) || 0);
    be(() => {
      u !== void 0 && v(u.toString().length);
    }, [u]);
    const w = (E) => {
      v(E.target.value.length), l == null || l(E);
    }, g = F("flex w-full flex-col gap-[8px]", s), h = a || o === "disabled" ? "default" : o === "error" ? "error" : "default";
    return /* @__PURE__ */ V("div", { className: g, children: [
      /* @__PURE__ */ p(
        fl,
        {
          ref: f,
          className: F("min-h-[80px]", e),
          state: o,
          autoStateChange: i,
          disabled: a,
          value: u,
          onChange: w,
          maxLength: n,
          ...d
        }
      ),
      (t || r) && /* @__PURE__ */ p("div", { className: "flex w-full items-center justify-between", children: /* @__PURE__ */ p(
        Do,
        {
          state: h,
          text: t || "",
          showCharacterCounter: r,
          characterCount: m,
          maxLength: n,
          className: "border-0 p-0"
        }
      ) })
    ] });
  }
);
qv.displayName = "TextArea";
const at = {
  wrapper: "relative w-full",
  inputWrapper: "flex items-center w-full h-[50px] px-4 py-[13px] rounded-[8px]",
  input: "typography-ui-17m flex-1 h-full w-full p-0 border-none bg-transparent text-gray-700 placeholder:text-gray-300 outline-none focus:outline-none disabled:cursor-not-allowed disabled:text-gray-200 caret-primary-700 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none [&]:appearance-none",
  clearButton: "cursor-pointer text-gray-600",
  validationIcon: "cursor-default",
  iconContainer: "flex items-center gap-[4px] pl-[8px]"
}, ml = re(
  ({
    className: e,
    value: t,
    onChange: n,
    onValueChange: r,
    showClearButton: o = !0,
    onClear: i,
    children: s,
    validationStatus: a = "none",
    defaultValue: u,
    ...l
  }, d) => {
    const f = Bt(null), m = d || f, [v, w] = Ee(!1), g = l.type === "password", h = g && v ? "text" : l.type, y = (O) => {
      let P = O.target.value;
      l.type !== "text" && l.maxLength && P.length > l.maxLength && (P = P.slice(0, l.maxLength), O.target.value = P), r == null || r(P), n == null || n(O);
    }, E = () => {
      var O;
      r == null || r(""), n == null || n({ target: { value: "" } }), i == null || i(), (O = m.current) == null || O.focus();
    }, x = a === "error" || l["aria-invalid"] === !0, b = l.disabled, S = () => x ? "border border-red-600 border-solid bg-red-100" : b ? "bg-gray-40" : "bg-gray-10 border border-gray-100 border-solid", T = F(at.inputWrapper, S(), e), C = () => a === "success" ? /* @__PURE__ */ p(Pe, { name: "check_circle", size: 20, className: "text-green-500", filled: !0 }) : a === "error" ? /* @__PURE__ */ p(Pe, { name: "error", size: 20, className: "text-red-500", filled: !0 }) : null, D = t !== void 0 ? t : u, { type: I, ...L } = l;
    return /* @__PURE__ */ V("div", { className: F(at.wrapper, e), children: [
      /* @__PURE__ */ V("div", { className: T, children: [
        /* @__PURE__ */ p(
          "input",
          {
            type: h || "text",
            className: at.input,
            value: D,
            onChange: y,
            ref: m,
            "aria-invalid": x,
            ...L
          }
        ),
        /* @__PURE__ */ V("div", { className: at.iconContainer, children: [
          g && D && !l.disabled && !l.readOnly && /* @__PURE__ */ p(
            "div",
            {
              className: at.clearButton,
              onClick: () => {
                var O;
                w(!v), (O = m.current) == null || O.focus();
              },
              "aria-label": v ? "비밀번호 숨기기" : "비밀번호 보기",
              children: /* @__PURE__ */ p(
                Pe,
                {
                  name: v ? "visibility" : "visibility_off",
                  size: 20,
                  className: "text-gray-700",
                  filled: !0
                }
              )
            }
          ),
          o && D && !l.disabled && !l.readOnly && /* @__PURE__ */ p("div", { className: at.clearButton, onClick: E, children: /* @__PURE__ */ p(Pe, { name: "cancel", size: 20, className: "text-gray-200", filled: !0 }) }),
          a !== "none" && /* @__PURE__ */ p("div", { className: at.validationIcon, children: C() })
        ] })
      ] }),
      s
    ] });
  }
);
ml.displayName = "InputContainer";
const Zv = re(
  ({
    state: e = "enabled",
    helpTextArea: t,
    type: n,
    value: r,
    onChange: o,
    onValueChange: i,
    showClearButton: s = !0,
    onClear: a,
    className: u,
    defaultValue: l,
    isValid: d,
    ...f
  }, m) => {
    const [v, w] = Ee(r);
    be(() => {
      r !== v && w(r);
    }, [r]);
    const g = (b) => {
      i && (f.maxLength && b.length > f.maxLength && (b = b.slice(0, f.maxLength)), i(b), w(b));
    }, h = (b) => {
      o && (f.maxLength && b.target.value.length > f.maxLength && (b.target.value = b.target.value.slice(0, f.maxLength)), o(b), w(b.target.value));
    }, y = () => {
      w(""), i == null || i(""), a == null || a();
    }, E = r !== void 0;
    return /* @__PURE__ */ V("div", { className: "flex w-full flex-col", children: [
      /* @__PURE__ */ p(
        ml,
        {
          className: u,
          value: E ? r : v,
          defaultValue: E ? void 0 : l,
          onChange: o ? h : void 0,
          onValueChange: i ? g : void 0,
          showClearButton: s,
          onClear: y,
          type: n,
          disabled: e === "disabled" || f.disabled,
          "aria-invalid": e === "error",
          validationStatus: e === "error" ? "error" : d ? "success" : "none",
          ref: m,
          ...f
        }
      ),
      t && /* @__PURE__ */ p(
        Do,
        {
          state: e === "error" ? "error" : "default",
          text: t,
          showCharacterCounter: !1,
          className: "mt-2 border-0 p-0"
        }
      )
    ] });
  }
);
Zv.displayName = "TextInput";
const Oo = re(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p(
    $u,
    {
      ref: n,
      className: F(
        "peer h-[22px] w-[22px] rounded-[4px] border-2 border-gray-100 border-solid bg-white ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "!duration-75",
        "data-[state=checked]:border-0 data-[state=checked]:bg-primary-600 data-[state=checked]:text-white",
        "data-[state=indeterminate]:border-0 data-[state=indeterminate]:bg-primary-600 data-[state=indeterminate]:text-white",
        "disabled:cursor-not-allowed",
        "disabled:data-[state=checked]:bg-gray-100 disabled:data-[state=indeterminate]:bg-gray-100",
        "disabled:data-[state=unchecked]:border-gray-100 disabled:data-[state=unchecked]:bg-gray-50",
        e
      ),
      ...t,
      checked: t.checked,
      "data-state": t.checked === "indeterminate" ? "indeterminate" : t.checked ? "checked" : "unchecked",
      children: /* @__PURE__ */ p(
        ku,
        {
          className: F("flex items-center justify-center text-current"),
          forceMount: t.checked === "indeterminate" ? !0 : void 0,
          children: t.checked === "indeterminate" ? /* @__PURE__ */ p(Pe, { name: "check_indeterminate_small", size: 22 }) : /* @__PURE__ */ p(Pe, { name: "check", size: 22 })
        }
      )
    }
  )
);
Oo.displayName = "Checkbox";
const Qv = en("flex items-center", {
  variants: {
    hasDescription: {
      true: "flex-col items-start gap-2",
      false: "gap-2"
    }
  },
  defaultVariants: {
    hasDescription: !1
  }
}), Jv = re(
  ({ className: e, label: t, description: n, checkboxProps: r, hasDescription: o, ...i }, s) => {
    const a = !!n, u = () => {
      if (r != null && r.onCheckedChange && r.checked !== "indeterminate") {
        const l = r.checked !== !0;
        r.onCheckedChange(l);
      }
    };
    return /* @__PURE__ */ V("div", { ref: s, className: F(Qv({ hasDescription: a, className: e })), ...i, children: [
      /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ p(Oo, { ...r }),
        /* @__PURE__ */ p("span", { className: "typography-ui-15m cursor-pointer text-gray-900", onClick: u, children: t })
      ] }),
      n && /* @__PURE__ */ p("div", { className: "pl-[30px]", children: /* @__PURE__ */ p("span", { className: "typography-ui-13r text-gray-400", children: n }) })
    ] });
  }
);
Jv.displayName = "CheckItem";
const Mo = re(
  ({ className: e, checked: t, disabled: n, onClick: r, ...o }, i) => /* @__PURE__ */ p(
    "button",
    {
      ref: i,
      type: "button",
      className: F(
        "!duration-75 relative h-[22px] w-[22px] rounded-full border-2 border-solid transition-[border-width,border-color,background-color]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2",
        "focus:outline-none",
        t ? n ? "border-[5px] border-gray-100 bg-white" : "border-[5px] border-primary-600 bg-white ring-primary-500" : n ? "border-gray-100 bg-gray-50" : "border-gray-100 bg-white hover:border-primary-500",
        n ? "cursor-not-allowed" : "cursor-pointer",
        e
      ),
      disabled: n,
      onClick: n ? void 0 : r,
      "data-state": t ? "checked" : "unchecked",
      "aria-checked": t,
      role: "radio",
      ...o
    }
  )
);
Mo.displayName = "RadioButton";
const gl = Pn(void 0);
function ey({ defaultValue: e, value: t, onChange: n, name: r, children: o, className: i }, s) {
  const [a, u] = Ee(e), l = {
    value: t !== void 0 ? t : a,
    onChange: (d) => {
      t === void 0 && u(d), n == null || n(d);
    },
    name: r
  };
  return /* @__PURE__ */ p(gl.Provider, { value: l, children: /* @__PURE__ */ p("div", { ref: s, className: F("flex flex-col gap-3", i), role: "radiogroup", children: o }) });
}
const ty = re(ey);
ty.displayName = "RadioGroup";
function ny({ value: e, children: t, className: n, disabled: r, description: o }, i) {
  const s = An(gl);
  if (!s)
    throw new Error("RadioItem must be used within a RadioGroup");
  const a = s.value === e;
  return /* @__PURE__ */ V("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ V("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ p(
        Mo,
        {
          ref: i,
          checked: a,
          disabled: r,
          onClick: () => !r && s.onChange(e),
          name: s.name,
          value: e,
          "aria-checked": a
        }
      ),
      t && /* @__PURE__ */ p(
        "label",
        {
          className: F(
            "typography-ui-15m cursor-pointer",
            r && "cursor-not-allowed text-gray-300",
            n
          ),
          onClick: () => !r && s.onChange(e),
          children: t
        }
      )
    ] }),
    o && /* @__PURE__ */ p("div", { className: "pl-[30px]", children: /* @__PURE__ */ p("span", { className: F("typography-ui-13r text-gray-400", r && "text-gray-300"), children: o }) })
  ] });
}
const ry = re(ny);
ry.displayName = "RadioItem";
const Xy = Cm, oy = re(({ className: e, helpText: t, children: n, selectedValue: r, ...o }, i) => {
  const s = r || n;
  return /* @__PURE__ */ V("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ V(
      ks,
      {
        ref: i,
        className: F(
          "group flex h-[50px] w-full items-center justify-between gap-[4px] rounded-lg bg-gray-10 px-4 py-[13px] transition-colors",
          "typography-ui-17m text-gray-300 focus:outline-none",
          r && "text-gray-700",
          "border-[1px] border-gray-100 border-solid disabled:cursor-not-allowed disabled:bg-gray-40 disabled:text-gray-200",
          e
        ),
        ...o,
        children: [
          /* @__PURE__ */ p("span", { className: "min-w-0 truncate", children: s }),
          /* @__PURE__ */ V("span", { className: "text-gray-700", children: [
            /* @__PURE__ */ p(
              Pe,
              {
                name: "keyboard_arrow_down",
                className: "h-5 w-5 group-data-[state=closed]:block group-data-[state=open]:hidden"
              }
            ),
            /* @__PURE__ */ p(
              Pe,
              {
                name: "keyboard_arrow_up",
                className: "h-5 w-5 group-data-[state=open]:block group-data-[state=closed]:hidden"
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ p(Do, { state: "default", text: t, showCharacterCounter: !1, className: "border-0 p-0" })
  ] });
});
oy.displayName = ks.displayName;
const qy = Sm, Zy = Ls, Qy = Tm, Jy = Rm, iy = re(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ V(
  js,
  {
    ref: o,
    className: F(
      "flex cursor-default select-none items-center gap-2 rounded-sm px-4 py-3 text-sm outline-none focus:bg-gray-20 data-[state=open]:bg-gray-20 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ p(Pe, { name: "chevron_right", className: "ml-auto" })
    ]
  }
));
iy.displayName = js.displayName;
const ay = re(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ks,
  {
    ref: n,
    className: F(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-[--radix-dropdown-menu-content-transform-origin] overflow-hidden rounded-md border bg-white p-1 shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ...t
  }
));
ay.displayName = Ks.displayName;
const sy = re(({ className: e, sideOffset: t = 8, align: n = "center", side: r = "bottom", ...o }, i) => /* @__PURE__ */ p(Ls, { children: /* @__PURE__ */ p(
  Fs,
  {
    ref: i,
    sideOffset: t,
    align: n,
    side: r,
    avoidCollisions: !0,
    collisionPadding: 8,
    className: F(
      "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] w-[var(--radix-dropdown-menu-trigger-width)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-white px-0 py-2 shadow-md",
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...o
  }
) }));
sy.displayName = Fs.displayName;
const cy = re(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p(
  Bs,
  {
    ref: r,
    className: F(
      "relative flex cursor-default select-none items-center gap-2 px-4 py-3 outline-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      "typography-ui-17m text-gray-600 hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50",
      t && "pl-8",
      e
    ),
    ...n
  }
));
cy.displayName = Bs.displayName;
const ly = re(({ className: e, children: t, checked: n, ...r }, o) => {
  const i = n === "indeterminate";
  return /* @__PURE__ */ V(
    Vs,
    {
      ref: o,
      className: F(
        "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        "typography-ui-17m text-gray-600",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ p("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ p(zs, { children: /* @__PURE__ */ p(
          Oo,
          {
            className: "h-[18px] w-[18px]",
            checked: i ? "indeterminate" : !0,
            onClick: (s) => {
              s.preventDefault(), s.stopPropagation();
            }
          }
        ) }) }),
        t
      ]
    }
  );
});
ly.displayName = Vs.displayName;
const uy = re(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ V(
  Us,
  {
    ref: r,
    className: F(
      "relative flex cursor-default select-none items-center py-3 pr-2 pl-8 outline-none transition-colors hover:bg-gray-20 focus:bg-gray-20 active:bg-gray-50 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "typography-ui-17m text-gray-600",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ p("span", { className: "absolute left-2 flex items-center justify-center", children: /* @__PURE__ */ p(zs, { children: /* @__PURE__ */ p(
        Mo,
        {
          checked: !0,
          className: "h-[18px] w-[18px]",
          onClick: (o) => {
            o.preventDefault(), o.stopPropagation();
          }
        }
      ) }) }),
      t
    ]
  }
));
uy.displayName = Us.displayName;
const dy = re(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ p(
  Ws,
  {
    ref: r,
    className: F("typography-ui-17sb px-4 py-3 text-gray-700", t && "pl-8", e),
    ...n
  }
));
dy.displayName = Ws.displayName;
const fy = re(({ className: e, ...t }, n) => /* @__PURE__ */ p(Hs, { ref: n, className: F("-mx-1 my-1 h-px bg-gray-100", e), ...t }));
fy.displayName = Hs.displayName;
const py = ({ className: e, ...t }) => /* @__PURE__ */ p("span", { className: F("ml-auto text-gray-400 text-xs tracking-widest", e), ...t });
py.displayName = "DropdownMenuShortcut";
const my = re(
  ({ className: e, checked: t, defaultChecked: n, disabled: r, onChange: o, ...i }, s) => {
    const [a, u] = Ee(n || !1), l = t !== void 0, d = l ? t : a, f = () => {
      r || (l || u(!a), o == null || o(!d));
    };
    return /* @__PURE__ */ p(
      "div",
      {
        ref: s,
        className: F(
          "relative h-[22px] w-[36px] rounded-[24px] p-[3px] transition-colors",
          d ? "bg-primary-600" : "bg-gray-100",
          r && "opacity-50",
          "cursor-pointer",
          e
        ),
        role: "switch",
        "aria-checked": d,
        tabIndex: r ? -1 : 0,
        onClick: f,
        onKeyDown: (m) => {
          (m.key === "Enter" || m.key === " ") && (m.preventDefault(), f());
        },
        ...i,
        children: /* @__PURE__ */ p(
          "div",
          {
            className: F(
              "h-[16px] w-[16px] rounded-full bg-white shadow-[0px_1px_2px_0px_rgba(0,0,0,0.04)] transition-transform",
              d ? "translate-x-[14px]" : "translate-x-0"
            )
          }
        )
      }
    );
  }
);
my.displayName = "Toggle";
const eb = ({
  type: e,
  showInformationText: t = !1,
  title: n,
  description: r,
  informationText: o = "Information Text",
  children: i,
  buttons: s,
  open: a,
  onOpenChange: u,
  className: l
}) => {
  const d = () => {
    if (!s)
      return null;
    if (e === "single") {
      const f = s[0];
      return /* @__PURE__ */ p(
        wt,
        {
          size: "xl",
          buttonColor: f.variant === "primary" ? "primary" : "gray",
          buttonStyle: f.variant === "primary" ? "contained" : "outlined",
          onClick: f.onClick,
          disabled: f.disabled ?? !1,
          className: "w-full",
          children: f.label
        }
      );
    }
    return e === "horizontal" ? /* @__PURE__ */ p("div", { className: "flex gap-[12px]", children: s.map((f, m) => /* @__PURE__ */ p(
      wt,
      {
        size: "xl",
        buttonColor: f.variant === "primary" ? "primary" : "gray",
        buttonStyle: f.variant === "primary" ? "contained" : "outlined",
        onClick: f.onClick,
        disabled: f.disabled ?? !1,
        className: "flex-1",
        children: f.label
      },
      m
    )) }) : /* @__PURE__ */ p("div", { className: "flex flex-col gap-[12px]", children: s.map((f, m) => /* @__PURE__ */ p(
      wt,
      {
        size: "xl",
        buttonColor: f.variant === "primary" ? "primary" : "gray",
        buttonStyle: f.variant === "primary" ? "contained" : "outlined",
        onClick: f.onClick,
        className: "w-full",
        disabled: f.disabled ?? !1,
        children: f.label
      },
      m
    )) });
  };
  return /* @__PURE__ */ p(Ft.Root, { open: a, onOpenChange: u, children: /* @__PURE__ */ V(Ft.Portal, { children: [
    /* @__PURE__ */ p(Ft.Overlay, { className: "fixed inset-0 z-[9999] bg-dimmed-80" }),
    /* @__PURE__ */ p(Ft.Title, {}),
    /* @__PURE__ */ V(
      Ft.Content,
      {
        className: F(
          "fixed right-0 bottom-0 left-0 z-[9999] mx-auto",
          "rounded-t-2xl bg-white",
          "flex flex-col gap-[32px]",
          "w-full min-w-[360px] max-w-[480px]",
          l
        ),
        style: { margin: "0 auto" },
        children: [
          /* @__PURE__ */ V("div", { className: "flex flex-col gap-[20px] px-[20px] pt-[24px] pb-0", children: [
            /* @__PURE__ */ V("div", { className: "flex flex-col gap-[8px] px-[4px]", children: [
              /* @__PURE__ */ p("h2", { className: "typography-ui-22sb whitespace-pre-line text-gray-800", children: n }),
              r && /* @__PURE__ */ p("p", { className: "typography-ui-15r text-gray-600", children: r })
            ] }),
            i && /* @__PURE__ */ p("div", { className: "px-[4px]", children: i }),
            t && /* @__PURE__ */ p("div", { className: "px-[4px]", children: /* @__PURE__ */ p(ul, { children: o }) })
          ] }),
          s && /* @__PURE__ */ p("div", { className: "px-[20px] pb-[24px]", children: d() })
        ]
      }
    )
  ] }) });
}, tb = ({
  type: e,
  title: t,
  description: n,
  children: r,
  buttons: o,
  open: i,
  className: s,
  onOpenChange: a
}) => {
  const u = () => {
    if (!o)
      return null;
    if (e === "single") {
      const l = o[0];
      return /* @__PURE__ */ p(
        wt,
        {
          size: "xl",
          buttonColor: l.buttonColor,
          buttonStyle: l.buttonStyle,
          onClick: l.onClick || (() => a == null ? void 0 : a(!1)),
          className: "w-full",
          children: l.label
        }
      );
    }
    return /* @__PURE__ */ p("div", { className: "flex gap-[8px]", children: o.map((l, d) => /* @__PURE__ */ p(
      wt,
      {
        size: "xl",
        buttonColor: l.buttonColor,
        buttonStyle: l.buttonStyle,
        onClick: l.onClick || (() => a == null ? void 0 : a(!1)),
        className: "flex-1",
        children: l.label
      },
      d
    )) });
  };
  return /* @__PURE__ */ p(iv, { open: i, children: /* @__PURE__ */ V(av, { children: [
    /* @__PURE__ */ p(sv, { className: "fixed inset-0 z-[9999] bg-dimmed-40" }),
    /* @__PURE__ */ V(
      cv,
      {
        className: F(
          "-translate-x-1/2 -translate-y-1/2 fixed top-1/2 left-1/2 z-[9999] transform",
          "rounded-[16px] bg-white shadow-[0px_8px_16px_0px_rgba(0,0,0,0.16)]",
          "flex flex-col gap-[24px] whitespace-pre-wrap p-[24px]",
          "w-full min-w-[296px] max-w-[296px]",
          s
        ),
        children: [
          /* @__PURE__ */ V("div", { className: "flex flex-col gap-[8px]", children: [
            /* @__PURE__ */ p(lv, { className: "typography-ui-20sb break-words text-gray-800", children: t }),
            n && /* @__PURE__ */ p(uv, { className: "typography-ui-15r break-words text-gray-600", children: n }),
            r && /* @__PURE__ */ p("div", { className: "px-[4px]", children: r })
          ] }),
          o && /* @__PURE__ */ p("div", { children: u() })
        ]
      }
    )
  ] }) });
}, gy = 1, hy = 3e3, hl = 300;
let ur = 0;
const vy = () => (ur = (ur + 1) % Number.MAX_SAFE_INTEGER, ur.toString()), vl = Pn(null), dr = /* @__PURE__ */ new Map(), fr = (e, t) => {
  if (dr.has(e))
    return;
  const n = setTimeout(() => {
    dr.delete(e), t({
      type: "REMOVE_TOAST",
      toastId: e
    });
  }, hl);
  dr.set(e, n);
}, yy = (e, t) => {
  switch (t.type) {
    case "ADD_TOAST":
      return {
        ...e,
        toasts: [t.toast, ...e.toasts].slice(0, gy)
      };
    case "UPDATE_TOAST":
      return {
        ...e,
        toasts: e.toasts.map((n) => n.id === t.toast.id ? { ...n, ...t.toast } : n)
      };
    case "DISMISS_TOAST": {
      const { toastId: n } = t;
      return {
        ...e,
        toasts: e.toasts.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_TOAST":
      return t.toastId === void 0 ? {
        ...e,
        toasts: []
      } : {
        ...e,
        toasts: e.toasts.filter((n) => n.id !== t.toastId)
      };
  }
}, by = (e, t) => {
  const n = Vt((o) => {
    const i = vy(), s = (u) => e({
      type: "UPDATE_TOAST",
      toast: { ...u, id: i }
    }), a = () => {
      e({ type: "DISMISS_TOAST", toastId: i }), fr(i, e);
    };
    return e({
      type: "ADD_TOAST",
      toast: {
        ...o,
        id: i,
        open: !0,
        duration: o.duration ?? hy,
        direction: o.direction ?? "top",
        onOpenChange: (u) => {
          u || a();
        }
      }
    }), {
      id: i,
      dismiss: a,
      update: s
    };
  }, []), r = Vt(
    (o) => {
      e({ type: "DISMISS_TOAST", toastId: o }), o ? fr(o, e) : t.toasts.forEach((i) => {
        fr(i.id, e);
      });
    },
    [t.toasts]
  );
  return { toast: n, dismiss: r };
}, wy = () => {
  const e = An(vl);
  if (!e)
    throw new Error("useToast must be used within a ToastProvider");
  return e;
}, xy = cl, _r = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p(No, { ref: n, className: F("fixed z-[350] flex max-h-screen w-auto", e), ...t })
);
_r.displayName = "ToastViewport";
const Ey = en(
  F(
    "group pointer-events-auto relative flex items-center justify-center whitespace-pre",
    "rounded-[8px] border bg-white px-[20px] py-[13px] shadow-lg",
    "sm:gap-3 sm:rounded-[8px] sm:px-[20px] sm:py-[13px]",
    "w-max max-w-[320px]",
    // 기본 transition 설정
    "transition-all duration-300 ease-out"
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 px-[20px] py-[13px] text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), $r = c.forwardRef(
  ({ className: e, variant: t, direction: n, style: r, open: o, duration: i = 3e3, ...s }, a) => {
    const [u, l] = c.useState(!1), [d, f] = c.useState(o);
    c.useEffect(() => {
      if (o) {
        f(!0);
        const v = setTimeout(() => l(!0), 10);
        return () => clearTimeout(v);
      } else {
        l(!1);
        const v = setTimeout(() => {
          f(!1);
        }, hl);
        return () => clearTimeout(v);
      }
    }, [o]);
    const m = c.useMemo(() => ({
      transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
      transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
      opacity: u ? 1 : 0,
      ...r
    }), [u, n, r]);
    return d ? /* @__PURE__ */ p(
      To,
      {
        ref: a,
        className: F(Ey({ variant: t, direction: n }), e),
        style: m,
        open: !0,
        duration: i,
        forceMount: !0,
        "data-direction": n,
        ...s
      }
    ) : null;
  }
);
$r.displayName = "ToastRoot";
const Cy = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  ll,
  {
    ref: n,
    className: F(
      "inline-flex h-7 shrink-0 items-center justify-center rounded-[8px]",
      "border border-gray-200 bg-transparent px-2",
      "transition-colors hover:bg-gray-50",
      "focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2",
      "disabled:pointer-events-none disabled:opacity-50",
      "sm:h-8 sm:rounded-[8px] sm:px-3 ",
      e
    ),
    ...t
  }
));
Cy.displayName = "ToastAction";
const Sy = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(Po, { ref: n, className: F("leading-none tracking-tight", e), ...t }));
Sy.displayName = "ToastTitle";
const kr = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ao,
  {
    ref: n,
    className: F("typography-ui-15r text-center leading-relaxed", e),
    ...t
  }
));
kr.displayName = "ToastDescription";
const Ry = ({ children: e }) => {
  const [t, n] = Li(yy, { toasts: [] }), { toast: r, dismiss: o } = by(n, t), i = Ut(
    () => ({
      toasts: t.toasts,
      toast: r,
      dismiss: o
    }),
    [t.toasts, r, o]
  );
  return /* @__PURE__ */ p(vl.Provider, { value: i, children: e });
}, Ty = () => {
  const { toasts: e } = wy(), [t, n] = Ee(!1);
  be(() => {
    n(!0);
  }, []);
  const r = e.filter((s) => s.direction === "top"), o = e.filter((s) => s.direction === "bottom");
  if (!t)
    return null;
  const i = /* @__PURE__ */ V(xy, { children: [
    r.map(function({ id: s, text: a, ...u }) {
      return /* @__PURE__ */ p($r, { ...u, children: /* @__PURE__ */ p("div", { className: "grid gap-1", children: a && /* @__PURE__ */ p(kr, { children: a }) }) }, s);
    }),
    r.length > 0 && /* @__PURE__ */ p(_r, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    o.map(function({ id: s, text: a, ...u }) {
      return /* @__PURE__ */ p($r, { ...u, children: /* @__PURE__ */ p("div", { className: "grid gap-1", children: a && /* @__PURE__ */ p(kr, { children: a }) }) }, s);
    }),
    o.length > 0 && /* @__PURE__ */ p(_r, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? Hr(i, document.body) : i;
}, nb = ({ children: e }) => /* @__PURE__ */ V(Ry, { children: [
  e,
  /* @__PURE__ */ p(Ty, {})
] }), Ny = 1, Lr = 6e3, Py = 300;
let pr = 0;
const Ay = () => (pr = (pr + 1) % Number.MAX_SAFE_INTEGER, pr.toString()), yl = Pn(null), mr = /* @__PURE__ */ new Map(), gr = (e, t) => {
  if (mr.has(e))
    return;
  const n = setTimeout(() => {
    mr.delete(e), t({
      type: "REMOVE_SNACKBAR",
      snackbarId: e
    });
  }, Lr);
  mr.set(e, n);
}, Dy = (e, t) => {
  switch (t.type) {
    case "ADD_SNACKBAR":
      return {
        ...e,
        snackbars: [t.snackbar, ...e.snackbars].slice(0, Ny)
      };
    case "UPDATE_SNACKBAR":
      return {
        ...e,
        snackbars: e.snackbars.map((n) => n.id === t.snackbar.id ? { ...n, ...t.snackbar } : n)
      };
    case "DISMISS_SNACKBAR": {
      const { snackbarId: n } = t;
      return {
        ...e,
        snackbars: e.snackbars.map(
          (r) => r.id === n || n === void 0 ? {
            ...r,
            open: !1
          } : r
        )
      };
    }
    case "REMOVE_SNACKBAR":
      return t.snackbarId === void 0 ? {
        ...e,
        snackbars: []
      } : {
        ...e,
        snackbars: e.snackbars.filter((n) => n.id !== t.snackbarId)
      };
  }
}, Oy = (e, t) => {
  const n = Vt((o) => {
    const i = Ay(), s = (l) => e({
      type: "UPDATE_SNACKBAR",
      snackbar: { ...l, id: i }
    }), a = () => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: i }), gr(i, e);
    };
    e({
      type: "ADD_SNACKBAR",
      snackbar: {
        ...o,
        id: i,
        open: !0,
        duration: o.duration ?? Lr,
        direction: o.direction ?? "top",
        onOpenChange: (l) => {
          l || a();
        }
      }
    });
    const u = o.duration ?? Lr;
    return setTimeout(() => {
      a();
    }, u), {
      id: i,
      dismiss: a,
      update: s
    };
  }, []), r = Vt(
    (o) => {
      e({ type: "DISMISS_SNACKBAR", snackbarId: o }), o ? gr(o, e) : t.snackbars.forEach((i) => {
        gr(i.id, e);
      });
    },
    [t.snackbars]
  );
  return { snackbar: n, dismiss: r };
}, My = () => {
  const e = An(yl);
  if (!e)
    throw new Error("useSnackbar must be used within a SnackbarProvider");
  return e;
}, Iy = cl, Fr = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ p(No, { ref: n, className: F("fixed z-[100] flex max-h-screen w-auto", e), ...t })
);
Fr.displayName = "SnackbarViewport";
const _y = en(
  F(
    "group pointer-events-auto relative flex w-full items-center justify-center gap-2",
    "overflow-hidden rounded-[8px] border bg-white shadow-lg transition-all hover:cursor-auto",
    "min-w-[320px] max-w-full sm:gap-3 sm:rounded-[8px] "
  ),
  {
    variants: {
      variant: {
        default: "border-gray-200 bg-gray-800 text-white"
      },
      direction: {
        top: "",
        bottom: ""
      }
    },
    defaultVariants: {
      variant: "default",
      direction: "top"
    }
  }
), Wr = c.forwardRef(({ className: e, variant: t, direction: n, style: r, open: o, duration: i = 3e3, ...s }, a) => {
  const [u, l] = c.useState(!1), [d, f] = c.useState(o);
  c.useEffect(() => {
    if (o) {
      f(!0);
      const v = setTimeout(() => l(!0), 10);
      return () => clearTimeout(v);
    } else {
      l(!1);
      const v = setTimeout(() => {
        f(!1);
      }, Py);
      return () => clearTimeout(v);
    }
  }, [o]);
  const m = c.useMemo(() => ({
    transition: "transform 0.3s ease-out, opacity 0.3s ease-out",
    transform: u ? "translateY(0)" : n === "bottom" ? "translateY(100%)" : "translateY(-100%)",
    opacity: u ? 1 : 0,
    ...r
  }), [u, n, r]);
  return d ? /* @__PURE__ */ p(
    To,
    {
      ref: a,
      className: F(_y({ variant: t, direction: n }), "min-w-[320px] max-w-full justify-between", e),
      style: m,
      open: !0,
      duration: i,
      forceMount: !0,
      "data-direction": n,
      ...s
    }
  ) : null;
});
Wr.displayName = "SnackbarRoot";
const Br = c.forwardRef(({ buttonText: e, buttonAction: t, onDismiss: n, ...r }, o) => {
  const i = () => {
    t(), n == null || n();
  };
  return /* @__PURE__ */ p(
    "button",
    {
      ref: o,
      className: F("typography-ui-15sb text-primary-700", "h-full px-[20px] py-[13px]"),
      onClick: i,
      type: "button",
      ...r,
      children: e
    }
  );
});
Br.displayName = "SnackbarAction";
const Vr = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Po,
  {
    ref: n,
    className: F("typography-ui-15sb text-white", "whitespace-nowrap", e),
    ...t
  }
));
Vr.displayName = "SnackbarTitle";
const Ur = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ p(
  Ao,
  {
    ref: n,
    className: F("typography-ui-15r text-gray-200", "whitespace-nowrap", e),
    ...t
  }
));
Ur.displayName = "SnackbarDescription";
const $i = ({ children: e }) => /* @__PURE__ */ p("div", { className: "grid py-[13px] pl-[20px]", children: e }), $y = ({ children: e }) => {
  const [t, n] = Li(Dy, { snackbars: [] }), { snackbar: r, dismiss: o } = Oy(n, t), i = Ut(
    () => ({
      snackbars: t.snackbars,
      snackbar: r,
      dismiss: o
    }),
    [t.snackbars, r, o]
  );
  return /* @__PURE__ */ p(yl.Provider, { value: i, children: e });
}, ky = () => {
  const { snackbars: e, dismiss: t } = My(), [n, r] = Ee(!1);
  be(() => {
    r(!0);
  }, []);
  const o = e.filter((a) => a.direction === "top"), i = e.filter((a) => a.direction === "bottom");
  if (!n)
    return null;
  const s = /* @__PURE__ */ V(Iy, { children: [
    o.map(function({ id: a, title: u, description: l, buttonAction: d, buttonText: f, ...m }) {
      return /* @__PURE__ */ V(Wr, { ...m, children: [
        /* @__PURE__ */ V($i, { children: [
          u && /* @__PURE__ */ p(Vr, { children: u }),
          l && /* @__PURE__ */ p(Ur, { children: l })
        ] }),
        d && f && /* @__PURE__ */ p(Br, { buttonText: f, buttonAction: d, onDismiss: () => t(a) })
      ] }, a);
    }),
    o.length > 0 && /* @__PURE__ */ p(Fr, { className: "-translate-x-1/2 top-[16px] left-1/2 transform sm:top-4" }),
    i.map(function({ id: a, title: u, description: l, buttonAction: d, buttonText: f, ...m }) {
      return /* @__PURE__ */ V(Wr, { ...m, children: [
        /* @__PURE__ */ V($i, { children: [
          u && /* @__PURE__ */ p(Vr, { children: u }),
          l && /* @__PURE__ */ p(Ur, { children: l })
        ] }),
        d && f && /* @__PURE__ */ p(Br, { buttonText: f, buttonAction: d, onDismiss: () => t(a) })
      ] }, a);
    }),
    i.length > 0 && /* @__PURE__ */ p(Fr, { className: "-translate-x-1/2 top-auto bottom-[16px] left-1/2 transform sm:top-auto sm:bottom-4" })
  ] });
  return typeof window < "u" ? Hr(s, document.body) : s;
}, rb = ({ children: e }) => /* @__PURE__ */ V($y, { children: [
  e,
  /* @__PURE__ */ p(ky, {})
] }), Ly = en(
  "typography-ui-15m inline-flex h-6 cursor-pointer items-center justify-center whitespace-nowrap px-0 leading-[22px] underline-offset-[2px] transition-all duration-200 focus-visible:outline-none disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 ",
  {
    variants: {
      color: {
        primary: "text-primary-600 hover:text-primary-700 active:text-primary-800",
        red: "text-red-500 hover:text-red-600 active:text-red-700",
        gray: "text-gray-600 hover:text-gray-700 active:text-gray-800"
      },
      state: {
        default: "opacity-100",
        hover: "opacity-80",
        pressed: "opacity-60",
        dimmed: "opacity-40"
      }
    },
    defaultVariants: {
      color: "primary",
      state: "default"
    }
  }
), Fy = c.forwardRef(
  ({ className: e, color: t, state: n, underline: r = !0, asChild: o = !1, ...i }, s) => /* @__PURE__ */ p(
    o ? Kr : "button",
    {
      className: F(Ly({ color: t, state: n, className: e })),
      ref: s,
      style: { textDecoration: r ? "underline" : "none" },
      ...i
    }
  )
);
Fy.displayName = "TextButton";
export {
  lu as ActionSheet,
  Hv as ActionSheetContent,
  Fi as ActionSheetContext,
  jv as ActionSheetItem,
  dl as ActionSheetItemLabel,
  Gi as ActionSheetTrigger,
  tb as Alert,
  fl as AreaContainer,
  eb as BottomSheet,
  wt as Button,
  Jv as CheckItem,
  Oo as Checkbox,
  Xy as DropdownMenu,
  ly as DropdownMenuCheckboxItem,
  sy as DropdownMenuContent,
  qy as DropdownMenuGroup,
  cy as DropdownMenuItem,
  dy as DropdownMenuLabel,
  Zy as DropdownMenuPortal,
  Jy as DropdownMenuRadioGroup,
  uy as DropdownMenuRadioItem,
  fy as DropdownMenuSeparator,
  py as DropdownMenuShortcut,
  Qy as DropdownMenuSub,
  ay as DropdownMenuSubContent,
  iy as DropdownMenuSubTrigger,
  oy as DropdownMenuTrigger,
  Do as HelpTextArea,
  ul as InformationText,
  ml as InputContainer,
  Mo as RadioButton,
  ty as RadioGroup,
  ry as RadioItem,
  Py as SNACKBAR_ANIMATION_DURATION,
  Wr as Snackbar,
  Br as SnackbarAction,
  rb as SnackbarContainer,
  $i as SnackbarContentWrapper,
  Ur as SnackbarDescription,
  Vr as SnackbarTitle,
  Fr as SnackbarViewport,
  hl as TOAST_ANIMATION_DURATION,
  qv as TextArea,
  Fy as TextButton,
  Zv as TextInput,
  $r as Toast,
  Cy as ToastAction,
  nb as ToastContainer,
  kr as ToastDescription,
  Ry as ToastProvider,
  Sy as ToastTitle,
  _r as ToastViewport,
  my as Toggle,
  Kv as buttonVariants,
  Ly as textButtonVariants,
  cu as useActionSheet,
  Wi as useActionSheetContext,
  My as useSnackbar,
  wy as useToast
};
//# sourceMappingURL=index.es.js.map
